/* eslint-disable max-lines */
/**
 * Strings em português brasileiro.
 * REGRA: toda string exposta ao usuário vive aqui.
 * Nunca escreva texto de UI hardcoded em componentes.
 * Nunca use nomes técnicos (LLM, modelo, prompt, IA) neste arquivo. // ux-neutrality:allow doc-comment
 *
 * Organização das chaves:
 *   productName       -> nome do produto exposto na UI
 *   nav.*             -> rótulos de navegação (header, sidebar, footer)
 *   common.*          -> botões e mensagens reaproveitadas em muitos lugares
 *   errors.*          -> mensagens de erro padronizadas (HTTP e validação)
 *   routes.*          -> título de cada rota placeholder do shell
 *   shell.*           -> rótulos do shell visual (toggles, brand, rodapé)
 *   placeholder.*     -> textos das páginas que ainda são esboço
 *   login.*           -> formulário e mensagens da tela /login
 *   signup.*          -> formulário e mensagens da tela /signup
 *   perfil.*          -> formulário e mensagens da tela /perfil
 *   apiKeys.*         -> tela /configuracoes/api-keys (CRUD de chaves)
 *   upload.*          -> formulário da tela /upload (par de assinaturas)
 *   analise.*         -> tela /analise/:id (polling + resultado pericial)
 *   criterio.*        -> rótulos da taxonomia ACE-V (nomes + status + peso + impacto)
 *   lr.*              -> classificação verbal ENFSI do Likelihood Ratio
 *   fraude.*          -> tipologias de fraude (forensic-methodology §4)
 *   wizard.*          -> wizard de upload de documentos (E8.F3)
 *   extraction.*      -> revisão de extração de assinaturas (E8.F4)
 *   portal.*          -> Portal do Cliente (E50) — vive em pt-BR.portal.ts
 *   casoDoPortal.*    -> o caso do portal em abas (E148) — vive em pt-BR.caso.ts
 *   conversaDoCaso.*  -> a conversa do caso com o cliente (E149) — vive em pt-BR.conversa.ts
 *   avisosDaEquipe.*  -> os avisos da equipe (E150) — vive em pt-BR.avisos.ts
 *   abertura.*        -> abertura do caso por serviço (E126) — vive em pt-BR.abertura.ts
 *   historicoDoCaso.* -> histórico do caso (E137) — vive em pt-BR.historico.ts
 *   integridadeDoArquivo.* -> integridade do arquivo emitido (E138) — vive em pt-BR.integridade.ts
 *   fichaDaLeitura.*  -> informações e limites da leitura (E139) — vive em pt-BR.ficha.ts
 *   conferenciaDaLeitura.* -> conferência da leitura (E140) — vive em pt-BR.conferencia.ts
 *   conferenciaDasEtapas.* -> conferência das etapas (E147) — vive em pt-BR.etapas.ts
 *   acessoControlado.* -> acesso pelo QR e acesso recusado (E145) — vive em pt-BR.acesso.ts
 *   recusaDoArquivo.* -> o arquivo que o envio não recebeu e o motivo (E146) — vive em pt-BR.recusa.ts
 *   recursosDoArquivo.* -> os recursos automáticos do arquivo recebido (E146.F2) — idem
 *   formalizacao.*    -> perfil e regras do exame de formalização (E151) — vive em pt-BR.formalizacao.ts
 *   formalizacaoAvaliacao.* -> formalização preparada para revisão (E152) — vive em pt-BR.formalizacaoAvaliacao.ts
 *   conferenciaNoPortal.* -> a conferência no portal da plataforma (E172.F7) — vive em pt-BR.conferenciaNoPortal.ts
 *   resultadoAuditado.* -> a página do resultado auditado (E153) — vive em pt-BR.resultado.ts
 *   certificadosECarimbo.* -> a tela "Certificados e carimbo" (E157) — vive em pt-BR.certificados.ts
 *   orientacoes.* -> as "Orientações para o jurídico" (E158) — vive em pt-BR.orientacoes.ts
 *   conferenciaDasSaidas.* -> "Conferir laudo e orientações" (E159) — vive em pt-BR.saidas.ts
 *   correcaoDoRascunho.* -> os trechos, as ações e as recusas da edição (E160) — vive em pt-BR.correcao.ts
 *   editorManual.* -> a tela "Editor manual" (E171) — vive em pt-BR.editor.ts
 *   preparacaoDoPacote.* -> o card "Preparação do pacote" (E168.F7) — vive em pt-BR.pacote.ts
 */
import { ptBRAbertura } from './pt-BR.abertura';
import { ptBRCadastroSemEspera } from './pt-BR.cadastro';
import { ptBRAcesso } from './pt-BR.acesso';
import { ptBRAvisosDaEquipe } from './pt-BR.avisos';
import { ptBRArquivosPendentes } from './pt-BR.arquivosPendentes';
import { ptBRCaso } from './pt-BR.caso';
import { ptBRAssinaturaIcp } from './pt-BR.assinaturaIcp';
import { ptBRCertificados } from './pt-BR.certificados';
import { ptBRCorrecao } from './pt-BR.correcao';
import { ptBREditor } from './pt-BR.editor';
import { ptBRRecursos, ptBRRecusa } from './pt-BR.recusa';
import { ptBRConferencia } from './pt-BR.conferencia';
import { ptBRConversa } from './pt-BR.conversa';
import { ptBREtapas } from './pt-BR.etapas';
import { ptBRConferenciaNoPortal } from './pt-BR.conferenciaNoPortal';
import { ptBRFicha } from './pt-BR.ficha';
import { ptBRFormalizacao } from './pt-BR.formalizacao';
import { ptBRFormalizacaoAvaliacao } from './pt-BR.formalizacaoAvaliacao';
import { ptBROrientacoes } from './pt-BR.orientacoes';
import { ptBRPacote } from './pt-BR.pacote';
import { ptBRMesaUnica } from './pt-BR.mesaUnica';
import { ptBRDocumentos } from './pt-BR.documentos';
import { ptBRDocumentoDaMesa } from './pt-BR.documentoDaMesa';
import { ptBRPainelDoDado } from './pt-BR.painelDoDado';
import { ptBRRecorteDoDocumento } from './pt-BR.recorte';
import { ptBRExclusaoNaMesa } from './pt-BR.exclusaoNaMesa';
import { ptBRConferenciaFinal } from './pt-BR.conferenciaFinal';
import { ptBRHistorico } from './pt-BR.historico';
import { ptBRIntegridade } from './pt-BR.integridade';
import { ptBRPortal } from './pt-BR.portal';
import { ptBRResultado } from './pt-BR.resultado';
import { ptBRSaidas } from './pt-BR.saidas';
import { ptBRFaltasDaIdentificacao } from './pt-BR.identificacao';

export const ptBR = {
  // E74.F1 (ADR-0075 §9): o nome deixou de afirmar a modalidade — o sistema
  // também analisa assinatura eletrônica. O laudo grafotécnico segue com o nome dele.
  productName: 'Sistema de análise de assinaturas',

  // Portal do Cliente (E50.F2): namespace próprio, único lugar da marca
  // SignCheck em UI (docs/domain/naming-conventions.md).
  portal: ptBRPortal,

  // E148 (GUS-109, ADR-0102 §2): o caso do portal em abas — andamento, documentos e relatórios.
  casoDoPortal: ptBRCaso,
  // E193.F1 (GUS-259): o que falta ao caso digital aguardando arquivos.
  arquivosPendentes: ptBRArquivosPendentes,

  // E149 (GUS-149, ADR-0102 §3): a conversa do caso, no portal e na área da equipe.
  conversaDoCaso: ptBRConversa,

  // E150 (GUS-150, ADR-0102 §4): os avisos da equipe, do que o cliente registrou na conversa.
  avisosDaEquipe: ptBRAvisosDaEquipe,

  // E126 (GUS-105, ADR-0088): a abertura por serviço, a mesma no portal e na área do perito.
  // E189.F2 (ADR-0138): `abertura.cadastro`, o "Enviar e seguir" e os cadastros em andamento.
  // E206.F1 (GUS-296 item 1): a falha da conclusão diz o que houve e o que fazer; o envio não se
  // perde (aqui, e não em pt-BR.abertura.ts, que está no teto de linhas).
  abertura: {
    ...ptBRAbertura,
    cadastro: ptBRCadastroSemEspera,
    falhaDaConclusao: {
      servidor:
        'O envio não foi concluído por uma falha no servidor. Nada se perdeu: os arquivos e as respostas continuam neste rascunho. Tente de novo em alguns minutos; se a falha se repetir, avise a equipe com o código do caso.',
      rede: 'Sem conexão com o servidor: o envio não foi concluído e continua neste rascunho. Confira a conexão e tente de novo.',
    },
  },
  // E177.F1.C03 (GUS-253 item 3): a conclusão recusada pede só o que falta da identificação.
  faltasDaIdentificacao: ptBRFaltasDaIdentificacao,

  // E137.F3 (GUS-160, ADR-0093): o histórico do caso, só da equipe.
  historicoDoCaso: ptBRHistorico,

  // E138.F3 (GUS-21, ADR-0094): o código registrado da versão emitida e a conferência do arquivo.
  integridadeDoArquivo: ptBRIntegridade,

  // E145.F2 (GUS-181, ADR-0099): o acesso pelo QR da versão emitida e o acesso recusado.
  acessoControlado: ptBRAcesso,
  recusaDoArquivo: ptBRRecusa,
  // E146.F2 (GUS-179, ADR-0100 §2.7): o arquivo recebido com recursos automáticos.
  recursosDoArquivo: ptBRRecursos,

  // E139.F3 (GUS-142, ADR-0095): a ficha da leitura na pré-análise eletrônica.
  fichaDaLeitura: ptBRFicha,

  // E157.F3 (GUS-157, ADR-0107 §2.7): a tela "Certificados e carimbo", só da equipe.
  assinaturaIcp: ptBRAssinaturaIcp,
  certificadosECarimbo: ptBRCertificados,
  orientacoes: ptBROrientacoes,
  // E159.F3 (GUS-153, ADR-0109 §2.7): "Conferir laudo e orientações", só da equipe.
  conferenciaDasSaidas: ptBRSaidas,
  // E160.F3 (GUS-145, ADR-0110 §2.4): "Correção privada do rascunho", só da equipe.
  correcaoDoRascunho: ptBRCorrecao,
  // E171.F3 (GUS-145 e GUS-46, ADR-0122 §2.7): o "Editor manual" do exame e do risco.
  editorManual: ptBREditor,

  // E140.F3 (GUS-143, ADR-0096): a conferência da leitura na pré-análise eletrônica.
  conferenciaDaLeitura: ptBRConferencia,
  conferenciaDasEtapas: ptBREtapas,

  // E151.F2 (GUS-174, ADR-0103 §4.2): o perfil e as regras do exame na mesa eletrônica.
  formalizacao: ptBRFormalizacao,

  // E152.F3 (GUS-175, ADR-0103 §5.9): a formalização preparada para revisão na mesa eletrônica.
  formalizacaoAvaliacao: ptBRFormalizacaoAvaliacao,
  // E172.F7.T03 (GUS-230 B1.3, ADR-0124 §1): a conferência no portal da plataforma na mesa.
  conferenciaNoPortal: ptBRConferenciaNoPortal,
  // E153.F3 (GUS-176, ADR-0104 §2.6): a página do resultado auditado, só da equipe.
  resultadoAuditado: ptBRResultado,
  // E168.F7 (GUS-180, ADR-0116 §9): o card "Preparação do pacote" na pré-análise e na mesa.
  preparacaoDoPacote: ptBRPacote,
  conferenciaFinal: ptBRConferenciaFinal,
  // E201.F1 (GUS-47, ADR-0144): a mesa única do caso eletrônico.
  mesaUnica: ptBRMesaUnica,
  documentosDoCaso: ptBRDocumentos,
  // E202.F1 (GUS-145, ADR-0145): o documento do exame no centro da mesa única.
  documentoDaMesa: ptBRDocumentoDaMesa,
  // E203.F2 (ADR-0146): o painel do dado que o clique no documento abre.
  painelDoDado: ptBRPainelDoDado,
  // E214.F1 (GUS-314): o recorte manual na aba Documentos.
  recorteDoDocumento: ptBRRecorteDoDocumento,
  exclusaoNaMesa: ptBRExclusaoNaMesa,

  nav: {
    home: 'Início',
    upload: 'Nova análise',
    config: 'Configurações',
    login: 'Entrar',
    logout: 'Sair',
    signup: 'Criar conta',
    skipToContent: 'Pular para o conteúdo principal',
    casos: 'Casos',
    novoCaso: 'Novo caso',
  },

  common: {
    loading: 'Carregando…',
    error: 'Ocorreu um erro. Tente novamente.',
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Avançar',
    close: 'Fechar',
    retry: 'Tentar novamente',
    empty: 'Nenhum item para mostrar.',
    acaoDestrutiva: 'Esta ação não pode ser desfeita.',
    // E200.F3 (GUS-220): o botão com o pedido em curso, para o leitor de tela.
    aguarde: 'Aguarde…',
  },
  // E200.F3 (GUS-220, ADR-0143 §4): a falha com saída — o que houve e por onde sair.
  falhaComSaida: {
    tentarDeNovo: 'Tentar de novo',
    voltarAoCaso: 'Voltar ao caso',
    voltarAosCasos: 'Voltar aos casos',
    revisarNaMesa: 'Revisar na mesa',
  },

  caseStatus: {
    rascunho: 'Rascunho',
    em_analise: 'Em análise',
    encerrado_triagem: 'Encerrado na triagem',
    // E72.F2 — os dois desfechos da triagem são estados distintos: só este tem
    // documento. O catálogo acompanha o `CaseStatus` do pill, sob pena de a
    // indexação por status voltar a ser parcial.
    encerrado_com_relatorio: 'Encerrado com relatório',
    indefinido: 'Situação não identificada',
    laudo_em_elaboracao: 'Laudo em elaboração',
    // E224.F1 (ADR-0151): a CCB concluída não é o laudo assinado; o rótulo diz o passo que falta.
    eletronica_concluida: 'Concluído · aguardando assinatura',
    // E193.F1 (GUS-259): o caso digital sem o kit completo, fora da análise.
    aguardando_arquivos: 'Aguardando arquivos',
    aguardando_revisao: 'Aguardando revisão',
    aguardando_revisor: 'Aguardando revisor',
    devolvido_pelo_revisor: 'Devolvido pelo revisor',
    concluido: 'Concluído',
    finalizado: 'Finalizado',
    arquivado: 'Arquivado',
    assinado: 'Assinado',
    // E224.F2: a equipe cancelou o caso, com motivo.
    cancelado: 'Cancelado',
  },

  // E166.F2.T04: a dica da regra única da senha nova, junto de todo campo que define senha.
  senhaForte: {
    regra: 'Mínimo de 8 caracteres, com uma letra maiúscula e um símbolo (como ! @ # -).',
  },

  errors: {
    generic: 'Não foi possível concluir a ação. Tente novamente.',
    networkOffline: 'Sem conexão com a internet. Verifique sua rede e tente novamente.',
    serviceUnavailable: 'O serviço de análise está temporariamente indisponível.',
    notFound: 'O conteúdo solicitado não foi encontrado.',
    unauthorized: 'Sua sessão expirou. Entre novamente.',
    forbidden: 'Você não tem permissão para acessar este conteúdo.',
    validation: 'Verifique os campos destacados antes de continuar.',
    invalidCredentials: 'E-mail ou senha incorretos. Verifique e tente novamente.',
    tooManyAttempts: 'Muitas tentativas seguidas. Aguarde alguns minutos e tente de novo.',
    emailAlreadyRegistered: 'Já existe uma conta com este e-mail. Acesse pela tela de entrada.',
    analysisImageInvalid:
      'Uma das imagens não é um arquivo PNG ou JPG válido. Confira os formatos aceitos.',
    analysisImageTooLarge: 'Uma das imagens passa do tamanho máximo (10 MB). Reduza o arquivo.',
    analysisNotFound: 'Análise não encontrada ou indisponível para o seu acesso.',
    analysisNoApiKey:
      'Configure a chave do provedor de análise no seu perfil antes de iniciar uma análise.',
  },

  sessionExpired: {
    title: 'Sessão expirada',
    body: 'Por segurança, você foi desconectado depois de um período sem atividade. Entre novamente para continuar de onde parou.',
    confirm: 'Entrar novamente',
    cancel: 'Sair',
  },

  errorPages: {
    notFound: {
      code: 'HTTP 404',
      title: 'Página não encontrada',
      body: 'O endereço acessado não existe ou foi movido. Confira o link ou volte ao início.',
      backCta: 'Voltar ao início',
    },
    forbidden: {
      code: 'HTTP 403',
      title: 'Acesso restrito',
      body: 'Você não tem permissão para visualizar este conteúdo. Se acredita ser engano, fale com o responsável pelo escritório.',
      backCta: 'Voltar ao início',
    },
    // E70.F1: o perfil não respondeu — não é recusa, é falha do momento.
    perfilIndisponivel: {
      title: 'Não foi possível confirmar seu acesso',
      body: 'A verificação do seu perfil não respondeu. Tente novamente em instantes.',
      retryCta: 'Tentar novamente',
    },
    serverError: {
      code: 'HTTP 500',
      title: 'Algo deu errado por aqui',
      body: 'Não conseguimos concluir a operação. Tente novamente em instantes; se persistir, registre o identificador abaixo no contato com o suporte.',
      backCta: 'Voltar ao início',
      retryCta: 'Tentar novamente',
      correlationLabel: 'Identificador da falha',
    },
  },

  home: {
    intro:
      'Análise pericial assistida de assinaturas com metodologia ACE-V e Razão de Verossimilhança (LR) ENFSI. Envie o par de assinaturas, receba o parecer estruturado com decomposição por critério e evidência visual.',
    ctaStart: 'Iniciar nova análise',
    featuresTitle: 'O que o sistema entrega',
    feature1Title: 'Processo ACE-V',
    feature1Body:
      'Análise, Comparação, Avaliação e Verificação aplicadas em cada par padrão–questionada.',
    feature2Title: 'LR ENFSI verbal',
    feature2Body:
      'Razão de Verossimilhança com classificação verbal padronizada — não é "genuína ou falsa".',
    feature3Title: 'Evidência visual',
    feature3Body:
      'Cada divergência é marcada na imagem com coordenadas e justificativa textual editáveis.',
  },

  homePanel: {
    greetingMorning: 'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening: 'Boa noite',
    greetingFallback: 'Olá',
    greetingTemplate:
      '{{greeting}}, {{name}}. Você tem {{ativos}} {{ativosLabel}} em análise e {{aguardando}} {{aguardandoLabel}} aguardando laudo.',
    casoSingular: 'caso',
    casoPlural: 'casos',
    summaryError: 'Não foi possível carregar o painel agora. Tente atualizar.',
    kpiCasosNoMes: 'Casos no mês',
    kpiTempoMedio: 'Tempo médio de análise',
    kpiLrAutoria: 'LR > 100 (autoria)',
    kpiLrHeteroautoria: 'LR < 0,01 (heteroaut.)',
    kpiUnavailableHint: 'Métrica disponível quando houver casos concluídos suficientes.',
    continuarTitle: 'Continuar trabalhando',
    continuarHint: 'Seus 3 casos editados mais recentes.',
    continuarEmpty: 'Nada em andamento. Comece um novo caso para ver atalhos por aqui.',
    prazosTitle: 'Prazos próximos',
    prazosHint: 'Casos com prazo nos próximos 7 dias.',
    prazosEmpty: 'Nenhum prazo nos próximos 7 dias.',
    prazoDaysAway: 'Faltam {{days}} dias',
    prazoTomorrow: 'Faltam 1 dia',
    prazoToday: 'Vence hoje',
    prazoOverdue: 'Atrasado',
    ctaPrimary: '+ Novo caso',
    ctaSecondary: 'Ver todos os casos',
    educationalToggle: 'Ver fundamentos forenses',
    openCaseLabel: 'Abrir caso {{code}}',
  },

  authShell: {
    brandTagline: 'Análise de assinaturas defensável em juízo',
    brandSubtitle:
      'Metodologia ACE-V, Razão de Verossimilhança ENFSI e evidência visual rastreável em cada laudo.',
    brandFooter: 'Versão 0.1 · Sistema de análise de assinaturas',
    heroEyebrow: 'Grafotécnica forense',
    heroTitle: 'Análise Forense',
    tagAcev: 'ACE-V',
    tagEnfsi: 'ENFSI LR',
    tagCadeia: 'Cadeia de custódia',
    accessKicker: 'Acesso restrito',
  },

  login: {
    pageTitle: 'Entrar',
    intro: 'Acesse com suas credenciais para iniciar uma análise.',
    emailLabel: 'E-mail',
    emailPlaceholder: 'voce@exemplo.com',
    passwordLabel: 'Senha',
    passwordPlaceholder: 'Sua senha de acesso',
    passwordShow: 'Mostrar senha',
    passwordHide: 'Ocultar senha',
    capsLockOn: 'Caps Lock ativo',
    rememberMe: 'Manter conectado neste dispositivo',
    resetSuccess: 'Senha redefinida. Entre com a sua nova senha.',
    forgotPassword: 'Esqueci minha senha',
    forgot: {
      title: 'Redefinir senha',
      body: 'Informe o e-mail da sua conta. Se houver um cadastro, enviaremos um link para criar uma nova senha.',
      emailLabel: 'E-mail',
      emailPlaceholder: 'voce@exemplo.com',
      submit: 'Enviar link',
      submitting: 'Enviando…',
      cancel: 'Cancelar',
      sentTitle: 'Verifique seu e-mail',
      sentBody:
        'Se houver uma conta com esse e-mail, enviamos um link para redefinir a senha. O link expira em pouco tempo.',
      sentConfirm: 'Entendi',
      errorNetwork: 'Não foi possível concluir agora. Verifique sua conexão e tente novamente.',
      errorTooMany: 'Muitos pedidos seguidos. Aguarde alguns minutos antes de pedir outro link.',
    },
    // Ajuste do owner (03/11, ADR-0149): quem abre o endereço do caso impresso no QR entra pelo
    // código de seis dígitos enviado ao e-mail da conta, sem senha.
    codigo: {
      intro: 'Informe o e-mail da sua conta. Enviaremos um código de acesso para ele.',
      submit: 'Enviar código',
      submitting: 'Enviando…',
      sentIntro: (email: string): string =>
        `Se ${email} tiver uma conta, enviamos para ele um código de 6 dígitos. O código vale por 10 minutos.`,
      codigoLabel: 'Código de acesso',
      codigoPlaceholder: '000000',
      entrar: 'Entrar',
      entrando: 'Entrando…',
      reenviar: 'Enviar outro código',
      reenviarEm: (segundos: number): string => `Enviar outro código em ${segundos} s`,
      reenviado: 'Enviamos um novo código. O anterior deixou de valer.',
      trocarEmail: 'Usar outro e-mail',
      usarSenha: 'Entrar com senha',
      usarCodigo: 'Receber um código por e-mail',
      errorInvalid: 'Código incorreto ou vencido. Confira o código no e-mail ou peça outro.',
      errorTooMany: 'Muitas tentativas seguidas. Aguarde alguns minutos e tente de novo.',
      errorNetwork: 'Não foi possível concluir agora. Verifique sua conexão e tente novamente.',
    },
    submit: 'Entrar',
    submitting: 'Entrando…',
    noAccount: 'Ainda não tem conta?',
    signupCta: 'Criar conta',
    footerVersion: 'Versão 0.1',
    footerLgpd: 'LGPD',
    footerSupport: 'Suporte',
  },

  resetPassword: {
    pageTitle: 'Criar nova senha',
    intro: 'Escolha uma nova senha para a sua conta.',
    passwordLabel: 'Nova senha',
    passwordPlaceholder: 'Mínimo de 8, com maiúscula e símbolo',
    passwordShow: 'Mostrar senha',
    passwordHide: 'Ocultar senha',
    confirmLabel: 'Confirmar nova senha',
    confirmPlaceholder: 'Repita a nova senha',
    submit: 'Salvar nova senha',
    submitting: 'Salvando…',
    mismatch: 'As senhas não coincidem.',
    tooShort: 'A senha precisa ter ao menos 8 caracteres, uma letra maiúscula e um símbolo.',
    missingLink: 'Link de redefinição ausente ou incompleto. Solicite um novo.',
    errorInvalidLink: 'Este link é inválido ou expirou. Solicite um novo link de redefinição.',
    errorWeak: 'Escolha uma senha mais forte.',
    errorNetwork: 'Não foi possível concluir agora. Verifique sua conexão e tente novamente.',
    errorTooMany: 'Muitas tentativas seguidas. Aguarde alguns minutos e tente de novo.',
    requestNew: 'Solicitar novo link',
  },

  signup: {
    pageTitle: 'Criar conta',
    intro: 'Cadastre seu escritório e comece a usar o sistema de análise.',
    emailLabel: 'E-mail',
    emailPlaceholder: 'voce@exemplo.com',
    passwordLabel: 'Senha',
    passwordHint: 'Mínimo de 8 caracteres, com uma letra maiúscula e um símbolo (como ! @ # -).',
    passwordPlaceholder: 'Crie uma senha forte',
    passwordShow: 'Mostrar senha',
    passwordHide: 'Ocultar senha',
    passwordConfirmLabel: 'Confirme a senha',
    passwordConfirmPlaceholder: 'Repita a senha para conferência',
    passwordMismatch: 'As senhas não conferem.',
    capsLockOn: 'Caps Lock ativo',
    strengthLabel: 'Força da senha',
    strengthWeak: 'Fraca',
    strengthMedium: 'Média',
    strengthStrong: 'Forte',
    strengthVeryStrong: 'Muito forte',
    nomeEscritorioLabel: 'Nome do escritório',
    nomeEscritorioPlaceholder: 'Ex.: Cartório de Perícias da Cidade',
    lgpdLabel: 'Li e aceito os Termos de Uso e o aviso LGPD.',
    lgpdRequired: 'Você precisa aceitar os Termos e o aviso LGPD para criar a conta.',
    lgpdReadCta: 'Ver Termos e aviso LGPD',
    lgpdSoonTitle: 'Termos de Uso e aviso LGPD',
    lgpdSoonBody:
      'O texto definitivo dos Termos de Uso e do aviso LGPD será publicado no fechamento da versão 1.0. Enquanto isso, o cadastro segue os princípios da Lei 13.709/2018: os dados pessoais informados (e-mail e nome do escritório) são usados apenas para autenticar o titular e identificar o escritório, sem compartilhamento com terceiros. As assinaturas analisadas ficam restritas ao escritório criador (segregação por RLS no banco).',
    lgpdSoonConfirm: 'Fechar',
    submit: 'Criar conta',
    submitting: 'Criando conta…',
    hasAccount: 'Já tem uma conta?',
    loginCta: 'Entrar',
    // E166.F2.T03: o cadastro público fechado (produção e homologação).
    closedTitle: 'Acesso por convite',
    closedBody:
      'As contas são criadas pelo administrador do seu escritório ou pelo gestor do seu banco. Peça o seu acesso a quem administra a sua equipe.',
    errorClosed:
      'O cadastro não está disponível. Peça o seu acesso ao administrador do seu escritório ou ao gestor do seu banco.',
  },

  onboarding: {
    pageTitle: 'Tudo certo. Vamos preparar seu escritório.',
    intro:
      'Três passos rápidos para começar com o pé direito. Você pode voltar e ajustar tudo isso depois em Configurações.',
    step1Title: '1. Confirme os dados do escritório',
    step1Body:
      'Esses são os dados que aparecerão no rodapé dos laudos e na sua sessão. O nome do escritório pode ser alterado depois em Configurações.',
    step1EmailLabel: 'E-mail do titular',
    step1EscritorioLabel: 'Identificador técnico do escritório',
    step1EscritorioHint: 'Use apenas para suporte técnico. Não aparece em laudos nem em listas.',
    step2Title: '2. Cadastre sua primeira chave de acesso',
    step2Body:
      'A chave é o que libera o uso do provedor de análise. Você pode adicionar agora ou depois — a tela de Casos espera pacientemente.',
    step2Cta: 'Cadastrar chave agora',
    step3Title: '3. Comece a periciar',
    step3Body:
      'Tudo pronto. Você pode criar o primeiro caso ou ir direto para a lista de casos e olhar a interface.',
    step3CtaPrimary: 'Criar primeiro caso',
    step3CtaSecondary: 'Ir para a lista de casos',
    skipLink: 'Pular essas dicas e ir para a lista de casos',
    contextLoadError:
      'Não foi possível carregar seus dados agora. Você pode continuar mesmo assim e revisar em Configurações.',
  },

  trocaDeSenha: {
    eyebrow: 'CONTA',
    pageTitle: 'Defina uma senha sua',
    intro:
      'A senha com que você entrou foi definida por outra pessoa. Escolha uma senha que só você conheça para continuar.',
    senhaAtualLabel: 'Senha atual',
    senhaAtualHint: 'A que você acabou de usar para entrar.',
    senhaNovaLabel: 'Nova senha',
    senhaNovaHint: 'Ao menos 8 caracteres, com uma letra maiúscula e um símbolo (como ! @ # -).',
    confirmacaoLabel: 'Repita a nova senha',
    submit: 'Salvar e continuar',
    submitting: 'Salvando...',
    erroSenhaAtual: 'A senha atual não confere. Confira e tente de novo.',
    erroConfirmacao: 'As duas senhas não coincidem.',
    erroSenhaCurta:
      'A nova senha precisa de ao menos 8 caracteres, uma letra maiúscula e um símbolo.',
    erroSenhaRepetida: 'A nova senha precisa ser diferente da atual.',
    erroRede: 'Não foi possível falar com o servidor. Tente de novo em instantes.',
    erroDesconhecido: 'Não foi possível trocar a senha agora. Tente de novo em instantes.',
  },
  perfil: {
    eyebrow: 'CONTA',
    pageTitle: 'Seu perfil',
    intro: 'Seus dados básicos. As chaves de acesso ao provedor ficam em Configurações.',
    escritorioLabel: 'Escritório',
    techIdShow: 'Ver identificador técnico',
    techIdHide: 'Ocultar identificador técnico',
    techIdCopy: 'Copiar identificador',
    techIdCopied: 'Copiado para a área de transferência.',
    apiKeysSection: 'Chave do provedor de análise',
    apiKeysSectionHint:
      'A chave que libera o uso do provedor de análise é gerenciada em uma tela dedicada para reduzir risco de exposição acidental.',
    apiKeysManageLink: 'Gerenciar chaves de acesso',
    preferencesSectionTitle: 'Preferências',
    preferencesSectionHint:
      'Densidade das tabelas. O fuso é detectado automaticamente do navegador.',
    preferencesTimezoneLabel: 'Fuso horário',
    preferencesTimezoneAuto: 'Detectado automaticamente',
    preferencesDensityLabel: 'Densidade das tabelas',
    preferencesDensityCompact: 'Compacta',
    preferencesDensityComfortable: 'Confortável',
    // E164.F2 (ADR-0113): a assinatura com certificado digital confere o CPF do certificado.
    cpfSectionTitle: 'CPF',
    cpfSectionHint:
      'O CPF do seu certificado digital. A assinatura do laudo só é aceita quando o certificado traz este CPF. Ele não aparece no laudo.',
    cpfLabel: 'CPF',
    cpfPlaceholder: '000.000.000-00',
    cpfSave: 'Salvar CPF',
    cpfSaved: 'CPF atualizado.',
    cpfError: 'Não foi possível salvar o CPF. Confira os dígitos e tente novamente.',
    registroSectionTitle: 'Registro profissional',
    registroSectionHint:
      'Número do seu registro profissional. Ele é impresso no laudo certificado que você assinar. Deixe em branco se não quiser informar.',
    registroLabel: 'Registro profissional',
    registroPlaceholder: 'Ex.: CRC-SP 12.345',
    registroSave: 'Salvar registro',
    registroSaving: 'Salvando…',
    registroSaved: 'Registro atualizado.',
    registroError: 'Não foi possível salvar o registro. Tente novamente.',
    registroVazio: 'Não informado',
    // E56.F1: nome da própria pessoa. Sem ele, o cabeçalho da conta mostrava o
    // e-mail — o nome do escritório não serve, porque quem está logado pode não
    // ser o titular.
    nomeSectionTitle: 'Seu nome',
    nomeSectionHint:
      'Como seu nome aparece no menu e nos registros de quem fez cada ação. Deixe em branco para voltar a exibir o e-mail.',
    nomeLabel: 'Nome',
    nomePlaceholder: 'Ex.: Gustavo Carneiro',
    nomeSave: 'Salvar nome',
    nomeSaved: 'Nome atualizado.',
    nomeError: 'Não foi possível salvar o nome. Tente novamente.',
  },

  config: {
    eyebrow: 'CONFIGURAÇÕES DO ESCRITÓRIO',
    pageTitle: 'Configurações',
    intro:
      'Atalhos para gerenciar o que afeta o escritório: chaves de acesso, equipe e dados do escritório.',
    cardApiKeysTitle: 'Chaves de acesso',
    cardApiKeysBody: 'Adicione, troque ou remova as chaves que liberam o provedor de análise.',
    cardApiKeysCta: 'Abrir',
    cardMembersTitle: 'Equipe do escritório',
    cardMembersBody:
      'Convide peritos, defina papéis e gerencie acessos. Apenas o administrador pode adicionar ou remover usuários.',
    cardMembersCta: 'Abrir',
    cardContaTitle: 'Dados do escritório',
    cardContaBody:
      'Razão social, CNPJ, endereço e responsável técnico que aparecem no rodapé do laudo.',
    cardContaCta: 'Abrir',
  },

  apiKeys: {
    eyebrow: 'CHAVES DE ACESSO',
    pageTitle: 'Chaves de acesso',
    intro:
      'Gerencie as chaves que liberam o uso dos provedores externos do escritório. Cada chave fica guardada com cifragem e só mostramos os últimos 4 caracteres.',
    listEmptyTitle: 'Nenhuma chave salva ainda',
    listEmptyHint: 'Adicione a chave do provedor de análise para liberar as análises.',
    listLoading: 'Carregando chaves…',
    listErrorRetry: 'Tentar novamente',
    addCta: '+ Nova chave',
    addDialogTitle: 'Adicionar nova chave',
    addDialogHint:
      'Cole a chave fornecida pelo provedor. Salvamos com cifragem; ela nunca aparece em tela depois disso.',
    addDialogProviderLabel: 'Provedor',
    addDialogProviderDisplayName: 'Provedor de análise',
    // Catálogo por PAPEL do provedor, não pelo identificador do contrato HTTP:
    // o nome do fornecedor não entra no arquivo de textos (o mapa
    // contrato → papel vive em `lib/api_keys`, que carrega o bypass do lint).
    addDialogProviderNames: {
      analise: 'Provedor de análise',
      bureau: 'Bureau cadastral (endereços e vínculos)',
    },
    addDialogProviderHint:
      'O bureau cadastral só é usado na modalidade de assinatura eletrônica: sem ele, os endereços vinculados ao titular saem como não consultados no quadro.',
    addDialogValueLabel: 'Valor da chave',
    addDialogValuePlaceholder: 'Cole aqui a chave fornecida pelo provedor',
    addDialogConfirm: 'Salvar chave',
    addDialogCancel: 'Cancelar',
    rotateCta: 'Trocar',
    rotateDialogTitle: 'Trocar valor da chave',
    rotateDialogHint:
      'A chave atual será substituída pela nova. Os 4 caracteres finais aparecem aqui depois de salvar.',
    rotateDialogValueLabel: 'Novo valor da chave',
    rotateDialogValuePlaceholder: 'Cole aqui o novo valor',
    rotateDialogConfirm: 'Trocar chave',
    rotateDialogCancel: 'Cancelar',
    revokeCta: 'Remover',
    revokeConfirmTitle: 'Remover esta chave?',
    revokeConfirmHint:
      'Depois de remover, novas análises com este provedor ficam bloqueadas até você cadastrar outra chave.',
    revokeConfirmYes: 'Remover',
    revokeConfirmNo: 'Cancelar',
    itemProviderLabel: 'Provedor',
    itemLast4Label: 'Final',
    itemCreatedAtLabel: 'Adicionada em',
    itemLastUsedAtLabel: 'Último uso',
    itemLastUsedAtNever: 'Ainda não usada',
    itemStatusLabel: 'Status',
    itemStatusActive: 'Ativa',
    columnActions: 'Ações',
    revealOnceHint:
      'Anote agora — a chave só aparece nesta tela. Depois você verá só os 4 últimos caracteres.',
    saving: 'Salvando…',
    removing: 'Removendo…',
    saveSuccess: 'Chave salva com segurança.',
    rotateSuccess: 'Chave trocada com segurança.',
    revokeSuccess: 'Chave removida.',
    errorConflict:
      'Já existe uma chave salva para este provedor. Troque o valor da chave atual em vez de adicionar.',
    errorNotFound: 'Esta chave não está mais disponível. Atualize a lista.',
    errorValidation:
      'A chave informada não foi aceita pelo formato esperado. Confira e tente novamente.',
    errorNetwork: 'Sem conexão com o servidor. Tente novamente em instantes.',
    errorUnauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
    errorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
  },

  members: {
    eyebrow: 'PESSOAS DO ESCRITÓRIO',
    pageTitle: 'Usuários do escritório',
    intro:
      'Gerencie quem tem acesso aos casos e análises do escritório. Apenas o administrador pode adicionar ou remover usuários.',
    listLoading: 'Carregando usuários…',
    listErrorRetry: 'Tentar novamente',
    listEmptyTitle: 'Nenhum usuário cadastrado além do administrador',
    listEmptyHint: 'Adicione um novo usuário para que ele acesse os casos do escritório.',
    addCta: '+ Novo usuário',
    roleOwner: 'Administrador',
    roleMember: 'Usuário',
    roleRevisor: 'Revisor',
    roleCertificador: 'Certificador',
    roleBankManager: 'Gestor',
    roleBankUser: 'Usuário da instituição',
    statusActive: 'Ativo',
    statusInactive: 'Inativo',
    itemRoleLabel: 'Papel',
    itemStatusLabel: 'Situação',
    itemCreatedAtLabel: 'Adicionado em',
    addDialogTitle: 'Adicionar usuário',
    addDialogHint:
      'Defina e-mail e senha iniciais. O usuário entra com a senha que você definir; depois pode alterar em "Seu perfil".',
    addDialogEmailLabel: 'E-mail',
    addDialogEmailPlaceholder: 'usuario@dominio',
    addDialogPasswordLabel: 'Senha inicial',
    addDialogPasswordPlaceholder: 'Mínimo de 8, com maiúscula e símbolo',
    addDialogPasswordConfirmLabel: 'Confirme a senha',
    addDialogConfirm: 'Adicionar usuário',
    addDialogCancel: 'Cancelar',
    addDialogPasswordTooShort:
      'A senha precisa ter ao menos 8 caracteres, uma letra maiúscula e um símbolo.',
    addDialogPasswordMismatch: 'As senhas não conferem.',
    addDialogEmailInvalid: 'Informe um e-mail válido.',
    promoteToRevisorCta: 'Tornar revisor',
    demoteToMemberCta: 'Tornar usuário comum',
    roleUpdateSuccess: 'Papel atualizado.',
    roleHint:
      'O revisor homologa os casos do escritório antes da emissão do laudo. Quando homologa um caso que ele mesmo elaborou, isso fica registrado no caso.',
    grantCertificadorCta: 'Tornar certificador',
    revokeCertificadorCta: 'Remover certificação',
    // E164.F2 (ADR-0113): quem dá a assinatura final dos laudos com certificado digital.
    grantResponsavelCta: 'Tornar responsável técnico',
    revokeResponsavelCta: 'Deixar de ser responsável técnico',
    responsavelBadge: 'Responsável técnico',
    responsavelHint:
      'O responsável técnico assina por último todo laudo com certificado digital. Só quem assina (certificador ou administrador) pode ser marcado.',
    responsavelJaDefinido: 'Já há um responsável técnico. Desmarque o atual antes de marcar outro.',
    certificadorHint:
      'O certificador assina os laudos das certificações solicitadas pelos clientes. O administrador do escritório da plataforma também assina.',
    removeCta: 'Remover',
    removeConfirmTitle: 'Remover este usuário?',
    removeConfirmHint:
      'O usuário perde acesso ao escritório imediatamente. Esta ação não pode ser desfeita pelo administrador.',
    removeConfirmYes: 'Remover',
    removeConfirmNo: 'Cancelar',
    saveSuccess: 'Usuário adicionado.',
    removeSuccess: 'Usuário removido.',
    saving: 'Salvando…',
    removing: 'Removendo…',
    errorConflict: 'Já existe um usuário com esse e-mail.',
    errorOwnerRequired: 'Apenas o administrador pode adicionar ou remover usuários.',
    errorOwnerCannotBeRemoved: 'O administrador do escritório não pode ser removido nesta tela.',
    errorValidation: 'Os dados informados não foram aceitos. Confira e tente novamente.',
    errorNotFound: 'Esse usuário não está mais disponível. Atualize a lista.',
    errorNetwork: 'Sem conexão com o servidor. Tente novamente em instantes.',
    errorUnauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
    errorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
  },

  escritorio: {
    eyebrow: 'DADOS DO ESCRITÓRIO',
    pageTitle: 'Dados do escritório',
    intro:
      'Nome e CNPJ aparecem no laudo e identificam seu escritório. Apenas o administrador pode editar.',
    formNomeLabel: 'Nome do escritório',
    formNomePlaceholder: 'Ex.: Perícias Grafotécnicas Ltda.',
    formCnpjLabel: 'CNPJ',
    formCnpjHint: 'Apenas dígitos. Opcional.',
    formCnpjPlaceholder: '00000000000000',
    formSave: 'Salvar alterações',
    formCancel: 'Descartar alterações',
    saving: 'Salvando…',
    saveSuccess: 'Dados do escritório atualizados.',
    loadErrorRetry: 'Tentar novamente',
    errorOwnerRequired: 'Apenas o administrador pode editar os dados do escritório.',
    errorEmpty: 'Altere ao menos um campo antes de salvar.',
    errorValidation: 'Os dados informados não foram aceitos. Confira e tente novamente.',
    errorNetwork: 'Sem conexão com o servidor. Tente novamente em instantes.',
    errorUnauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
    errorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
  },

  certificacao: {
    eyebrow: 'CERTIFICAÇÃO DE DOCUMENTO TÉCNICO',
    revisaoKicker: 'REVISÃO ANTES DA ASSINATURA',
    pageTitle: 'Certificação',
    intro:
      'CCBs com certificação requerida, da mais urgente para a menos. Abra a revisão para assumir o item, confira os três pontos obrigatórios e assine o laudo.',
    indicadorPendentes: 'Pendentes',
    indicadorVencemHoje: 'Vencem hoje',
    indicadorAssinadosHoje: 'Assinados hoje',
    pendentesLoading: 'Carregando certificações pendentes…',
    pendentesError: 'Não foi possível carregar as certificações pendentes.',
    pendentesRetry: 'Tentar novamente',
    pendentesEmptyTitle: 'Nenhuma CCB aguardando certificação',
    pendentesEmptyHint:
      'Assim que um cliente requerer a certificação de uma CCB, ela aparece aqui.',
    colCaso: 'Caso · CCB',
    colExame: 'Exame primário',
    colRequeridaPor: 'Requerida por',
    colProducao: 'Produção de origem',
    colPrazo: 'Prazo',
    colAcao: 'Ação',
    semValor: '—',
    ambienteBanco: 'Banco',
    ambienteEscritorio: 'Escritório',
    // E60.F3 — o item foi puxado para a frente pelo perito.
    prioritarioBadge: 'Prioritário',
    statusRequerida: 'Requerida',
    statusEmRevisao: 'Em revisão',
    statusLaudoEntregue: 'Laudo entregue',
    abrirRevisao: 'Abrir revisão',
    abrindoRevisao: 'Abrindo…',
    revisaoTitle: 'Revisão da CCB',
    revisaoHint:
      'Confirme cada ponto antes de assinar. A assinatura só é aceita com os três confirmados.',
    revisaoFechar: 'Fechar revisão',
    checklistMetodologia: 'Metodologia e cadeia de custódia conferidas',
    checklistComparativos: 'Comparativos válidos e suficientes',
    checklistEvidencias: 'Evidências eletrônicas conferidas e suficientes',
    checklistTexto: 'Texto do laudo revisado',
    checklistPendente: 'Confirme os três pontos para liberar a assinatura.',
    abrirLaudo: 'Abrir o laudo do caso',
    assinar: 'Certificar e assinar',
    assinando: 'Assinando…',
    // E170.F1 (GUS-229): a assinatura interna é registro na plataforma, não certificado digital.
    assinaturaOk: 'Laudo assinado por registro na plataforma, sem certificado digital ICP-Brasil.',
    assinaturaCoincidencia:
      'Este laudo declara que produção e assinatura foram do mesmo profissional.',
    // E147.F3 (ADR-0101 §2.6): a conexão caiu no meio da assinatura — a tela relê antes de oferecer
    // "Assinar" de novo, e o pedido repetido recebe a assinatura gravada.
    assinaturaReconciliada:
      'A assinatura já estava registrada: a conexão caiu depois de assinar, e nada foi assinado de novo.',
    assinaturaGravada: 'Assinatura registrada em {quando} (arquivo {sha}).',
    assinaturaNaoRegistrada:
      'A conexão caiu antes de a assinatura ser registrada. Nada foi assinado: assine de novo.',
    assinaturaSemConfirmacao:
      'Sem conexão para confirmar a assinatura. Tente de novo: se ela já estiver registrada, nada é assinado outra vez.',
    erroCertificadoDivergente:
      'O arquivo assinado guardado não confere com o registro da assinatura. Avise a equipe técnica antes de prosseguir.',
    erroDisputada: 'Outro certificador já está com este item.',
    erroNaoAssumida: 'Este item não está em revisão com você. Abra a revisão novamente.',
    erroRevisaoIncompleta: 'A revisão precisa estar completa para assinar.',
    erroJaAssinado: 'Esta CCB já tem laudo assinado.',
    erroLaudoNaoPronto:
      'O laudo deste caso ainda não está pronto para assinar. Abra o caso e conclua o que falta: no exame eletrônico, o "Próximo passo" no alto das telas do caso diz o quê.',
    erroSaidasNaoRevisadas:
      'O exame desta versão ainda não foi marcado como revisado. Abra "Conferir e assinar" no caso e revise o exame.',
    erroIcpObrigatoria:
      'O exame eletrônico só se assina com certificado digital ICP-Brasil, pelo Assinador. Nada foi assinado.',
    erroAssinaturaNaoConferida:
      'A assinatura não foi registrada: a conferência da assinatura não aprovou o laudo desta versão. Abra o caso e confira o "Próximo passo".',
    erroNaoEncontrado: 'Item não encontrado.',
    erroSemPermissao: 'Você não tem acesso a esta ação.',
    erroRede: 'Sem conexão com o servidor. Verifique a rede e tente novamente.',
    erroGenerico: 'Não foi possível concluir a operação. Tente novamente.',
  },

  // Console de administração da plataforma (E53, ADR-0064). Área interna do
  // SignCheck: clientes, escritórios, pessoas e trilha de auditoria.
  admin: {
    clientesEyebrow: 'ADMINISTRAÇÃO DA PLATAFORMA',
    usuariosEyebrow: 'ADMINISTRAÇÃO DA PLATAFORMA',
    trilhaEyebrow: 'ADMINISTRAÇÃO DA PLATAFORMA',
    // Marcador único de dado que o console não consegue afirmar. Fonte única —
    // nunca literal no componente (lição F-E51.F4-01).
    valorAusente: '—',
    clientesTitle: 'Clientes e escritórios',
    clientesIntro:
      'Cadastre clientes, vincule escritórios e defina qual escritório opera a plataforma.',
    // -- clientes --
    clientesSectionTitle: 'Clientes',
    clienteColNome: 'Cliente',
    clienteColDocumento: 'CNPJ',
    clienteColEscritorios: 'Escritórios',
    clienteColCriadoEm: 'Cadastrado em',
    clientesVazio: 'Nenhum cliente cadastrado ainda.',
    clientesErro: 'Não foi possível carregar os clientes.',
    novoClienteTitle: 'Novo cliente',
    novoClienteNome: 'Nome do cliente',
    novoClienteDocumento: 'CNPJ (somente números, opcional)',
    novoClienteSubmit: 'Cadastrar cliente',
    novoClienteEnviando: 'Cadastrando…',
    novoClienteSucesso: 'Cliente cadastrado.',
    validationNomeObrigatorio: 'Informe o nome do cliente.',
    validationDocumento: 'O CNPJ deve ter 14 números, sem pontuação.',
    // -- escritórios --
    escritoriosSectionTitle: 'Escritórios',
    escritorioColNome: 'Escritório',
    escritorioColAmbiente: 'Tipo',
    escritorioColCliente: 'Cliente vinculado',
    escritorioColPessoas: 'Pessoas',
    escritorioColCasos: 'Casos',
    escritorioColAcoes: 'Ações',
    escritoriosVazio: 'Nenhum escritório encontrado.',
    escritoriosErro: 'Não foi possível carregar os escritórios.',
    escritoriosCarregando: 'Carregando escritórios…',
    ambientePlataforma: 'Plataforma',
    ambienteEscritorio: 'Escritório',
    ambienteCliente: 'Escritório-cliente',
    ambienteBanco: 'Cliente',
    semVinculo: 'Sem vínculo',
    vinculoMultiplo: '{total} clientes',
    vincularLabel: 'Vincular a',
    vincularSubmit: 'Salvar vínculo',
    desvincularOpcao: 'Sem vínculo',
    marcarPlataforma: 'Tornar plataforma',
    desmarcarPlataforma: 'Deixar de ser plataforma',
    // -- encerramento de escritório (E69.F1, ADR-0072) --
    encerrarEscritorio: 'Encerrar escritório',
    reabrirEscritorio: 'Reabrir escritório',
    encerrarConfirmacao:
      'Encerrar {nome}? {pessoas} perdem o acesso agora. Os casos e o histórico ficam guardados.',
    encerrarConfirmacaoUmaPessoa: '1 pessoa perde o acesso agora',
    encerrarConfirmacaoPessoas: '{total} pessoas',
    encerrarConfirmacaoNinguem: 'Ninguém tem acesso ativo',
    encerrarSucesso: 'Escritório encerrado. As pessoas dele perderam o acesso.',
    reabrirSucesso: 'Escritório reaberto. Reative as pessoas uma a uma em Pessoas e acessos.',
    escritorioEncerradoMarca: 'Encerrado',
    novoEscritorioTitle: 'Novo escritório',
    novoEscritorioHint:
      'O escritório é criado junto com a conta do administrador. A senha informada é provisória: ' +
      'o administrador é obrigado a trocá-la no primeiro acesso.',
    novoEscritorioNome: 'Nome do escritório',
    novoEscritorioDocumento: 'CNPJ (somente números, opcional)',
    novoEscritorioGestorEmail: 'E-mail do administrador',
    novoEscritorioGestorNome: 'Nome do administrador (opcional)',
    novoEscritorioGestorSenha: 'Senha provisória do administrador',
    novoEscritorioCliente: 'Cliente vinculado (opcional)',
    novoEscritorioSemCliente: 'Sem vínculo',
    novoEscritorioSubmit: 'Cadastrar escritório',
    novoEscritorioEnviando: 'Cadastrando…',
    novoEscritorioSucesso: 'Escritório cadastrado.',
    validationNomeEscritorioObrigatorio: 'Informe o nome do escritório.',
    acaoSucesso: 'Alteração salva.',
    buscaLabel: 'Buscar',
    buscaPlaceholder: 'Nome ou documento',
    estadoLabel: 'Estado',
    estadoAtivos: 'Ativos',
    estadoInativos: 'Inativos',
    estadoTodos: 'Todos',
    paginaAnterior: 'Anterior',
    paginaProxima: 'Próxima',
    paginaResumo: 'Mostrando {inicio}–{fim} de {total}',
    // -- pessoas e acessos (E53.F6) --
    usuariosTitle: 'Pessoas e acessos',
    usuariosIntro:
      'Veja quem trabalha em cada ambiente. Clique em Editar para corrigir os dados, o papel, o escritório, a senha ou o acesso de uma pessoa.',
    usuarioColPessoa: 'Pessoa',
    usuarioColAmbiente: 'Ambiente',
    usuarioColPapel: 'Papel',
    usuarioColEstado: 'Estado',
    usuarioColAcoes: 'Ações',
    usuariosVazio: 'Nenhuma pessoa encontrada com esse recorte.',
    usuariosErro: 'Não foi possível carregar as pessoas.',
    usuariosCarregando: 'Carregando pessoas…',
    ambienteFiltroLabel: 'Ambiente',
    ambienteTodos: 'Todos',
    estadoAtivo: 'Ativo',
    estadoInativo: 'Inativo',
    trocarPapelLabel: 'Papel',
    trocarPapelSubmit: 'Salvar papel',
    desativarAcesso: 'Desativar acesso',
    reativarAcesso: 'Reativar acesso',
    confirmarPergunta: 'Confirmar esta alteração?',
    confirmarSim: 'Confirmar',
    confirmarNao: 'Cancelar',
    novaPessoaTitle: 'Nova pessoa',
    novaPessoaHint:
      'A senha é provisória: a pessoa entra com ela e é obrigada a trocá-la no primeiro acesso.',
    novaPessoaEmail: 'Acesso (e-mail)',
    novaPessoaNome: 'Nome (opcional)',
    novaPessoaCpf: 'CPF (opcional; necessário para assinar laudos)',
    novaPessoaAbrir: '+ Nova pessoa',
    novaPessoaSenha: 'Senha provisória',
    novaPessoaDestinoTipo: 'A pessoa trabalha em',
    novaPessoaDestinoEscritorio: 'Um escritório',
    novaPessoaDestinoCliente: 'Um cliente (banco)',
    novaPessoaDestino: 'Qual',
    novaPessoaPapel: 'Papel',
    novaPessoaSubmit: 'Criar pessoa',
    novaPessoaEnviando: 'Criando…',
    novaPessoaSucesso: 'Pessoa criada. Informe a senha provisória a ela.',
    validationEmailObrigatorio: 'Informe o acesso (e-mail).',
    validationSenhaCurta:
      'A senha provisória precisa de ao menos 8 caracteres, uma letra maiúscula e um símbolo.',
    validationDestinoObrigatorio: 'Escolha o destino da pessoa.',
    erroUltimoGestor:
      'Esta é a única pessoa ativa que administra este ambiente. Dê o papel a outra pessoa antes de retirar esta.',
    erroAcaoSobreSiMesmo: 'Você não pode alterar o próprio papel nem o próprio acesso por aqui.',
    erroPapelForaDoAmbiente: 'Este papel não existe no ambiente desta pessoa.',
    erroEmailJaCadastrado: 'Este e-mail já pertence a outra pessoa.',
    erroPessoaComRastro:
      'Esta pessoa já usou o sistema, e o histórico precisa continuar com o nome dela. Desative o acesso em vez de excluir ou mudar de escritório.',
    erroCpfInvalido: 'CPF inválido. Confira os números.',
    // -- painel da pessoa (E175.F1, ADR-0127) --
    pessoaEditar: 'Editar',
    pessoaCarregando: 'Carregando…',
    pessoaFechar: 'Fechar',
    pessoaSecaoDados: 'Dados',
    pessoaNome: 'Nome',
    pessoaEmail: 'E-mail de acesso',
    pessoaCpf: 'CPF',
    pessoaCpfHint: 'Necessário para assinar laudos com certificado digital.',
    pessoaSalvarDados: 'Salvar dados',
    pessoaSecaoPapel: 'Papel',
    pessoaSecaoEscritorio: 'Escritório',
    pessoaMover: 'Mudar de escritório',
    pessoaMoverBloqueado:
      'Esta pessoa já usou o sistema e não muda de escritório. Desative o acesso e cadastre a pessoa no escritório certo.',
    pessoaSecaoSenha: 'Senha',
    pessoaSenhaHint:
      'Defina uma senha provisória e informe-a à pessoa. Ela será obrigada a trocá-la no próximo acesso.',
    pessoaSenhaPendente: 'A pessoa ainda não trocou a senha provisória.',
    pessoaSenhaNova: 'Nova senha provisória',
    pessoaSenhaSubmit: 'Definir senha provisória',
    pessoaSenhaSucesso: 'Senha provisória definida. Informe-a à pessoa.',
    pessoaSecaoAcesso: 'Acesso',
    pessoaExcluir: 'Excluir pessoa',
    pessoaExcluirHint: 'Esta pessoa ainda não usou o sistema e pode ser excluída de vez.',
    pessoaExcluirBloqueado:
      'Esta pessoa já usou o sistema: para preservar o histórico, ela só pode ser desativada.',
    pessoaExcluirConfirmar: 'Excluir de vez? Não há como desfazer.',
    pessoaExcluirSucesso: 'Pessoa excluída.',
    papelDescricao: {
      owner:
        'Administra o escritório: pessoas, dados, chaves de acesso e texto do laudo. No escritório da plataforma, também administra clientes e escritórios e assina laudos.',
      member: 'Trabalha nos casos do escritório.',
      revisor: 'Trabalha nos casos e homologa antes da emissão do laudo.',
      certificador:
        'Assina os laudos com certificado digital. Só existe no escritório da plataforma.',
      bank_manager: 'Administra o ambiente do cliente: pessoas e escritórios que o cliente criou.',
      bank_user: 'Abre casos e acompanha os resultados do cliente.',
    },
    // -- trilha de auditoria: o que é DO CONSOLE (E53.F7) --
    // O vocabulário da trilha (colunas, estados, ações, origens) vive em
    // `ptBR.trilha`, porque o módulo do banco mostra a MESMA trilha (E61.F4).
    // Aqui fica só a moldura do console: cabeçalho, filtros e export.
    trilhaTitle: 'Trilha de auditoria',
    trilhaIntro:
      'O que aconteceu com cada cliente: ações do console e eventos do próprio trabalho, lado a lado.',
    trilhaDesde: 'De',
    trilhaAte: 'Até',
    trilhaAutorLabel: 'Quem fez',
    trilhaOrigemLabel: 'Origem',
    trilhaOrigemTodas: 'Todas',
    trilhaExportar: 'Exportar CSV',
    trilhaExportando: 'Preparando arquivo…',
    trilhaExportSucesso: 'Arquivo gerado.',
    erroExportMuitoGrande:
      'O recorte tem registros demais para um único arquivo. Reduza o período e exporte por partes.',
    // -- mensagens de recusa (a frase que vale é a do servidor) --
    erroEscritorioComCasos:
      'Este escritório já produziu casos para o cliente atual. Defina o destino desses casos antes de mudar o vínculo.',
    erroDesvinculoAmbiguo:
      'Este escritório atende mais de um cliente. Escolha qual vínculo remover — retirar sem dizer qual apagaria o registro errado.',
    erroPlataformaNaoTemCliente:
      'Um escritório não pode ser da plataforma e de um cliente ao mesmo tempo.',
    erroUltimaPlataforma:
      'Este é o único escritório da plataforma. Promova outro antes de retirar este.',
    erroPlataformaNaoEncerra: 'O escritório da plataforma não pode ser encerrado.',
    erroEscritorioEncerrado:
      'O escritório desta pessoa está encerrado. Reabra o escritório antes de reativar o acesso.',
    erroNaoEncontrado: 'Registro não encontrado. Atualize a página e tente novamente.',
    erroSemAcesso: 'Você não tem acesso a esta ação ou sua sessão expirou.',
    erroRede: 'Sem conexão com o servidor. Tente novamente em instantes.',
    erroGenerico: 'Não foi possível concluir a operação. Tente novamente.',
  },

  // Vocabulário da trilha de auditoria — o código do fato vira frase aqui, e as
  // DUAS telas que mostram a mesma trilha leem daqui: o console da plataforma
  // (E53.F7) e o módulo do banco (E61.F4). Moldura de cada tela (cabeçalho,
  // filtros, export) fica no namespace da tela, não neste.
  trilha: {
    colData: 'Quando',
    colAcao: 'O que aconteceu',
    colAutor: 'Quem fez',
    colAmbiente: 'Ambiente',
    colObjeto: 'Sobre',
    colOrigem: 'Origem',
    vazio: 'Nenhum registro nesse recorte.',
    erro: 'Não foi possível carregar a trilha.',
    carregando: 'Carregando registros…',
    semAutor: 'Registro automático',
    // Marcador único de dado que a trilha não consegue afirmar — nunca literal
    // no componente (lição F-E51.F4-01).
    valorAusente: '—',
    // Detalhe do fato: cada ação diz COMO o próprio detalhe se lê, e o valor
    // sai traduzido. Nada de nome de campo do payload na tela (F-E61.F4-01).
    campoPapel: 'Papel',
    campoNome: 'Nome',
    campoCnpj: 'CNPJ',
    campoPessoasDesativadas: 'Pessoas que perderam o acesso',
    campoCasosPreservados: 'Casos preservados',
    acessoAtivo: 'Com acesso',
    acessoSem: 'Sem acesso',
    plataformaSim: 'Escritório da plataforma',
    plataformaNao: 'Escritório de cliente',
    // Rótulos das origens — a tela nomeia de onde veio o registro para que
    // ninguém confunda "não há registro" com "esta origem não grava isso".
    origemAdministracao: 'Console',
    origemAssinatura: 'Assinatura de laudo',
    origemMedicao: 'Medição',
    origemRequisicao: 'Requisição de certificação',
    origemEdicaoLaudo: 'Edição de laudo',
    origemCompartilhamento: 'Compartilhamento de laudo',
    origemCaso: 'Histórico do caso',
    filtroCaso: 'Caso',
    filtroCasoPlaceholder: 'Código do caso',
    // Ações — vocabulário fechado do console + as ações de domínio projetadas.
    // A paridade com o que o servidor pode emitir é travada por teste
    // (`tests/unit/test_e61_f4_paridade_catalogo_trilha.py`): ação sem rótulo
    // aqui fica vermelha antes de chegar à tela (F-E61.F4-05).
    acaoClienteCriado: 'Cliente cadastrado',
    acaoEscritorioCriado: 'Escritório cadastrado',
    acaoEscritorioVinculado: 'Escritório vinculado ao cliente',
    acaoEscritorioDesvinculado: 'Escritório desvinculado',
    acaoEscritorioMarcadoPlataforma: 'Escritório passou a ser da plataforma',
    acaoEscritorioDesmarcadoPlataforma: 'Escritório deixou de ser da plataforma',
    acaoUsuarioCriado: 'Pessoa criada',
    acaoPapelAlterado: 'Papel alterado',
    acaoAcessoDesativado: 'Acesso desativado',
    acaoAcessoReativado: 'Acesso reativado',
    acaoLaudoAssinado: 'Laudo assinado',
    acaoExameEntregue: 'Exame entregue',
    acaoCertificacaoRequerida: 'Certificação requerida',
    acaoNarrativaEditada: 'Texto do laudo editado',
    acaoLrAjustado: 'Indicador do laudo ajustado',
    acaoLaudoCompartilhado: 'Laudo compartilhado',
    acaoLaudoCertificadoBaixado: 'Laudo certificado baixado',
    acaoSenhaTrocada: 'Senha alterada pela própria pessoa',
    acaoDocumentoBaixado: 'Documento do caso baixado',
    acaoEscritorioEncerrado: 'Escritório encerrado',
    acaoEscritorioReaberto: 'Escritório reaberto',
    acaoPessoaEditada: 'Dados da pessoa alterados',
    acaoSenhaProvisoriaDefinida: 'Senha provisória definida pelo administrador',
    acaoPessoaMovida: 'Pessoa mudou de escritório',
    acaoPessoaExcluida: 'Pessoa excluída',
    // Rede de segurança do catálogo, não caminho de operação: com a paridade
    // travada, nenhum produtor real cai aqui. Se cair, a linha continua
    // completa (quando, quem, sobre o quê) e o código interno do fato NÃO é
    // publicado — foi assim que a violação entrou (F-E61.F4-05).
    acaoDesconhecida: 'Fato registrado',
    origemDesconhecida: 'Origem não identificada',
  },

  precificacao: {
    eyebrow: 'CONFIGURAÇÃO COMERCIAL',
    pageTitle: 'Configuração comercial',
    // Marcador único de dado ainda indeterminado (volume inicial que depende do
    // limite anterior, valor ausente). Fonte única — nunca literal no componente.
    valorAusente: '—',
    intro:
      'Consulte o histórico de preços por banco e registre novas versões. Cada versão vale por um período de vigência e não altera valores já medidos.',
    bancoLabel: 'Banco',
    bancoPlaceholder: 'Selecione um banco',
    bancosLoading: 'Carregando bancos…',
    bancosEmptyTitle: 'Nenhum banco cadastrado',
    bancosEmptyHint: 'Cadastre um banco antes de configurar preços.',
    bancosError: 'Não foi possível carregar os bancos.',
    historicoTitle: 'Histórico de versões',
    historicoLoading: 'Carregando histórico…',
    historicoEmptyTitle: 'Nenhuma versão registrada para este banco',
    historicoEmptyHint: 'Crie a primeira versão de preços abaixo.',
    historicoError: 'Não foi possível carregar o histórico.',
    listErrorRetry: 'Tentar novamente',
    vigenteBadge: 'Vigente',
    vigenciaLabel: 'Vigência',
    vigenciaAte: 'até',
    criadoEmLabel: 'Registrada em',
    colFaixa: 'Faixa',
    colVolume: 'Volume mensal',
    colExame: 'Exame',
    colCertificacao: 'Certificação (agregado)',
    volumeAberto: 'ou mais',
    novaVersaoTitle: 'Nova versão',
    novaVersaoHint:
      'Defina o período de vigência e as faixas de volume. As faixas devem cobrir do volume 1 em diante, sem sobreposição, e a última fica aberta.',
    vigenciaInicioLabel: 'Início da vigência',
    vigenciaFimLabel: 'Fim da vigência',
    faixaOrdem: 'Faixa',
    faixaVolumeInicio: 'Volume inicial',
    faixaVolumeFim: 'Volume final',
    faixaVolumeFimHint: 'Deixe vazio na última faixa (aberta).',
    faixaExame: 'Valor do exame (R$)',
    faixaCertificacao: 'Valor da certificação — agregado (R$)',
    addFaixa: '+ Adicionar faixa',
    removeFaixa: 'Remover faixa',
    submit: 'Registrar versão',
    submitting: 'Registrando…',
    saveSuccess: 'Versão registrada.',
    validationVigencia: 'O fim da vigência deve ser igual ou posterior ao início.',
    validationVigenciaObrigatoria: 'Informe o início e o fim da vigência.',
    validationFaixaVazia: 'Adicione ao menos uma faixa.',
    validationParticao: 'As faixas devem começar no volume 1 e ser contínuas, sem gaps.',
    validationUltimaAberta: 'Somente a última faixa pode ter o volume final aberto.',
    validationAgregado: 'O valor da certificação deve ser igual ou maior que o do exame.',
    validationValores: 'Informe valores válidos (iguais ou maiores que zero) em todas as faixas.',
    errorConflict:
      'Já existe uma versão com vigência sobreposta para este banco. Ajuste o período e tente novamente.',
    errorValidation: 'Os dados informados não foram aceitos. Confira as faixas e a vigência.',
    errorNetwork: 'Sem conexão com o servidor. Tente novamente em instantes.',
    errorUnauthorized: 'Você não tem acesso a esta área ou sua sessão expirou.',
    errorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
    errorBancoInexistente:
      'Este banco não está mais disponível. Atualize a página e selecione novamente.',
  },

  upload: {
    pageTitle: 'Nova análise',
    intro:
      'Envie a assinatura padrão (referência) e a assinatura questionada. Aceitamos PNG e JPG até 10 MB cada.',
    referenciaLabel: 'Assinatura padrão',
    referenciaHint: 'Imagem da assinatura de autoria conhecida (referência).',
    questionadaLabel: 'Assinatura questionada',
    questionadaHint: 'Imagem da assinatura sob análise.',
    dropzoneHint: 'Clique ou arraste a imagem aqui',
    dropzoneFormats: 'PNG ou JPG, até 10 MB',
    removeFile: 'Remover imagem',
    submit: 'Iniciar análise',
    submitting: 'Enviando…',
    missingFiles: 'Selecione as duas imagens antes de iniciar a análise.',
  },

  analise: {
    eyebrow: 'PARECER TÉCNICO',
    aprovarParecerKicker: 'APROVAÇÃO DO PERITO',
    pageTitleResultado: 'Resultado da análise',
    pageTitleAnalisando: 'Análise em andamento',
    pageTitleErro: 'Análise não concluída',
    statusPendingMessage: 'Preparando a análise. Isso costuma levar até 30 segundos.',
    statusRunningMessage: 'Comparando as assinaturas e compondo o resultado.',
    statusFailedMessage:
      'Não foi possível concluir esta análise. Volte e tente novamente, ou inicie uma nova análise.',
    imagensSectionTitle: 'Assinaturas analisadas',
    imagemReferenciaLabel: 'Assinatura padrão (referência)',
    imagemQuestionadaLabel: 'Assinatura questionada',
    imagemReferenciaAlt: 'Imagem da assinatura padrão usada como referência da análise',
    imagemQuestionadaAlt: 'Imagem da assinatura questionada submetida pelo perito',
    imagensCarregando: 'Carregando imagem...',
    veredictoSectionTitle: 'Veredicto pericial',
    veredictoLrLabel: 'Razão de verossimilhança (LR)',
    veredictoTipologiaLabel: 'Tipologia provável de fraude',
    hipotesesSectionTitle: 'Hipóteses avaliadas',
    hipoteseH1Label: 'Hipótese H1 — mesmo autor',
    hipoteseH2Label: 'Hipótese H2 — autores diferentes',
    criteriosSectionTitle: 'Critérios avaliados',
    criterioPesoLabel: 'Hierarquia',
    criterioImpactoLabel: 'Impacto',
    criterioRefsLabel: 'Referências bibliográficas',
    criterioEvidenciaLabel: 'Justificativa',
    criterioCoordsLabel: 'Coordenadas da evidência visual',
    aprovarParecer: 'Aprovar parecer',
    aprovarParecerDescricao:
      'Ao aprovar, você confirma este parecer como final. Os ajustes feitos nas marcações visuais não são persistidos nesta versão.',
    aprovarParecerEnviando: 'Registrando aprovação...',
    aprovarParecerErroNotFound: 'Análise não encontrada.',
    aprovarParecerErroNotCompleted:
      'A análise ainda não está concluída — aguarde o término antes de aprovar.',
    aprovarParecerErroAlreadyApproved: 'Esta análise já havia sido aprovada anteriormente.',
    aprovarParecerErroNetwork: 'Sem conexão. Verifique a rede e tente novamente.',
    aprovarParecerErroGeneric: 'Não foi possível registrar a aprovação. Tente novamente.',
    aprovacaoConfirmadaTitulo: 'Parecer aprovado',
    aprovacaoConfirmadaMensagem: 'Parecer aprovado em {{quando}} por {{perito}}.',
    aprovacaoConfirmadaMensagemSemPerito: 'Parecer aprovado em {{quando}}.',
    backToUpload: 'Iniciar nova análise',
    salvandoEdicoes: 'Salvando edições…',
    edicoesSalvas: 'Edições salvas',
    erroSalvarEdicoes: 'Não foi possível salvar as edições. Será tentado novamente.',
    restaurarMarcacoesSistema: 'Restaurar marcações do sistema',
    restaurarMarcacoesEnviando: 'Restaurando…',
  },

  // preAnalise.* -> tela /casos/:id/pre-analise (triagem preliminar, E45.F2).
  // Apoio amigável e PRELIMINAR: indicativo em % + tendência humilde
  // ("indícios de…", nunca conclusão categórica). Nunca substitui o exame
  // pericial nem o laudo.
  preAnalise: {
    pageTitle: 'Análise preliminar',
    pageSubtitle:
      'Uma triagem rápida para decidir se vale seguir para o exame pericial completo ou encerrar por aqui.',
    loading: 'Carregando a triagem…',
    runIntro:
      'Compare a assinatura questionada com os padrões do caso e gere um indicativo preliminar de mesma autoria.',
    runCta: 'Iniciar análise preliminar',
    running: 'Comparando as assinaturas…',
    needsContested:
      'Este caso ainda não tem uma assinatura questionada. Adicione uma para fazer a triagem.',
    needsPattern: 'Adicione ao menos uma assinatura padrão para comparar com a questionada.',
    errorGeneric: 'Não foi possível concluir a análise preliminar. Tente novamente.',
    errorCaseNotFound: 'Caso não encontrado.',
    errorContestedNotFound: 'Assinatura questionada não encontrada neste caso.',
    errorNoApiKey: 'Configure a chave de acesso nas configurações antes de iniciar a triagem.',
    errorInsufficientSignatures:
      'É preciso ao menos uma assinatura padrão e a questionada para comparar.',
    errorContract: 'A análise preliminar não retornou um resultado válido. Tente novamente.',
    errorAssistant:
      'O serviço de análise está indisponível no momento. Tente novamente em instantes.',
    errorInvalidTransition: 'Esta triagem já foi encerrada ou encaminhada.',
    errorNetwork: 'Sem conexão. Verifique a rede e tente novamente.',
    comparacaoSectionTitle: 'Comparação das assinaturas',
    // E67.F1 — o caso tem N questionadas e M padrões. A triagem roda uma vez
    // por questionada, e cada uma delas é comparada com TODOS os padrões (é o
    // que o motor sempre fez; até aqui a tela ilustrava com um só).
    contestadaOrdinal: 'Assinatura questionada {n} de {total}',
    comparacaoPadroesUsados: 'Comparada com os {n} padrões do caso.',
    comparacaoUmPadraoUsado: 'Comparada com o único padrão do caso.',
    padraoExibidoLabel: 'Padrão exibido na comparação',
    padraoOrdinal: 'Padrão {n}',
    portaoTitulo: 'Triagem do caso',
    portaoResumo: '{n} assinaturas questionadas triadas.',
    portaoResumoUma: '1 assinatura questionada triada.',
    // E67.F1.C01 — a decisão é do caso inteiro, então ela só abre com o caso
    // inteiro triado. O rodapé diz o que falta em vez de deixar dois botões
    // desabilitados sem explicação.
    portaoIncompleto:
      '{triadas} de {total} assinaturas questionadas com resultado. Conclua as que faltam para ' +
      'decidir o caso.',
    portaoAguardando: 'Aguarde a conclusão das triagens em andamento para decidir o caso.',
    indicativoSectionTitle: 'Indicativo da triagem',
    indicativoMeterLabel: 'Indicativo de mesma autoria, de 0 a 100',
    heatmapLabel: 'Marcações da análise preliminar sobre a assinatura questionada',
    sinteseSectionTitle: 'Síntese',
    // E54.F6.T02/T04 — legenda da figura e rótulo dos achados da triagem, na
    // prancha 3A. O rótulo é o mesmo da marcação desenhada sobre a assinatura.
    marcacaoConvergencia: 'Convergência',
    marcacaoDivergencia: 'Divergência',
    ctaSeguirMesa: 'Seguir para o exame pericial',
    ctaSeguindo: 'Encaminhando…',
    ctaFinalizar: 'Encerrar na triagem',
    ctaFinalizando: 'Encerrando…',
    // E72.F2 — a terceira saída do portão. O rótulo do botão é o pedido do
    // owner; o DOCUMENTO se identifica como Relatório Preliminar (ADR-0074), e
    // é assim que a ajuda do portão e o estado pós-decisão o chamam.
    ctaGerarRelatorio: 'Gerar laudo',
    ctaGerandoRelatorio: 'Gerando o documento…',
    statusSeguiuMesaMessage: 'Caso encaminhado ao exame pericial completo.',
    statusEncerradaMessage:
      'Caso encerrado na triagem. Este é um resultado preliminar, não pericial.',
    statusEncerradaComRelatorioMessage:
      'Caso encerrado na triagem com relatório preliminar emitido. Este é um resultado ' +
      'preliminar, não pericial.',
    // E72.F2 — estado pós-decisão: o portão some quando não há mais triagem
    // pendente, e é aqui que o documento continua ao alcance.
    desfechoRelatorioTitulo: 'Relatório preliminar emitido',
    desfechoRelatorioTexto:
      'O documento reúne a identificação do caso, o material analisado e a síntese da triagem. ' +
      'Ele não traz exame pericial nem responsável técnico, e pode ser baixado quantas vezes ' +
      'for preciso.',
    ctaBaixarRelatorio: 'Baixar relatório',
    ctaBaixandoRelatorio: 'Preparando o arquivo…',
    errorRelatorioNotReady: 'Este caso não foi encerrado com relatório preliminar.',
    errorRelatorioDownload:
      'Não foi possível preparar o relatório preliminar agora. Tente novamente.',
    shareSectionTitle: 'Resumo compartilhável',
    shareIntro: 'Copie o resumo preliminar para encaminhar ao requerente. Não é um laudo pericial.',
    shareCopyCta: 'Copiar resumo',
    shareCopied: 'Resumo copiado',
    shareableHeader: 'Resultado preliminar de triagem — NÃO é laudo pericial.',
    shareableIndicativoLabel: 'Indicativo de mesma autoria',
    shareableFooter: 'Resultado preliminar; não substitui o exame pericial nem o laudo.',
    gateTitle: 'O que deseja fazer com este caso?',
    // E72.F2 — a ajuda passou a descrever as TRÊS saídas, na ordem em que os
    // botões aparecem. Encerrar sem documento continua sendo uma delas: quem
    // não quer o relatório não é obrigado a gerá-lo.
    gateHelp:
      'A decisão é sua e encerra este passo. Encerrar na triagem registra o resultado ' +
      'preliminar como desfecho, sem documento; gerar o relatório preliminar encerra o caso ' +
      'emitindo um documento em PDF; seguir para o exame pericial aprofunda a análise na mesa ' +
      'de trabalho.',
  },

  caseStepper: {
    ariaLabel: 'Etapas do caso',
    stageCriacao: 'Criação',
    stagePreliminar: 'Análise preliminar',
    stageMesa: 'Mesa',
    stageLaudo: 'Laudo',
    conversa: 'Conversa',
    historico: 'Histórico',
    certificados: 'Certificados e carimbo',
    blockedHint: 'Etapa ainda não alcançada neste caso.',
    // E91.F1 (RF02): disponível e concluída são estados distintos.
    availableHint: 'Etapa disponível. Ainda não concluída.',
  },

  preenchimentoDoCaso: {
    titulo: 'O que os documentos dizem sobre o cadastro',
    intro:
      'Nome, CPF e endereço do signatário lidos dos documentos deste caso. Os campos que estavam vazios são preenchidos no processamento inicial; confira a origem de cada valor e corrija no cadastro o que não conferir.',
    campos: {
      signatario_nome: 'Nome do signatário',
      cpf: 'CPF',
      endereco: 'Endereço',
    },
    origem: 'De onde saiu',
    aplicar: 'Aplicar ao cadastro',
    aplicando: 'Aplicando…',
    aplicado: 'Cadastro atualizado com os valores conferidos.',
    divergenciasTitulo: 'Divergências com o que já está no cadastro',
    divergenciaLinha: 'No cadastro: {cadastro} · Em {documento}: {documento_valor}',
    divergenciaIntro:
      'O cadastro e o documento dizem coisas diferentes. Nada foi alterado: confira qual dos dois está certo.',
    semFonteTitulo: 'Não encontrado em nenhum documento',
    semDocumento:
      'Este caso ainda não tem documentos carregados. Envie-os para que o cadastro possa ser lido deles.',
    nadaAPropor:
      'Os documentos deste caso foram lidos e o cadastro já está de acordo com eles. Nada a propor.',
    carregando: 'Lendo os documentos do caso…',
    erroCarregar: 'Não foi possível ler os documentos do caso agora.',
    erroAplicar: 'Não foi possível gravar o cadastro. Tente de novo.',
    // E91.F2 (GUS-51 RF03): a seção fica recolhida atrás de uma linha; a
    // divergência que afeta o exame fica VISÍVEL nessa linha, sem abrir nada.
    secaoTitulo: 'Cadastro do caso',
    resumoLendo: 'Lendo os documentos…',
    resumoIndisponivel: 'Leitura dos documentos indisponível',
    resumoDivergencias: '{n} divergências entre o cadastro e os documentos',
    resumoDivergenciaUma: '1 divergência entre o cadastro e os documentos',
    resumoPropostas: '{n} dados lidos dos documentos, a conferir',
    resumoPropostaUma: '1 dado lido dos documentos, a conferir',
    resumoEmDia: 'Cadastro de acordo com os documentos',
    resumoSemDocumento: 'Sem documentos para ler o cadastro',
  },

  // E98.F5 (ADR-0083 §2.6): CNH, nota fiscal, fatura e extrato. A leitura PROPÕE os
  // campos; nada entra no exame até o perito conferir e confirmar.
  documentosDeApoio: {
    secaoTitulo: 'Documentos de apoio',
    abrir: 'Conferir documentos de apoio',
    // E106.F3: no consignado do arquivo único, só a identidade entra no exame.
    // E109.F1: no pacote do banco (ou com imagem solta), as imagens do material recebido.
    resumoLendo: 'Carregando os documentos…',
    resumoIndisponivel: 'Documentos de apoio indisponíveis',
    resumoVazio: 'Nenhum documento de apoio no caso',
    resumoTotal: '{n} documentos de apoio',
    resumoTotalUm: '1 documento de apoio',
    resumoEmDia: '{n} leituras confirmadas',
    resumoEmDiaUma: '1 leitura confirmada',
    carregando: 'Carregando os documentos de apoio…',
    erroCarregar: 'Não foi possível carregar os documentos de apoio agora.',
    vazio:
      'Nenhum documento deste caso é documento de apoio. Envie a CNH, o CRLV, a nota fiscal, a fatura ou o extrato em Adicionar documentos.',
    // E101.F4: o identificador que cada página do documento do contrato imprime no topo.
    identificadoresDica:
      'Um identificador por página, na ordem das páginas, separados por espaço. Confira cada um no topo da página.',
    tipo: 'Tipo do documento',
    tipoEscolher: 'Escolha o tipo',
    sugerido: 'O documento parece ser: {tipo}',
    ler: 'Ler o documento',
    lendo: 'Lendo o documento…',
    origem: {
      camada_de_texto: 'Campos lidos do texto do documento. Confira cada um antes de confirmar.',
      leitura_optica:
        'Campos lidos da imagem do documento. Confira cada um com o arquivo antes de confirmar.',
      digitada: 'Nada foi lido deste documento. Preencha os campos a partir do arquivo.',
    },
    abrirArquivo: 'Abrir o arquivo',
    confirmar: 'Confirmar leitura',
    confirmando: 'Confirmando…',
    confirmadaEm: 'Leitura confirmada em {data}',
    confirmadaAgora: 'Leitura confirmada. O exame do caso será atualizado.',
    concluido: 'O exame deste documento foi concluído; a leitura não muda mais.',
    erroLer: 'Não foi possível ler o documento agora. Preencha os campos a partir do arquivo.',
    erroConfirmar: 'Não foi possível confirmar a leitura. Tente de novo.',
    erroForma:
      'Algum campo não está na forma esperada (CPF, CNPJ, chave de acesso, chassi, CEP ou data). Corrija e confirme de novo.',
    erroNaoEDeApoio:
      'Este documento foi identificado como documento do contrato e não pode ser conferido como documento de apoio.',
    // E111.F1 (S-08, N-14): tirar a imagem da análise é ação própria, com motivo e registro.
    exclusao: {
      excluir: 'Excluir da análise',
      ajuda:
        'Use só quando a imagem não deve entrar no exame (por exemplo, repetida ou ilegível). O relatório imprime a data, a hora e o motivo.',
      motivo: 'Motivo da exclusão',
      motivoDica: 'Obrigatório. Aparece no relatório como foi escrito.',
      confirmar: 'Confirmar exclusão',
      confirmando: 'Excluindo…',
      cancelar: 'Cancelar',
      registrada: 'Excluída da análise em {data}. Motivo: {motivo}',
      desfazer: 'Desfazer exclusão',
      desfazendo: 'Desfazendo…',
      excluidaAgora: 'Imagem excluída da análise. O exame do caso será atualizado.',
      desfeitaAgora: 'A imagem voltou à análise e precisa da leitura confirmada.',
      erroMotivo: 'Escreva o motivo, com pelo menos 3 caracteres.',
      erroFotoDoCaso:
        'Esta imagem é a origem de uma foto do signatário. Remova a foto na galeria antes de excluí-la.',
      erroNaoEImagem: 'Só imagens do material recebido podem ser excluídas da análise.',
      erro: 'Não foi possível concluir a exclusão. Tente de novo.',
    },
    campos: {
      nome: 'Nome',
      cpf: 'CPF',
      nascimento: 'Data de nascimento',
      registro: 'Número de registro',
      emitido_em: 'Data de emissão',
      valido_ate: 'Validade',
      filiacao: 'Filiação',
      documento_de_identidade: 'Documento de identidade (impresso na CNH)',
      documento_de_origem: 'Documento de origem (certidão citada no RG)',
      orgao_expedidor: 'Órgão expedidor',
      naturalidade: 'Naturalidade',
      chave_de_acesso: 'Chave de acesso',
      numero: 'Número do documento',
      emitida_em: 'Data de emissão',
      emitente: 'Emitente',
      emitente_cnpj: 'CNPJ do emitente',
      destinatario: 'Destinatário',
      destinatario_documento: 'CPF ou CNPJ do destinatário',
      valor_total: 'Valor total (R$)',
      chassi: 'Chassi',
      marca_e_versao: 'Veículo (marca e versão)',
      cor: 'Cor',
      ano_fabricacao: 'Ano de fabricação',
      ano_mod: 'Ano (mod.)',
      alienacao_fiduciaria_em_favor_de: 'Alienação fiduciária em favor de',
      titular: 'Titular',
      endereco: 'Endereço',
      cep: 'CEP',
      agencia: 'Agência',
      conta: 'Conta',
      // E101.F4: o CRLV, a fotografia do veículo e os documentos do contrato lidos por imagem.
      placa: 'Placa',
      renavam: 'RENAVAM',
      combustivel: 'Combustível',
      proprietario: 'Proprietário',
      proprietario_documento: 'CPF ou CNPJ do proprietário',
      local: 'Local',
      tirada_em: 'Data impressa na fotografia',
      hora: 'Hora impressa na fotografia',
      marca: 'Marca',
      versao: 'Versão do veículo',
      valor: 'Valor do veículo (R$)',
      identificadores: 'Identificador de cada página',
    },
  },

  analiseFotografica: {
    // E123.F3 (GUS-128): a página da etapa saiu da esteira; o que segue são as candidatas, abertas
    // em "Trocar fotos" na pré-análise.
    candidatas: {
      titulo: 'Imagens encontradas nos documentos',
      intro: 'Nada entra no caso sem a sua confirmação.',
      ajudaTitulo: 'Como as imagens são escolhidas',
      ajudaTexto:
        'São as imagens embutidas nos documentos do caso, das maiores para as menores. Selos, ícones e códigos pequenos ficam de fora.',
      proveniencia: 'De onde saiu',
      provenienciaComPagina: (documento: string, pagina: number): string =>
        `${documento}, página ${pagina}`,
      tamanho: (largura: number, altura: number): string => `${largura} × ${altura}`,
      usarComo: 'Usar esta imagem como',
      usarComoIdentidade: 'Fotografia do documento de identidade',
      usarComoCcb: 'Selfie/FotoDocContrato da formalização',
      confirmando: 'Confirmando…',
      confirmada: 'Imagem confirmada e adicionada ao caso.',
      // E191.F1 (GT-2026-0030): o perito pede a leitura dos dados de uma imagem de documento.
      lerDocumento: 'Ler os dados deste documento',
      lendoDocumento: 'Pedindo a leitura…',
      leituraPedida:
        'Leitura pedida. Os dados lidos aparecem em instantes em "Dados lidos do documento", para você conferir e confirmar.',
      // E123.F3 ("Trocar fotos"): a candidata que é a fotografia escolhida agora para um grupo.
      emUso: (grupo: string): string => `Em uso: ${grupo}`,
      // E109.F1 (S-08): a imagem que não é retrato sai das propostas. E111.F1: só isso — a
      // leitura de apoio continua exigida; tirar da análise é outra ação.
      excluir: 'Não é fotografia de referência',
      excluindo: 'Retirando…',
      excluida:
        'Imagem retirada das propostas de fotografia de referência. Ela continua no material e, se for de documento, a leitura dos dados é proposta aqui para você conferir e confirmar.',
      // E114.F3 (R-05): a leitura proposta da imagem de documento, confirmada no próprio cartão.
      leitura: {
        titulo: 'Dados lidos do documento',
        intro:
          'Confira os dados abaixo contra a imagem. Confirmados, eles entram na conferência de identidade; para corrigir algum campo, use Documentos de apoio na pré-análise.',
        confirmar: 'Confirmar leitura',
        confirmando: 'Confirmando…',
        confirmada: 'Leitura confirmada',
        // E118.F1 (GUS-127): corroborada entra no documento sem clique; pendente fica fora dele.
        corroborada: 'Corroborada pelo cadastro (nome e CPF)',
        pendenteNaoConfere:
          'Leitura proposta aguarda sua confirmação: nome ou CPF não conferem com o cadastro. Sem confirmação, os dados dela não entram no documento.',
        pendenteSemDados:
          'Leitura proposta aguarda sua confirmação: sem nome e CPF lidos. Sem confirmação, os dados dela não entram no documento.',
        pendentesContador: '{n} leituras aguardam confirmação',
        pendentesContadorUm: '1 leitura aguarda confirmação',
        erro: 'Não foi possível confirmar a leitura agora. Tente de novo.',
        retiradasTitulo: 'Imagens de documento retiradas das propostas de fotografia de referência',
        // E114.F3.C02 (F-E114.F3-04): a leitura roda em segundo plano; a tela espera por ela.
        emCurso:
          'Lendo os dados das imagens de documento. A leitura proposta aparece aqui assim que terminar.',
        campos: {
          nome: 'Nome',
          cpf: 'CPF',
          registro: 'Registro geral',
          nascimento: 'Nascimento',
          emitido_em: 'Expedição',
          filiacao: 'Filiação',
          naturalidade: 'Naturalidade',
          orgao_expedidor: 'Órgão expedidor',
          documento_de_origem: 'Documento de origem',
        },
      },
      // E162.F1.T08 (ADR-0111 §2.4, QA-25): a imagem de documento sem vínculo demonstrado com o
      // contrato e a pessoa do caso fica proposta e marcada; não é escolhida sozinha e não corrobora.
      vinculo: {
        semVinculo: 'Sem vínculo demonstrado com este caso',
        motivo: {
          outro_contrato: 'o documento traz a chave de outro contrato',
          outra_pessoa: 'o documento identifica outra pessoa',
          nenhum: 'o documento não identifica a pessoa nem o contrato do caso',
        },
        efeito:
          'Esta imagem não é escolhida automaticamente. Se você a confirmar, a conferência facial fica registrada no laudo, marcada, e não corrobora a autoria do ato.',
      },
      // E122.F2 (ADR-0079 E.23): a classe lida de cada imagem agrupa a lista; a confirmação
      // automática entra sem clique e é dita no cartão.
      classificando:
        'Organizando as imagens encontradas por tipo. A lista se atualiza sozinha em instantes.',
      grupos: {
        identidade_frente: 'Fotografia do documento de identidade',
        retrato: 'Fotografia do titular',
        identidade_verso: 'Verso do documento de identidade',
        outras: 'Outras imagens',
        semClasse: 'Imagens ainda sem tipo',
        outrasResumo: (n: number): string =>
          n === 1
            ? '1 imagem sem fotografia nem documento'
            : `${n} imagens sem fotografia nem documento`,
      },
      classe: {
        identidade_frente: 'Documento de identidade (frente)',
        identidade_verso: 'Documento de identidade (verso)',
        retrato: 'Fotografia do titular',
        outra: 'Outra imagem',
      },
      sugerida: 'Sugestão: ',
      confirmadaAutomaticamente:
        'Confirmada automaticamente: era a única imagem clara deste tipo. Para trocar, remova-a na galeria de fotos.',
      semImagem:
        'Nenhuma imagem aproveitável foi encontrada nos documentos deste caso. A análise segue normalmente sem ela.',
      semDocumento:
        'Este caso ainda não tem documentos carregados. Envie-os na criação do caso para que as imagens possam ser procuradas.',
      carregando: 'Procurando imagens nos documentos…',
      erroCarregar: 'Não foi possível procurar as imagens nos documentos agora.',
      erros: {
        candidata_nao_encontrada:
          'Esta imagem não está mais disponível no documento. Recarregue a etapa.',
        candidata_ja_confirmada:
          'Esta imagem já foi adicionada ao caso como foto. Remova-a da galeria de fotos antes de excluí-la.',
        generico: 'Não foi possível concluir a ação. Tente de novo.',
      },
    },
  },

  criterio: {
    nome: {
      calibre: 'Calibre',
      inclinacao: 'Inclinação axial',
      proporcionalidade: 'Proporcionalidade',
      espacamento: 'Espaçamento',
      velocidade: 'Velocidade do traçado',
      pressao: 'Pressão',
      ataque: 'Ataque e remate',
      minimos: 'Mínimos gráficos',
      gestos: 'Gestos característicos',
      forma: 'Forma global',
    },
    status: {
      convergent: 'Convergente',
      divergent: 'Divergente',
      neutral: 'Neutra',
      inconclusive: 'Inconclusiva',
    },
    weight: {
      genetic: 'Genética',
      generic: 'Genérica',
    },
    impact: {
      alto: 'Alto',
      medio: 'Médio',
      baixo: 'Baixo',
    },
  },

  lr: {
    h1_muito_forte: 'Suporte muito forte para mesmo autor',
    h1_forte: 'Suporte forte para mesmo autor',
    h1_moderado: 'Suporte moderado para mesmo autor',
    h1_limitado: 'Suporte limitado para mesmo autor',
    h1_fraco: 'Suporte fraco para mesmo autor',
    inconclusivo: 'Inconclusivo',
    h2_fraco: 'Suporte fraco para autores diferentes',
    h2_limitado: 'Suporte limitado para autores diferentes',
    h2_moderado: 'Suporte moderado para autores diferentes',
    h2_forte: 'Suporte forte para autores diferentes',
    h2_muito_forte: 'Suporte muito forte para autores diferentes',
  },

  fraude: {
    imitacao_livre: 'Imitação livre',
    imitacao_servil: 'Imitação servil',
    falsificacao_exercitada: 'Falsificação exercitada',
    decalque_direto: 'Decalque direto',
    decalque_indireto: 'Decalque indireto',
    disfarce_proprio: 'Disfarce próprio (autofalsificação)',
    imitacao_memoria: 'Imitação por memória',
    hibridismo: 'Hibridismo',
    indeterminada: 'Tipologia indeterminada — análise não identificou padrão específico',
  },

  routes: {
    home: { title: 'Início' },
    login: { title: 'Entrar' },
    signup: { title: 'Criar conta' },
    upload: { title: 'Nova análise' },
    analise: { title: 'Análise' },
    dossie: { title: 'Dossiê' },
    config: { title: 'Configurações' },
    apiKeys: { title: 'Chaves de acesso' },
    members: { title: 'Usuários do escritório' },
    escritorio: { title: 'Dados do escritório' },
    perfil: { title: 'Seu perfil' },
    trocaDeSenha: { title: 'Defina uma senha sua' },
    onboarding: { title: 'Bem-vindo ao escritório' },
    casos: { title: 'Casos periciais' },
    novoCaso: { title: 'Novo caso' },
    casoWizard: { title: 'Envio de documentos' },
    casoWorkspace: { title: 'Mesa de análise pericial' },
    casoLaudo: { title: 'Laudo grafoscópico' },
  },

  shell: {
    brand: 'SignCheck',
    brandKicker: 'Perícia documental',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    agentOnline: 'Análise online',
    crumbHome: 'Painel',
    // E57.F2 (ADR-0066): o contexto de banco da sessão. "Carteira" é o termo
    // que o owner usa para o conjunto de casos de um banco — e não é termo
    // técnico nem de fornecedor.
    bancoAtivo: {
      label: 'Carteira ativa',
      placeholder: 'Selecione a carteira',
      semContexto: 'Escolha a carteira para ver os casos vinculados a ela.',
    },
    sidebar: {
      sectionMain: 'Atalhos',
      sectionWork: 'Trabalho',
      sectionAdmin: 'Administração',
      sectionPlataforma: 'Plataforma',
      casos: 'Casos',
      // E163.F3 (GUS-209 A67-18, ADR-0112 §5): os nomes da navegação do papel no HTML 6.7.
      novoCaso: 'Enviar documentos',
      perfil: 'Meu perfil',
      config: 'Configurações',
      precificacao: 'Configuração comercial',
      adminClientes: 'Clientes',
      adminUsuarios: 'Usuários',
      adminTrilha: 'Trilha de auditoria',
      certificacao: 'Certificação',
      userAnonymous: 'Sessão',
      // E205.F1.T05 (ADR-0147 §8): na mesa a barra abre recolhida, só com os ícones.
      recolher: 'Recolher a barra lateral',
      expandir: 'Expandir a barra lateral',
    },
    footer: {
      copyright: 'Sistema de análise de assinaturas',
      version: 'Versão',
    },
  },

  placeholder: {
    eyebrow: 'EM CONSTRUÇÃO',
    underConstruction: 'Este conteúdo será preenchido em uma próxima entrega.',
  },

  esteiraPortal: {
    title: 'Casos do portal',
    subtitle: 'Casos de escritórios-cliente atendidos pela equipe.',
    tabFila: 'Certificações requeridas',
    tabTodos: 'Todos do portal',
    colCodigo: 'Código',
    colEscritorio: 'Escritório',
    colProcesso: 'Processo',
    colCaso: 'Caso',
    colCertificacoes: 'Certificações',
    colPrazo: 'Prazo',
    vazioFila: 'Nenhuma certificação requerida no momento.',
    vazioTodos: 'Nenhum caso do portal até agora.',
    erroCarregar: 'Não foi possível carregar os casos do portal. Tente novamente.',
    prazoEstourado: 'Prazo estourado',
    carregando: 'Carregando casos do portal…',
  },

  casos: {
    eyebrow: 'Painel do perito',
    pageTitle: 'Casos periciais',
    subtitleTemplate:
      '{{ativos}} ATIVOS · {{aguardamPrazo}} AGUARDAM PRAZO · {{conflito}} CONFLITO ABERTO',
    novoCaso: '+ Novo caso',
    emptyTitle: 'Nenhum caso ainda',
    emptyDescription: 'Clique em + Novo caso para começar.',
    loading: 'Carregando casos…',
    errorLoad: 'Não foi possível carregar a lista de casos. Tente novamente.',
    // Owner, 04/11: a lista da equipe por pasta, como a do portal — uma linha por pasta, que abre
    // na própria lista com os casos e as CCBs dela (a tabela de sempre).
    pastas: {
      colPasta: 'Pasta',
      colProcesso: 'Processo',
      colTitular: 'Titular',
      colCasos: 'Casos e CCBs',
      colSituacao: 'Situação',
      colPrazo: 'Prazo',
      semPasta: 'Sem pasta informada',
      naoInformado: 'Não informado',
      titularesMais: '{titular} e mais {n}',
      casoUm: '1 caso',
      casos: '{n} casos',
      ccbUma: '1 CCB',
      ccbs: '{n} CCBs',
      pastaUma: '1 pasta',
      pastas: '{n} pastas',
      situacaoNaPasta: '{situacao}: {n}',
      casosDaPasta: 'Casos da pasta {pasta}',
    },
    tableColumnNumero: 'Nº',
    tableColumnCaso: 'Caso · solicitante',
    tableColumnEspecime: 'Espécime',
    tableColumnPadroes: 'Padrões',
    tableColumnLr: 'LR atual',
    tableColumnStatus: 'Status',
    tableColumnPrazo: 'Prazo',
    tableColumnAssinatura: 'Assinatura',
    tableColumnCadastro: 'Cadastro',
    placeholderEmDash: '—',
    padroesPlaceholder: 'n = 0',
    semData: '—',
    kpiCasosNoMes: 'Casos no mês',
    kpiTempoMedio: 'Tempo médio de análise',
    kpiLrAutoria: 'LR > 100 (autoria)',
    kpiLrHeteroautoria: 'LR < 0,01 (heteroaut.)',
    statusDraft: 'Rascunho',
    // E209.F2.T03 (GUS-296 item 5f): o caso ainda `draft` com a preparação já pedida.
    statusEnviado: 'Enviado',
    statusAnalysing: 'Em análise',
    statusDone: 'Concluído',
    statusConflict: 'Conflito',
    statusFinalizado: 'Finalizado',
    // E45.F2 — caso encerrado na triagem (resultado preliminar).
    statusEncerradoTriagem: 'Encerrado na triagem',
    // E72.F2 — encerrado na triagem COM o relatório preliminar emitido. Rótulo
    // próprio: é o único desfecho da triagem que tem documento para baixar.
    statusEncerradoComRelatorio: 'Encerrado com relatório',
    // E72.F2.T00 — recuo para situação que este bundle não conhece (backend à
    // frente do navegador). Neutro e sem código cru; ver `derivedUiStatus`.
    statusIndefinido: 'Situação não identificada',
    // E23.F24 — escada de status do fluxo do laudo.
    statusLaudoEmElaboracao: 'Laudo em elaboração',
    // E78.F1 — raia de assinatura eletrônica com todas as peças concluídas.
    // Rótulo próprio porque aqui não há narrativa a aprovar: o caso já tem
    // laudo, e "Laudo em elaboração" mandava o perito procurar trabalho que
    // não existia.
    statusEletronicaConcluida: 'Concluído · aguardando assinatura',
    // E224.F1 (owner, 05/11): requisição entregue e nenhuma pendente.
    statusAssinado: 'Assinado',
    statusCancelado: 'Cancelado',
    statusAguardandoArquivos: 'Aguardando arquivos',
    statusAguardandoRevisor: 'Aguardando revisor',
    statusDevolvidoRevisor: 'Devolvido pelo revisor',
    reviewFilterMyReview: 'Aguardando minha homologação',
    // E140.F3 (GUS-143): a leitura em conferência na lista de casos.
    leituraEmConferenciaFiltro: 'Leitura em conferência',
    leituraEmConferenciaMarca: 'Leitura em conferência',
    novoCasoEyebrow: 'Cadastro de caso',
    novoCasoPageTitle: 'Novo caso pericial',
    novoCasoIntro:
      'Preencha os dados administrativos do caso. Os padrões e a contestada serão anexados na próxima etapa.',
    // E82.F1 (GUS-26): a importação passou a aceitar quatro formatos. As strings
    // deixaram de prometer .docx — o rótulo do botão dizia o formato e virava
    // mentira no primeiro PDF aceito.
    importCcbButton: 'Importar CCB',
    importCcbHint:
      'Preenche os campos a partir de uma CCB em .docx, PDF, JPG ou PNG e a anexa como contestada. Revise antes de salvar.',
    importCcbLoading: 'Lendo a CCB…',
    importCcbSuccess: 'Campos pré-preenchidos a partir da CCB. Revise e ajuste antes de salvar.',
    importCcbErrorMime: 'Selecione um arquivo em .docx, PDF, JPG ou PNG.',
    importCcbErrorUnreadable:
      'Não foi possível ler este arquivo. Verifique se é uma CCB em .docx, PDF, JPG ou PNG válida.',
    importCcbErrorGeneric: 'Não foi possível importar a CCB. Tente novamente.',
    importCcbSbrLabel: 'Identificação/SBR detectada na CCB:',
    // E82.F1.C03 (F-E82.F1-03): o rótulo dizia 'CCB anexada:' antes de existir
    // caso — a leitura é stateless e o anexo só acontece depois que o caso é
    // criado. Se o perito desistir ou o envio falhar, nada foi anexado.
    importCcbFileLabel: 'Arquivo selecionado:',
    importCcbAttachFailedTitle: 'CCB não anexada automaticamente',
    importCcbAttachFailed:
      'O caso foi criado, mas não foi possível anexar a CCB automaticamente. Anexe-a na próxima etapa.',
    // E56.F3.T02: o importar CCB virou uma área própria dentro do formulário —
    // antes era um botão solto no canto do cabeçalho, desligado dos campos que
    // ele preenche.
    importCcbSectionTitle: 'Importar CCB',
    importCcbEmptyHint:
      'Tem a CCB em .docx, PDF, JPG ou PNG? Ela preenche os campos abaixo e já entra como documento contestado do caso.',
    importCcbReplace: 'Trocar arquivo',
    importCcbRetry: 'Tentar novamente',
    importCcbNoSbr: 'Nenhuma identificação/SBR encontrada no documento.',
    // E82.F1: o arquivo foi ACEITO e mesmo assim nada foi lido dele. É diferente
    // de "li o documento e nenhum rótulo casou": aqui não há texto no arquivo, e
    // insistir com outro .docx da mesma CCB é o conselho útil.
    // E82.F1.C03: o texto estava no pretérito ('foi anexado ao caso') num ponto
    // do fluxo em que não há caso nenhum. O anexo é uma promessa até o submit.
    importCcbSemTextoTitulo: 'Arquivo selecionado, campos não preenchidos',
    importCcbSemTexto:
      'Este arquivo é uma imagem do documento, sem texto que possa ser lido. Ele será anexado ao caso quando você criá-lo; preencha os campos abaixo à mão, ou importe a mesma CCB em .docx ou em PDF com texto.',
    // E56.F3.T03: o cadastro longo virou um bloco recolhido — criar um caso
    // volta a ser uma ação curta, e nenhum campo saiu do formulário.
    sectionMaisDetalhes: 'Mais detalhes',
    sectionMaisDetalhesHint:
      'Solicitante, processo, espécime, contratante e partes. Opcionais — e já vêm preenchidos quando a CCB é importada.',
    maisDetalhesShow: 'Abrir',
    maisDetalhesHide: 'Recolher',
    fieldTitle: 'Título do caso',
    fieldRequester: 'Órgão solicitante',
    fieldProcessNumber: 'Nº do processo',
    fieldEspecime: 'Espécime',
    fieldParties: 'Partes envolvidas',
    // E163.F1 (GUS-203, ADR-0112): o recebimento e a data do ato em campos e rótulos próprios.
    fieldReceivedAt: 'Data de recebimento',
    fieldDataDoAto: 'Data do ato (assinatura do documento)',
    fieldDataDoAtoHint: 'Opcional. Sem ela, o laudo diz que a data não foi informada.',
    fieldDeadline: 'Prazo (opcional)',
    // E126.F2 (GUS-105): o CPF deixou de ser obrigatório (a GUS-27 é substituída) —
    // vem dos arquivos do caso; o campo segue na identificação para conferência.
    fieldCpf: 'CPF',
    fieldCpfHint:
      'Vem dos arquivos do caso quando localizado. Com ou sem máscara (ex.: 000.000.000-00).',
    fieldContrato: 'Contrato (opcional)',
    fieldContratoHint: 'Identificador livre do contrato/processo bancário.',
    // E88.F1 (GUS-30 RF01/CA01): o endereço do signatário, que os documentos do
    // caso trazem e que não tinha onde ser guardado.
    fieldEndereco: 'Endereço do signatário',
    fieldEnderecoHint: 'Como aparece nos documentos do caso. Opcional.',
    // E74.F1 (ADR-0075 §1) — modalidade do caso, escolhida na criação.
    fieldModalidade: 'Modalidade da análise',
    fieldModalidadeHint: 'Definida na criação do caso e não muda depois.',
    fieldModalidadeBloqueadaHint: 'A modalidade foi definida na criação do caso e não muda.',
    modalidadeGrafotecnica: 'Análise grafotécnica',
    modalidadeEletronica: 'Análise de assinatura eletrônica',
    errorInvalidCpf: 'CPF inválido. Use apenas dígitos, pontos e hífen.',
    sectionIdentificacao: 'Identificação do caso',
    sectionDatas: 'Datas',
    sectionContratante: 'Contratante (opcional)',
    especimeNaoInformado: 'Não informado',
    especimeCcb: 'Análise do CCB',
    especimeContrato: 'Contrato',
    especimeCheque: 'Cheque',
    especimeProcuracao: 'Procuração',
    especimeTestamento: 'Testamento',
    especimeAval: 'Aval em nota promissória',
    especimeQuitacao: 'Termo de quitação',
    especimeEndosso: 'Endosso',
    especimeOutro: 'Outro',
    submit: 'Salvar e continuar',
    submitting: 'Salvando…',
    cancel: 'Cancelar',
    errorInvalidCnj: 'Número de processo inválido. Use o formato CNJ ou —.',
    errorDeadlineBeforeReceived: 'O prazo deve ser igual ou posterior à data de recebimento.',
    errorMissingTitle: 'Informe o título do caso.',
    errorMissingReceivedAt: 'Informe a data de recebimento.',
    errorValidation: 'Verifique os campos destacados antes de continuar.',
    errorNetwork: 'Sem conexão. Verifique sua rede e tente novamente.',
    errorGeneric: 'Não foi possível salvar o caso. Tente novamente.',
    search: {
      cpfLabel: 'Buscar por CPF',
      cpfPlaceholder: '000.000.000-00',
      contratoLabel: 'Buscar por contrato',
      contratoPlaceholder: 'Início do número/identificador',
      processoLabel: 'Buscar por processo ou pasta',
      processoPlaceholder: 'Nº do processo ou pasta',
      processoChip: 'Processo ou pasta',
      clearAria: 'Limpar busca',
    },
    filters: {
      statusLabel: 'Status',
      statusPlaceholderNone: 'Todos os status',
      statusPlaceholderMany: '{{count}} selecionados',
      especimeLabel: 'Espécime',
      especimePlaceholder: 'Todos os espécimes',
      dateFromLabel: 'De (recebimento)',
      dateToLabel: 'Até (recebimento)',
      activeChipsLabel: 'Filtros ativos',
      removeChipAria: 'Remover filtro: {{label}}',
      clearAll: 'Limpar filtros',
      statusOpen: 'Abrir seleção de status',
    },
    emptyFiltered: {
      title: 'Nenhum caso com os filtros aplicados',
      description: 'Ajuste ou remova filtros para ver mais casos.',
      cta: 'Limpar filtros',
    },
    table: {
      columnUpdated: 'Atualizado em',
      columnActions: 'Ações',
      rowActionsAria: 'Ações do caso {{display_code}}',
      actionOpen: 'Abrir',
      actionPreAnalise: 'Análise preliminar',
      // E72.F2 — só aparece no caso encerrado com relatório preliminar.
      actionBaixarRelatorio: 'Baixar relatório preliminar',
      actionBaixandoRelatorio: 'Preparando o arquivo…',
      // E60.F3 — o rótulo descreve a AÇÃO, não o estado.
      actionPriorizar: 'Priorizar caso',
      actionRemoverPrioridade: 'Remover prioridade',
      prioritarioBadge: 'Prioritário',
      prioritarioTooltip: 'Puxado para a frente da esteira em {{data}}.',
      prioridadeErro: 'Não foi possível alterar a prioridade. Tente novamente.',
    },
    export: {
      button: 'Exportar planilha',
      exporting: 'Gerando planilha…',
      error: 'Não foi possível gerar a planilha. Tente novamente.',
    },
    pagination: {
      pageLabel: 'Página',
      sizeLabel: 'Resultados por página',
      first: 'Primeira',
      prev: 'Anterior',
      next: 'Próxima',
      last: 'Última',
      summary: '{{start}}-{{end}} de {{total}}',
    },
    draftSubmit: 'Salvar como rascunho',
    draftSubmitting: 'Salvando rascunho…',
    datepicker: {
      today: 'Hoje',
      plus7: '+7 dias',
      plus30: '+30 dias',
      clear: 'Limpar',
    },
  },

  wizard: {
    eyebrow: 'Preparação do caso',
    pageTitle: 'Envio de documentos',
    pageIntro:
      'Anexe os documentos em duas etapas: primeiro os documentos padrão (confrontados), depois os questionados (contestados). O sistema processa cada documento e libera a próxima etapa quando termina.',
    // E78.F1 — modalidade eletrônica: sem confronto visual e sem recorte.
    // E91.F3 (GUS-51 RF06): uma instrução por ação, e a ação final nomeia a etapa
    // seguinte — desde a E123.F3, a análise preliminar (a fotográfica saiu da esteira).
    pageIntroEletronica: 'Envie os documentos e o protocolo de assinatura.',
    stepCase: 'Caso',
    stepConfrontadas: 'Confrontadas',
    stepReviewConfrontadas: 'Revisar confrontadas',
    stepContestadas: 'Contestadas',
    // E82.F7.T02 — na modalidade eletrônica o passo 2 recebe manifesto,
    // comprovante e demais peças do caso, não só a contestada.
    stepContestadasEletronica: 'Outros documentos',
    stepReviewContestadas: 'Revisar contestadas',
    actionPrevious: 'Voltar',
    actionNext: 'Avançar',
    actionFinish: 'Concluir e ir para análise',
    actionFinishEletronica: 'Concluir e ir para a análise preliminar',
    stepperAriaLabel: 'Etapas do envio de documentos',
    // E78.F1 — único bloqueio possível na modalidade eletrônica.
    advanceBlockedPecasEletronica: 'Anexe ao menos um documento para avançar.',
    stepperLockedTooltip: 'Conclua a etapa atual antes de avançar.',
    dropzoneFormatsBadge: 'PDF · DOCX · JPG · PNG',
    // E107.F1: no caso eletrônico, também o pacote do banco e as duas evidências dele; os registros
    // da jornada (E156.F1). E209.F2.T04 (GUS-296 item 5h): os formatos de `ACCEPT_ELETRONICA`, sem
    // "PLANILHAS" e sem .xls.
    dropzoneFormatsBadgeEletronica:
      'PDF · DOCX · JPG · PNG · ZIP · JSON · TST · XLSX · CSV · TXT · LOG',
    dropzoneSizeBadge: 'Até 50 MB por arquivo',
    fileListThumbAria: 'Pré-visualização do arquivo {{name}}',
    fileListStatusEnviando: 'Enviando',
    fileListStatusOcr: 'OCR',
    fileListStatusRecortando: 'Recortando',
    fileListStatusPronto: 'Pronto',
    fileListStatusErro: 'Erro',
    // E23.F13: metadados do documento exibidos na lista.
    docMetaAuthor: 'Autor',
    docMetaCpf: 'CPF',
    docMetaProcess: 'Processo nº',
    docMetaDefendant: 'Parte contrária',
    docMetaContract: 'Contrato',
    docMetaSbr: 'Identificação',
    reviewRenameAction: 'Renomear',
    // E23.F26 (ADR-0033): incluir/descartar/ajustar migraram para os controles
    // ancorados na própria região (ver `extraction.box*`); o modal de ajuste por
    // coordenadas foi removido em favor do ajuste inline na box.
    reviewMarkConfrontadaAction: 'É referência (confrontada)',
    reviewMarkConfrontadaHint:
      'Marque quando esta assinatura da CCB for um padrão de confronto, não a questionada.',
    reviewErrorCardTitle: 'Falha ao extrair as assinaturas',
    reviewErrorRetry: 'Tentar de novo',
    confrontadasKicker: 'Passo 2 · Documentos padrão',
    confrontadasTitle: 'Documentos padrão (confrontados)',
    confrontadasIntro:
      'Anexe RG, procuração, ficha cadastral ou outro material com assinatura de referência. Aceita PDF, DOCX, JPG e PNG.',
    contestadasKicker: 'Passo 4 · Documentos questionados',
    contestadasTitle: 'Documentos questionados (contestados)',
    contestadasIntro:
      'Anexe CCB, contrato ou outro documento com a assinatura questionada. Aceita PDF, DOCX, JPG e PNG.',
    // E78.F1 — modalidade de assinatura eletrônica: esta é a única etapa de
    // documento, e não há recorte nem peça de referência a mencionar.
    contestadasKickerEletronica: 'Passo 2 · Documentos do caso',
    // E82.F7.T02 (pedido do owner em 2026-09-11, revendo a decisão de
    // 2026-09-10): o passo recebe manifesto, comprovante e demais peças do caso.
    contestadasTitleEletronica: 'Outros documentos (manifesto, caso…)',
    contestadasIntroEletronica:
      'Anexe a CCB, o manifesto ou comprovante da plataforma e os demais documentos do caso, exatamente como recebidos. Aceita PDF, DOCX, JPG, PNG, ZIP, as evidências da plataforma (JSON e TST) e os registros da jornada (XLSX, CSV, TXT e LOG).',
    dropzoneTitle: 'Arraste arquivos aqui',
    dropzoneSubtitle: 'ou clique para selecionar do disco',
    dropzoneHint: 'PDF, DOCX, JPG ou PNG · até 50 MB cada · vários por vez',
    dropzoneTooLarge: 'Arquivo passa do tamanho máximo (50 MB).',
    documentsListEmpty: 'Nenhum documento anexado ainda.',
    statusPending: 'Aguardando processamento…',
    statusProcessing: 'Processando documento…',
    statusExtracting: 'Extraindo assinaturas do documento…',
    statusCompleted: 'Documento processado',
    statusFailed: 'Falha ao processar — clique para tentar novamente',
    statusSkipped: 'Processamento adiado — revisão manual',
    // E78.F1 — na raia eletrônica o arquivo é conferido inteiro, sem recorte.
    statusPecaEletronicaPronta: 'Documento anexado — pronto para a análise preliminar',
    // E84.F1 — o comprovante de formalização, reconhecido pelo conteúdo no
    // passo 2: entra na custódia do caso e preenche o protocolo e os códigos.
    statusComprovanteReconhecido:
      'Comprovante de formalização — protocolo e códigos dos documentos preenchidos',
    fileListStatusComprovante: 'Comprovante',
    // E107.F1 (ADR-0087): o manifesto e o carimbo do banco não são documento a examinar.
    statusEvidencia: 'Evidência do banco — guardada na custódia do caso, sem exame próprio',
    fileListStatusEvidencia: 'Evidência',
    resumoComprovanteTitulo: 'Preenchido a partir do comprovante',
    resumoComprovanteCodigosPreenchidos: '{n} códigos preenchidos',
    resumoComprovanteCodigoPreenchidoUm: '1 código preenchido',
    resumoComprovantePecasSemCodigo: '{n} documentos sem código',
    resumoComprovantePecaSemCodigoUma: '1 documento sem código',
    resumoComprovanteCodigosSemPeca: '{n} códigos sem documento',
    resumoComprovanteCodigoSemPecaUm: '1 código sem documento',
    resumoComprovanteRegistro: 'assinatura registrada em {valor}',
    resumoComprovanteRegistroPresumido: '(sinal do fuso presumido)',
    resumoComprovanteCarregando: 'Conferindo o que o comprovante preencheu…',
    resumoComprovanteErro: 'Não foi possível conferir o que o comprovante preencheu.',
    statusNoCandidates: 'Nenhuma assinatura detectada — revise manualmente',
    statusRateLimited: 'Tente novamente em alguns instantes',
    statusProviderCredit: 'Chave de acesso sem saldo — recarregue e tente novamente',
    statusProviderAuth: 'Chave de acesso recusada — confira a chave cadastrada',
    statusPdfTooLong:
      'Documento com mais de 40 páginas — envie só as páginas com o contrato e a assinatura',
    actionRetry: 'Tentar novamente',
    actionRemove: 'Remover',
    actionUpload: 'Enviar',
    advanceBlockedConfrontadas: 'Anexe pelo menos um documento padrão processado para avançar.',
    advanceBlockedContestadas: 'Anexe pelo menos um documento questionado processado para avançar.',
    advanceBlockedProcessing: 'Aguarde o processamento dos documentos terminar.',
    advanceBlockedReviewStandards:
      'Confirme ao menos uma assinatura de referência (padrão) antes de avançar — em um documento padrão enviado, ou marcando uma assinatura como referência no próprio documento questionado.',
    advanceBlockedReviewContestadas:
      'Confirme a revisão de pelo menos um documento questionado antes de concluir. Marque a região da assinatura e clique em "Confirmar revisão".',
    errorCaseNotFound: 'Caso não encontrado.',
    errorUnsupportedMime: 'Tipo de arquivo não aceito.',
    errorFileTooLarge: 'Arquivo passa do tamanho máximo (50 MB).',
    errorFileEmpty: 'O arquivo está vazio.',
    errorNetwork: 'Sem conexão. Verifique sua rede e tente novamente.',
    // E111.F1 (GUS-122): o tempo de espera do envio acabou — o servidor pode ter recebido.
    errorTimeout:
      'O envio de {nome} demorou mais que o esperado e o servidor pode tê-lo recebido. Confira a lista de documentos: se reenviar, o arquivo que já chegou não se repete.',
    // 01/10 (pacote do PAN): depois dos 100% o servidor ainda lê o arquivo; a linha diz isso.
    uploadLendo: 'Recebido. Lendo o conteúdo; pode levar até um minuto. Não saia desta tela.',
    uploadLendoPacote:
      'Pacote recebido. Abrindo e lendo os arquivos; pode levar até um minuto. Não saia desta tela.',
    errorGeneric: 'Não foi possível enviar este arquivo. Tente novamente.',
    errorLoad: 'Não foi possível carregar os documentos do caso.',
    errorRemoveGeneric: 'Não foi possível remover este documento. Tente novamente.',
    counterDocuments: '{{count}} documento(s) anexado(s)',
    // E133.F2 (GUS-106, ADR-0089): o envio é um recebimento; o que o exame não lê fica guardado.
    errorRecebimento: 'Não foi possível registrar o envio. Tente novamente.',
    counterNaoExaminados: '{{count}} guardado(s) sem exame',
    naoExaminadoLinha: 'Recebido e guardado · sem exame: {motivo}',
    naoExaminadoSelo: 'Sem exame',
    // E135.F2.C01 (F-E135.F2-01): a conclusão do envio falhou e o recibo não foi fechado.
    reciboNaoSelado:
      'O recibo deste envio não foi fechado. Os arquivos estão guardados; conclua o envio para fechar o recibo.',
    actionConcluirDeNovo: 'Tentar concluir novamente',
    // E135.F2.C03 (F-E135.F2-03): a leitura do recibo falhou; sem ela não se sabe se há envio aberto.
    reciboNaoLido:
      'Não foi possível conferir o recibo dos envios deste caso. Leia de novo para saber se algum envio ficou sem concluir.',
    actionLerReciboDeNovo: 'Ler o recibo de novo',
    // E33.F4 — passo "Caso" editável: voltar e ajustar os dados antes de confirmar.
    caseEditKicker: 'Passo 1 · Caso',
    caseEditTitle: 'Dados do caso',
    caseEditIntro: 'Revise e ajuste os dados do caso. As alterações são salvas neste passo.',
    caseSave: 'Salvar alterações',
    caseSaving: 'Salvando…',
    caseSaved: 'Dados do caso atualizados.',
  },

  extraction: {
    kicker: 'Revisão de regiões',
    frameCaption: 'Página',
    pageTitle: 'Revisar extração',
    introTemplate: 'Sistema sugeriu {{count}} região(ões). Confirme ou ajuste antes de avançar.',
    introNoCandidates:
      'Nenhuma assinatura detectada. Marque manualmente as regiões antes de avançar.',
    paginatorAriaLabel: 'paginação',
    paginatorLabel: 'Página {{current}} de {{total}}',
    paginatorPrevious: 'Página anterior',
    paginatorNext: 'Próxima página',
    actionAddManual: 'Adicionar manualmente',
    actionAddManualHint: 'Arraste sobre a página para desenhar uma nova região.',
    actionAddManualCancel: 'Cancelar marcação manual',
    // E23.F26 (ADR-0033): controles ancorados na própria região do documento.
    boxIncludeTooltip: 'Incluir esta assinatura',
    boxDiscardTooltip: 'Descartar esta assinatura',
    boxAdjustTooltip: 'Ajustar o recorte — arraste a marcação no documento',
    boxRenameTooltip: 'Renomear assinatura',
    boxRemovePinTooltip: 'Remover marcação',
    boxRotateTooltip: 'Girar o recorte 90°',
    boxRotationLabel: 'Recorte girado {{deg}}°',
    boxConfrontadaShort: 'Referência',
    boxAdjustHint: 'Arraste ou redimensione a marcação sobre o documento para ajustar o recorte.',
    submit: 'Confirmar revisão',
    submitting: 'Salvando revisão…',
    submitDisabledHint: 'Decida cada região ou adicione marcação manual antes de salvar.',
    runningTitle: 'Processando documento…',
    runningBody: 'A extração ainda está em andamento. Esta tela será atualizada automaticamente.',
    failedBody: 'Tente novamente. Se persistir, remova e reenvie o arquivo.',
    failedApiKeyMissing:
      'A extração precisa de uma chave de acesso ao provedor de análise cadastrada. Cadastre a chave e tente novamente.',
    failedApiKeyMissingCta: 'Cadastrar chave de acesso',
    failedProviderCredit:
      'A chave de acesso cadastrada está sem saldo no provedor de análise. Recarregue o saldo da conta (ou cadastre outra chave) e tente novamente.',
    failedProviderAuth:
      'A chave de acesso cadastrada foi recusada pelo provedor de análise. Confira a chave em Configurações e tente novamente.',
    failedProviderCta: 'Ver chave de acesso',
    failedRetrying: 'Tentando novamente…',
    canvasAriaLabel: 'Página {{page}} do documento para revisão de assinaturas',
    canvasLoading: 'Carregando página…',
    canvasFailed: 'Não foi possível carregar a página.',
    errorLoadCandidates: 'Não foi possível carregar as regiões sugeridas. Tente novamente.',
    errorLoadDocument: 'Não foi possível carregar o documento. Tente novamente.',
    errorDocumentNotFound: 'Documento não encontrado.',
    errorCandidateNotFound: 'Uma das regiões selecionadas não existe mais. Recarregue a página.',
    errorPageNotFound: 'Página do documento indisponível.',
    errorContestedAlreadyResolved: 'Só é permitido confirmar uma região por documento contestado.',
    errorAlreadySubmitted: 'A revisão deste documento já foi confirmada.',
    // E23.F16: painel de reabertura da revisão.
    // E23.F14: banner quando assinaturas foram extraídas do próprio documento.
    embeddedImagesBanner: 'As assinaturas foram detectadas diretamente no documento enviado.',
    reopenHint:
      'Para refazer, exclua a assinatura confirmada abaixo — isso reabilita a revisão sem precisar excluir o documento.',
    reopenDeleteAction: 'Excluir',
    reopenReady: 'Assinatura excluída. Você pode refazer a revisão.',
    // E23.F16.C03: aviso quando havia marcações manuais perdidas ao navegar.
    reopenManualPinsLost:
      'As marcações manuais que você havia desenhado foram perdidas ao navegar. Exclua a assinatura confirmada abaixo e marque novamente.',
    errorRenderFailed: 'Falha ao gerar o recorte da assinatura. Tente novamente.',
    errorNetwork: 'Sem conexão. Verifique sua rede e tente novamente.',
    errorGeneric: 'Não foi possível salvar a revisão. Tente novamente.',
  },

  workspaceCaso: {
    pageTitle: 'Mesa de análise pericial',
    loading: 'Preparando análise…',
    caseInAnalysis: 'Caso em análise…',
    analysisFailed: 'A análise não pôde ser concluída.',
    analysisRetry: 'Tente recarregar a página. Se persistir, entre em contato.',
    analysisFailedProviderCredit:
      'A chave de acesso cadastrada está sem saldo no provedor de análise. Recarregue o saldo da conta (ou cadastre outra chave) e inicie a análise de novo.',
    analysisFailedProviderAuth:
      'A chave de acesso cadastrada foi recusada pelo provedor de análise. Confira a chave em Configurações e inicie a análise de novo.',
    composedLrTitle: 'Razão de verossimilhança composta (LR)',
    composedLrSubtitle:
      'Agregação das comparações entre cada padrão e o documento contestado (média geométrica).',
    // E36.F4: checklist "Conteúdo do laudo" (substitui o stepper decorativo).
    laudoContentTitle: 'Conteúdo do laudo',
    laudoContentAlways: 'sempre incluída',
    laudoContentInclude: 'Incluir no laudo',
    laudoContentRemove: 'Remover captura',
    laudoContentRenameLabel: 'Rótulo da captura',
    laudoContentEmpty:
      'Nenhuma captura ainda. Use "Capturar para o laudo" na mesa para escolher as vistas que ilustram o laudo.',
    laudoContentSaveError: 'Não foi possível salvar a alteração. Tente de novo.',
    tabCriterios: 'Critérios',
    tabAgente: 'Agente',
    tabCriteriosWaiting: 'Os critérios aparecem aqui assim que a análise for concluída.',
    criteriaPanelTitle: 'Critérios analisados',
    criteriaAskAgent: 'Perguntar ao Agente sobre esse critério',
    criteriaEvidenceMissing: 'Evidência textual não disponível para esse critério.',
    // E23.F5/ADR-0023: critérios sem sinal extraível (traço dinâmico cego em
    // foto/digitalização de papel) ficam ocultos por padrão, com toggle.
    criteriaNoSignalBadge: 'Não avaliado',
    criteriaNoSignalHint:
      'Sem sinal suficiente desse critério na imagem enviada — comum em traço dinâmico sobre foto ou digitalização de papel. Não foi avaliado e não pesa na conclusão.',
    criteriaShowNoSignal: 'Mostrar critérios não avaliados',
    criteriaHideNoSignal: 'Ocultar critérios não avaliados',
    patternsTitle: 'Assinaturas-padrão',
    /** Contador em mono ao lado do título da lista (prancha 2B). */
    patternsCount: '{count} no caso',
    /** Legenda mono no rodapé de cada prancha de trabalho (prancha 2B). */
    plateCaptionPattern: 'Padrão selecionado',
    /** Contagem do que foi avaliado, sob o título do painel (prancha 2B). */
    criteriaEvaluatedCount: '{evaluated} de {total} avaliados',
    plateCaptionContested: 'Assinatura contestada',
    contestedTitle: 'Assinatura contestada',
    toolCompare: 'Comparar',
    // E29.F2/ADR-0040: mesa única substitui os antigos "Sobrepor" + "Alinhar".
    toolOverlap: 'Sobrepor & alinhar',
    overlapOpacityLabel: 'Opacidade',
    overlapReset: 'Resetar',
    overlapNote:
      'Mesa de inspeção: arraste, escale e gire a contestada sobre o padrão para conferir o encaixe. Os ajustes são só de visualização — não alteram a análise.',
    // E26.F4/ADR-0039: filtros de inspeção — inverter (lente global), grade
    // (referência visual sem medição), régua (px da imagem original, com nota
    // de honestidade de escala; comparação canônica é a matriz/ADR-0038).
    inspectInvert: 'Inverter cores',
    inspectGrid: 'Grade de referência',
    inspectRuler: 'Régua',
    inspectRulerCompareOnly: 'Disponível no modo Comparar — a régua mede dentro de uma imagem.',
    inspectRulerHint: 'Arraste sobre uma das imagens para traçar e medir um segmento.',
    inspectRulerNote:
      'A régua mede dentro de uma imagem, em pixels da imagem original. Pixels de capturas diferentes não são comparáveis entre si — a comparação entre padrão e contestada usa a espessura do traço como unidade, na matriz de convergência física.',
    inspectRulerUnit: 'px (imagem)',
    // E36.F2: zoom/pan na mesa (Comparar + Sobrepor & alinhar).
    // E37.F1: pan por espaço nos dois modos + grupo de zoom com presets,
    // atalhos de teclado e sincronização K↔Q.
    zoomFit: 'Caber na tela',
    zoomMenu: 'Zoom',
    zoomIn: 'Aproximar (+)',
    zoomOut: 'Afastar (−)',
    zoomGestureTitle:
      'Roda do mouse: ampliar/reduzir · Espaço + arrastar: mover · Duplo clique: caber na tela · Teclado: + e − ampliam/reduzem, 0 = caber, 1 = 100%',
    syncPanels: 'Sincronizar painéis',
    syncPanelsTitle:
      'Espelha o zoom e o movimento entre o padrão e a contestada — examine a mesma região nos dois painéis.',
    syncPanelsCompareOnly: 'Disponível no modo Comparar — sincroniza os dois painéis lado a lado.',
    // E36.F3: anotações manuais do perito sobre a contestada (setas/círculos).
    annotateArrow: 'Seta',
    annotateCircle: 'Círculo',
    annotateColorGreen: 'Verde',
    annotateColorAmber: 'Âmbar',
    annotateColorRed: 'Vermelho',
    annotateDelete: 'Apagar anotação',
    annotateLayerLabel: 'Anotações manuais na assinatura contestada',
    annotateGestureTitle:
      'Arraste sobre a contestada para desenhar · Clique em uma anotação para selecionar e arraste para mover · Delete apaga a selecionada',
    annotateSaveError: 'Não foi possível salvar a anotação. Tente de novo.',
    // E47.F3: marcações trazidas da análise preliminar como ponto de partida.
    // Enquadramento (ADR-0058 §2.5.bis): são SUGESTÕES de apoio, não conclusão —
    // não entram no laudo enquanto o perito não as assumir como suas.
    triagemLayerLabel: 'Sugestões da análise preliminar na assinatura contestada',
    triagemBadge: 'Sugestão da análise preliminar',
    triagemHint:
      'Trazidas da análise preliminar como ponto de partida. Não entram no laudo enquanto você não as assumir como suas.',
    triagemAdopt: 'Assumir como minha',
    triagemAdoptTitle:
      'Assume a marcação como sua: ela passa a ser sua anotação e pode entrar no laudo',
    triagemDiscard: 'Descartar sugestão',
    triagemAdoptError: 'Não foi possível assumir a marcação. Tente de novo.',
    // E36.F4: captura da vista corrente da mesa como imagem do laudo.
    captureToLaudo: 'Capturar para o laudo',
    captureSuccess: 'Captura adicionada ao conteúdo do laudo.',
    captureFailure: 'Não foi possível capturar a vista. Tente de novo.',
    captureInvertedSuffix: 'cores invertidas',
    captureGestureTitle:
      'Salva a vista corrente (zoom, filtros, anotações e sobreposição) como imagem do laudo',
    // E37.F2: labels de acessibilidade dos grupos da toolbar redesenhada.
    toolbarLabel: 'Barra de ferramentas da mesa',
    modeGroupLabel: 'Modo de visualização',
    toolsGroupLabel: 'Ferramentas de anotação',
    filtersGroupLabel: 'Filtros de inspeção',
    toolbarOverflow: 'Mais ferramentas',
    // E37.F3.T03: modo foco — recolhe as colunas laterais (Esc/botão restaura).
    focusEnter: 'Modo foco',
    focusExit: 'Sair do modo foco',
    focusGestureTitle: 'Esconde as colunas laterais para análise imersiva (Esc restaura)',
    // E23.F10/ADR-0027: marcação por critério ancorada à região na contestada.
    // E36.F1: rebatizadas "marcações do sistema" (vs. anotações manuais do
    // perito, E36.F3) e ocultas por padrão.
    markersShow: 'Mostrar marcações do sistema',
    markersHide: 'Ocultar marcações do sistema',
    markersOverlayLabel: 'Marcações de critérios na assinatura contestada',
    markersLegendConvergent: 'Convergente',
    markersLegendDivergent: 'Divergente',
    markersLegendNeutral: 'Sem distinção',
    markersNone: 'Sem regiões marcáveis nesta assinatura.',
    // Nota de honestidade (ADR-0027 §2C): o marcador localiza a EVIDÊNCIA do
    // critério, não acusa um traço específico.
    markersDisclaimer:
      'Cada marca indica onde está a evidência do critério na assinatura; a cor reflete o exame do critério como um todo, não daquele ponto isolado.',
    markersGlobalNote:
      'Calibre, inclinação e forma global avaliam a assinatura inteira — aparecem na lista de critérios, sem marca em região.',
    // E26.F1/ADR-0036: topografia de pressão ESTIMADA — rótulo "estimada"
    // obrigatório em toda superfície; é propriedade de UMA assinatura
    // (o exame comparativo dos dois mapas é do perito, não do sistema).
    topographyTitle: 'Topografia de pressão (estimada)',
    // E29.F1/ADR-0040 §C: rótulo curto do chip no seletor segmentado; mantém
    // "(estimada)" obrigatório em toda superfície de topografia (ADR-0036).
    topographyChip: 'Topografia (estimada)',
    // E54.F6.T06 (prancha 2C): o método sobe para junto do título e a ressalva
    // fica no rodapé da figura — as duas frases já existiam na mesma linha; o
    // que muda é onde cada uma aparece, não o que elas dizem.
    topographyMethodNote:
      'Mapa derivado da espessura local do traço na imagem: tons mais quentes indicam traço mais espesso.',
    topographyRampThin: 'Fino',
    topographyRampThick: 'Espesso',
    topographyDisclaimer: 'É uma estimativa — imagem estática não mede a pressão real da escrita.',
    topographyPatternCaption: 'Padrão selecionado',
    topographyContestedCaption: 'Contestada',
    topographyUnavailable:
      'Topografia indisponível para esta imagem — material sem base suficiente para o mapa.',
    // E26.F4.T05 (classe F-E26.F3-02): falha técnica é distinta de
    // "indisponível" (estado forense do material).
    topographyError: 'Não foi possível carregar o mapa agora. Tente novamente.',
    topographyLoading: 'Gerando mapa…',
    // E26.F2/ADR-0037: gênese gráfica — extremidades SEM direção temporal
    // (imagem estática não registra ordem de execução; nunca atribuir qual
    // extremidade é ataque e qual é remate) e paradas ESTIMADAS.
    genesisTitle: 'Gênese gráfica — ataques, remates e paradas',
    genesisChip: 'Gênese',
    genesisDisclaimer:
      'Extremidades de traço são marcadas sem distinguir início (ataque) de fim (remate) — a imagem não registra a ordem de execução. Paradas são estimadas pelo acúmulo de tinta. A leitura comparativa entre as assinaturas é do perito.',
    genesisExtremities: 'Extremidades (ataques/remates)',
    genesisJunctions: 'Junções',
    genesisStops: 'Paradas (estimadas)',
    genesisPatternCaption: 'Padrão selecionado',
    genesisContestedCaption: 'Contestada',
    genesisUnavailable:
      'Gênese gráfica indisponível para esta imagem — material sem base suficiente para os marcadores.',
    // E26.F4.T05 (classe F-E26.F3-02): falha técnica é distinta de
    // "indisponível" (estado forense do material).
    genesisError: 'Não foi possível carregar os marcadores agora. Tente novamente.',
    genesisLoading: 'Carregando marcadores…',
    genesisOverlayLabel: 'Marcadores de gênese gráfica sobre a assinatura',
    // E26.F3/ADR-0038: matriz de convergência física — valores do MESMO
    // extrator do motor; px na unidade canônica ×traço (px absolutos não
    // comparam entre capturas); sem cor/marcação de veredito na matriz.
    matrixTitle: 'Matriz de convergência física',
    matrixChip: 'Matriz',
    // E29.F1/ADR-0040 §C: rótulo do grupo do seletor segmentado de instrumentos.
    instrumentSelectorLabel: 'Instrumentos de inspeção',
    matrixDisclaimer:
      'Valores medidos pelo mesmo processo que avalia os critérios. Medidas em pixels dependem da resolução da captura — a comparação usa a espessura do traço como unidade (×traço). A leitura comparativa entre as colunas é do perito.',
    matrixMeasureHeader: 'Medida',
    matrixPatternHeader: 'Padrão selecionado',
    matrixContestedHeader: 'Contestada',
    matrixStrokeUnit: '×traço',
    matrixStrokeUnresolved:
      'Espessura do traço não resolvida em uma das imagens — valores em pixels exibidos sem a unidade canônica; capturas de resoluções diferentes não são comparáveis em pixels.',
    matrixUnavailable: 'Matriz indisponível — material sem base suficiente para a medição.',
    matrixCellUnavailable: 'indisponível',
    // F-E26.F3-02: falha técnica é distinta de "indisponível" (estado
    // forense do material) — nunca reutilizar o texto de indisponibilidade.
    matrixError: 'Não foi possível carregar as medições agora. Tente novamente.',
    matrixCellError: 'falha ao carregar',
    matrixLoading: 'Medindo…',
    chatTitle: 'Agente Pericial',
    chatPlaceholder: 'Pergunte sobre os critérios analisados…',
    chatSend: 'Enviar',
    chatSending: 'Enviando…',
    chatProcessing: 'Agente processando…',
    chatEmpty: 'Inicie a conversa perguntando sobre algum critério.',
    chatErrorNetwork: 'Sem conexão. Verifique sua rede.',
    chatErrorAssistantUnavailable:
      'O Agente está temporariamente indisponível. Tente novamente em instantes.',
    chatErrorAssistantTimeout: 'O Agente demorou demais para responder.',
    chatErrorNoApiKey:
      'Configure sua chave de acesso ao Agente Pericial no perfil antes de conversar.',
    chatErrorGeneric: 'Não foi possível enviar a mensagem.',
    lrClassificationStrongForAuthor: 'Forte para mesma autoria',
    lrClassificationModerateForAuthor: 'Moderada para mesma autoria',
    lrClassificationLimitedForAuthor: 'Limitada para mesma autoria',
    lrClassificationStrongAgainst: 'Forte para heteroautoria',
    lrClassificationModerateAgainst: 'Moderada para heteroautoria',
    lrClassificationLimitedAgainst: 'Limitada para heteroautoria',
    lrClassificationInconclusive: 'Inconclusiva',
    // E39.F1/ADR-0054 (emenda ADR-0022): a magnitude na bancada passou da
    // intensidade 0–100% para o índice ASSINADO −100…+100. Os rótulos de
    // intensidade saíram com a leitura.
    // E39.F1/ADR-0054: régua de suporte ASSINADA −100…+100, instrumento de
    // bancada do perito (leitura PRINCIPAL na mesa). Sinal = direção; módulo =
    // força. Termos neutros — nunca "probabilidade"/"chance"/"certeza". Não sai
    // no laudo (ADR-0053).
    supportIndexTitle: 'Suporte do indício',
    supportIndexSubtitle:
      'Régua de apoio do perito, de −100 (apoio à heteroautoria) a +100 (apoio à mesma autoria); o centro é a zona inconclusiva.',
    supportIndexValueLabel: 'Índice de suporte',
    supportIndexAdjustLabel: 'Ajustar o índice de suporte (−100 a +100)',
    supportIndexSecondaryLr: 'Valor de referência (LR)',
    supportLevelWeakForAuthor: 'Fraca para mesma autoria',
    supportLevelWeakAgainst: 'Fraca para heteroautoria',
    supportTickAgainst: 'Apoio máximo à hipótese de heteroautoria.',
    supportTickNeutral: 'Centro da régua: zona inconclusiva, sem apoio a declarar.',
    supportTickForAuthor: 'Apoio máximo à hipótese de mesma autoria.',
    // E54.F5.T06: rótulo curto de cada zona sob a escala da régua (prancha 2B).
    supportZoneAgainst: 'Heteroautoria',
    supportZoneNeutral: 'Inconclusiva',
    supportZoneForAuthor: 'Mesma autoria',
    // E33.F2/ADR-0044: ajuste manual de LR pelo perito na mesa (calculado vs
    // efetivo). Sem termos técnicos de bastidor — "valor calculado" = o motor.
    lrAdjustInputLabel: 'Ajustar o valor de LR',
    lrAdjustRevert: 'Reverter ao valor calculado',
    criteriaExpand: 'Expandir critério',
    criteriaCollapse: 'Recolher critério',
    lrAdjustErrorNotPerito: 'Apenas o perito responsável pelo caso pode ajustar o LR.',
    lrAdjustErrorUnknownCriterion: 'Critério não encontrado nesta análise.',
    lrAdjustErrorInvalidValue: 'Informe um valor de LR positivo dentro da faixa aceita.',
    lrAdjustErrorNetwork: 'Falha de conexão ao salvar o ajuste. Tente novamente.',
    lrAdjustErrorGeneric: 'Não foi possível salvar o ajuste.',
    // E38.F3: critérios adicionados pelo perito (fora dos 10 canônicos). Saem no
    // laudo junto aos demais, mas não alteram o cálculo consolidado.
    customCriteriaAdd: 'Adicionar critério',
    customCriteriaSectionTitle: 'Critérios adicionados pelo perito',
    customCriteriaName: 'Nome do critério',
    customCriteriaNamePlaceholder: 'Ex.: Pontuação, Acentuação',
    customCriteriaLr: 'Valor de LR',
    customCriteriaObservation: 'Observação',
    customCriteriaObservationPlaceholder: 'Justificativa do critério (opcional)',
    customCriteriaSave: 'Salvar critério',
    customCriteriaCancel: 'Cancelar',
    customCriteriaRemove: 'Remover critério',
    customCriteriaHint: 'Sai no laudo junto aos demais; não altera o cálculo consolidado.',
    customCriteriaError:
      'Não foi possível salvar o critério. Verifique os campos e tente novamente.',
    errorLoadGeneric: 'Não foi possível carregar a mesa de análise.',
    summaryTitle: 'Síntese do Agente',
    summaryColCriterio: 'Critério',
    summaryColLR: 'LR',
    // E54.F6.T09: a coluna de barra da prancha 2C. Lá ela se chama "peso
    // relativo"; aqui não pode — o composto é média geométrica e nenhum
    // critério pesa mais que outro (ADR-0023). O que a barra mostra é a força
    // do próprio LR daquele critério.
    summaryColForca: 'Força do indício',
    summaryColDirecao: 'Direção',
    chatChipsLabel: 'Sugestões rápidas',
    patternCardFallback: 'Padrão',
    patternCardIdToggle: 'ver id técnico',
    patternCardOrigemLabel: 'Origem:',
    patternCardOrigemDireta: 'Enviada diretamente',
    patternCardOrigemExtraida: 'Extraída de documento',
    patternCardOrigemPag: 'pág.',
    breadcrumbCasos: 'Casos',
    breadcrumbAnalise: 'Análise',
    ctaCompartilhar: 'Compartilhar com revisor',
    // E24.F4 — compartilhar laudo com revisores por e-mail.
    shareConfirmTitle: 'Notificar os revisores do escritório?',
    shareConfirmDescription:
      'Cada revisor cadastrado receberá um e-mail com o resumo do resultado e o link do caso para revisar e aprovar.',
    shareConfirmCta: 'Enviar notificação',
    shareCancel: 'Cancelar',
    shareSuccessTitle: 'Notificação enviada',
    shareSuccessOne: 'O revisor {email} foi notificado por e-mail.',
    shareSuccessMany: '{count} revisores foram notificados por e-mail.',
    shareErrorTitle: 'Não foi possível notificar os revisores',
    shareErrorNoReviewers:
      'O escritório ainda não tem revisores cadastrados. Adicione um revisor em Configurações antes de compartilhar.',
    shareErrorNotReady: 'A análise precisa estar concluída antes de compartilhar o laudo.',
    shareErrorNotConfigured: 'O envio de e-mail não está configurado neste ambiente.',
    shareErrorSendFailed: 'O serviço de e-mail está indisponível. Tente novamente em instantes.',
    shareErrorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
    chatChip1: 'Comente a discordância entre padrão e questionada.',
    chatChip2: 'Resuma as conclusões em até 3 frases.',
    chatChip3: 'Indique qual critério mais pesa contra a hipótese de mesma autoria.',
    ctaGerarLaudo: 'Gerar laudo',
    ctaGerarLaudoBlocked: 'Concluir análise para gerar o laudo',
    // E34.F2: volta da mesa ao wizard do caso (dados/documentos/assinaturas).
    ctaVoltarCaso: 'Voltar ao caso',
    contestedTabsLabel: 'Assinaturas contestadas em análise',
    contestedTabFallbackLabel: 'Questionada',
    proportionWarningTitle: 'Proporções divergentes entre as imagens',
    proportionWarningMessage:
      'As proporções das assinaturas enviadas divergem de forma acentuada. Confira se os recortes correspondem às mesmas regiões assinadas antes de concluir a análise.',
    proportionWarningDismiss: 'Dispensar aviso',
    instabilityWarningTitle: 'Variação entre as amostras de referência',
    instabilityWarningMessage:
      'As amostras de referência apontam para conclusões opostas entre si — o resultado é tratado como inconclusivo. Verifique se todas as amostras foram capturadas em condições semelhantes (mesma iluminação, ângulo e recorte) antes de concluir.',
    instabilityWarningDismiss: 'Dispensar aviso',
    patternDegradationTitle: 'Qualidade insuficiente nas assinaturas-padrão',
    patternDegradationMessage:
      'Uma ou mais assinaturas-padrão deste confronto não têm qualidade de captura suficiente para avaliar os critérios dinâmicos. Esses critérios aparecem como "Não avaliado" — a ausência de convergência neles decorre do material de referência, e não de divergência entre os escritos. Considere substituir os padrões por capturas em melhor resolução.',
    patternDegradationDismiss: 'Dispensar aviso',
  },

  // E59 (rodada 3, item 2) — vocabulário ÚNICO do veredito exposto ao usuário.
  // Três telas tinham três vocabulários; agora todas passam por `lib/veredito.ts`
  // e leem daqui. A conclusão verbal do laudo NÃO usa estas chaves: ela segue a
  // escala forense (dual naming — nome de domínio ≠ nome de tela).
  veredito: {
    convergente: 'Convergente',
    divergente: 'Divergente',
    inconclusivo: 'Inconclusivo',
    pendente: 'Em exame',
  },

  informacoesRelevantes: {
    kicker: 'REGISTRO DO PERITO',
    titulo: 'Informações relevantes',
    descricao:
      'Espaço para registrar o que você observou no caso e que não passa pela comparação formal — um dado de contexto, uma coincidência entre documentos, uma circunstância de um deles.',
    campoLabel: 'Achados fora da comparação',
    placeholder:
      'Ex.: a assinatura digital da procuração registra o mesmo local do contrato contestado.',
    salvar: 'Salvar',
    salvando: 'Salvando…',
    salvoConfirmacao: 'Registro salvo.',
    erroSalvar: 'Não foi possível salvar o registro. Tente novamente.',
    nota: 'O texto sai em seção própria do laudo, declarada como fora da comparação formal. Não altera o cálculo nem a conclusão. Em branco, a seção não aparece no documento.',
  },

  cadeiaCustodia: {
    kicker: 'INTEGRIDADE DOS DOCUMENTOS',
    titulo: 'Cadeia de custódia',
    descricao:
      'Documentos recebidos por este exame, com quem anexou, quando e o código de verificação do conteúdo. O código sai impresso no laudo e pode ser conferido por qualquer parte que tenha o arquivo em mãos.',
    colPeca: 'Documento',
    colAutor: 'Anexado por',
    colRecebida: 'Recebido em',
    colCodigo: 'Código de verificação',
    tipoDocumento: 'Documento',
    tipoAssinatura: 'Assinatura',
    // E82.F7.T03 — mesmo rótulo do Apêndice B (`_TIPO_PECA_PT_BR` no laudo).
    tipoFoto: 'Fotografia',
    semCodigo: 'Não registrado — documento anterior ao registro de integridade',
    vazia: 'Nenhum documento foi anexado a este caso ainda.',
    limite:
      'O código de verificação atesta a identidade e a continuidade do arquivo a partir do recebimento. Não constitui, por si, prova sobre a origem ou a autoria do documento antes desse momento.',
    erroCarregar: 'Não foi possível carregar a cadeia de custódia. Recarregue a página.',
    // E85.F2 (GUS-32): a segunda lista do registro — o que o sistema produziu.
    documentosTitulo: 'Documentos produzidos neste caso',
    documentosDescricao:
      'Capturas da mesa, protocolo importado e laudo certificado, cada um com o código de verificação gravado no momento em que foi produzido.',
    colDocumento: 'Documento',
    colProduzidoPor: 'Produzido por',
    colProduzidoEm: 'Produzido em',
    tipoCapturaDaMesa: 'Captura da mesa',
    tipoProtocoloImportado: 'Protocolo importado',
    tipoLaudoCertificado: 'Laudo certificado',
    documentosVazio: 'Nenhum documento foi produzido neste caso ainda.',
  },

  // E85.F2 (GUS-32): o código do arquivo que acabou de descer, em toda tela que
  // baixa um documento emitido sob demanda.
  documentoBaixado: {
    rotulo: 'Código de verificação do arquivo baixado:',
    nota: 'Cada emissão gera um arquivo próprio. O código vale para o arquivo que acabou de ser salvo e pode ser conferido por quem o receber.',
  },

  // E93.F4 (GUS-56): a página que o link de cada referência do documento emitido abre.
  arquivoDaPeca: {
    eyebrow: 'ARQUIVO DO CASO',
    carregando: 'Localizando o arquivo...',
    intro:
      'Arquivo referenciado no documento emitido. Confira o código de verificação com o impresso na linha correspondente.',
    rotuloTipo: 'Tipo',
    rotuloCodigo: 'Código de verificação (SHA-256)',
    rotuloTamanho: 'Tamanho',
    rotuloRecebido: 'Recebido em',
    recebidoPor: '{{data}}, por {{autor}}',
    baixar: 'Baixar arquivo',
    baixando: 'Baixando...',
    baixado: 'Arquivo baixado.',
    codigoDoBaixado: 'Código de verificação do arquivo salvo:',
    recusaTitulo: 'Arquivo indisponível',
    foraDoRecorte:
      'Esta conta não tem acesso aos arquivos deste caso. Eles são liberados ao escritório responsável pelo caso e ao banco da carteira.',
    senhaProvisoria: 'Defina uma senha sua para abrir o arquivo.',
    naoEncontrado:
      'Arquivo não encontrado. O link pode estar incompleto, ou o arquivo não pertence a este caso.',
    naoConfere:
      'O arquivo guardado não confere com o código de verificação registrado no recebimento. Nada foi baixado; comunique o responsável pelo caso.',
    erroRede: 'Não foi possível falar com o servidor. Tente de novo em instantes.',
    erroDesconhecido: 'Não foi possível abrir o arquivo agora. Tente de novo em instantes.',
    tentarDeNovo: 'Tentar de novo',
    irParaInicio: 'Ir para o início',
  },

  laudoCaso: {
    pageTitle: 'Laudo grafoscópico',
    headerEyebrow: 'DOCUMENTO TÉCNICO',

    // E65.F1.T02 — blocos auxiliares que recolhem para o laudo ficar em primeiro
    // plano. O rótulo longo vai no aria-label; o curto é o texto do controle.
    blocoRecolhivel: {
      abrir: 'Abrir {{bloco}}',
      recolher: 'Recolher {{bloco}}',
      abrirCurto: 'Abrir',
      recolherCurto: 'Recolher',
      preenchido: 'Preenchido',
    },
    loading: 'Preparando o laudo…',
    exportPdf: 'Baixar PDF',
    exportDocx: 'Baixar DOCX',
    exporting: 'Gerando PDF…',
    exportingDocx: 'Gerando DOCX…',
    backToWorkspace: 'Voltar para a mesa de análise',
    headerVersion: 'v1',
    headerLastGenerated: 'Última geração: {{date}}',
    headerLastGeneratedNever: 'Última geração: ainda não gerada',
    headerStatusGlobal: {
      rascunho: 'Rascunho',
      editando: 'Em edição',
      aprovada: 'Aprovada',
    },
    regenerateConfirmTitle: 'Sobrescrever versão atual?',
    regenerateConfirmBody:
      'Esta ação sobrescreve a versão atual do texto. Tem certeza que deseja continuar?',
    regenerateConfirmAction: 'Sobrescrever',
    regenerateCancel: 'Cancelar',
    narrativeEmptyTitle: 'Texto ainda não foi gerado',
    narrativeEmptyDescription:
      'Clique em "Gerar texto" para criar o primeiro rascunho desta contestada.',
    narrativeEmptyCta: 'Gerar texto',
    headerSubtitle:
      'Pré-visualização do laudo gerado a partir dos dados do caso, das assinaturas e das análises concluídas.',
    notReadyKicker: 'ETAPA ANTERIOR PENDENTE',
    notReadyTitle: 'O laudo ainda não está disponível.',
    notReadyBody:
      'A análise pericial precisa estar concluída antes de gerar o laudo. Retorne à mesa de análise.',
    errorNetwork: 'Sem conexão. Verifique sua rede.',
    errorRenderFailed: 'Não foi possível gerar o laudo no momento. Tente novamente em instantes.',
    errorGeneric: 'Não foi possível carregar o laudo.',
    errorPdfGeneric: 'Não foi possível baixar o PDF do laudo.',
    errorDocxGeneric: 'Não foi possível baixar o DOCX do laudo.',
    contestadaItemLabel: 'Contestada',

    // E9.F2.T13 — Tabs por contestada + bloqueio de download
    tabs: {
      ariaLabel: 'Selecionar contestada para edição',
      statusRascunho: 'Rascunho',
      statusEditando: 'Em edição',
      statusAprovada: 'Aprovada',
    },
    blockedDownload: {
      missingNarrative:
        'Gere o texto do laudo para todas as contestadas antes de baixar o documento.',
      notApprovedSome: 'Aprove o texto de todas as contestadas antes de baixar o documento final.',
      reviewNotApproved:
        'O caso precisa ser homologado por um responsável antes de baixar o documento final.',
      regenerating:
        'O texto está sendo atualizado após o ajuste de valores. Aguarde concluir para aprovar e baixar.',
    },
    errorNarrativeNotReady:
      'Gere o texto do laudo para todas as contestadas antes de baixar o documento.',
    errorNarrativeNotApproved:
      'Aprove o texto de todas as contestadas antes de baixar o documento final.',
    errorReviewNotApproved:
      'O caso precisa ser homologado por um responsável antes de baixar o documento final.',

    // E23.F7 — Homologação do caso pelo perfil Revisor (separação de funções).
    review: {
      panelKicker: 'HOMOLOGAÇÃO',
      panelTitle: 'Homologação do caso',
      statusPending: 'Aguardando homologação',
      statusApproved: 'Homologado',
      statusRejected: 'Devolvido para correção',
      reviewedBy: 'Homologado por {{email}}',
      returnedBy: 'Devolvido por {{email}}',
      notesLabel: 'Observações (opcional)',
      notesPlaceholder: 'Registre o motivo da devolução ou observações da homologação.',
      notesShownLabel: 'Observações do responsável',
      approveCta: 'Homologar caso',
      rejectCta: 'Devolver para correção',
      submitting: 'Registrando…',
      approveSuccess: 'Caso homologado.',
      rejectSuccess: 'Caso devolvido para correção.',
      selfReviewHint:
        'Você participou da elaboração deste caso. A homologação fica registrada como do próprio responsável pela elaboração.',
      selfReviewChecking: 'Conferindo quem elaborou este caso…',
      selfReviewUnavailable:
        'Não foi possível conferir quem elaborou este caso. A homologação fica indisponível até a conferência responder.',
      selfReviewRetryCta: 'Tentar novamente',
      selfReviewChanged:
        'A elaboração deste caso mudou desde que esta tela abriu. Leia o aviso acima e confirme novamente.',
      mesmoAutorProducao:
        'Declaração: a elaboração do caso e a homologação foram do mesmo profissional.',
      errorGeneric: 'Não foi possível registrar a homologação. Tente novamente.',
    },

    // E9.F1.T09 — Revisão de narrativa antes do PDF final.
    narrative: {
      sectionTitle: 'Texto do laudo',
      emptyHint: 'Gere o laudo para começar a revisar e editar pelo documento.',
      // E65.F1.T01: a ação principal da tela chama o que ela produz. "Gerar
      // texto" descrevia a mecânica interna, não o resultado que o perito quer.
      generateCta: 'Gerar laudo',
      regenerateCta: 'Gerar laudo novamente',
      generating: 'Gerando o laudo…',
      savingIndicator: 'Salvando alterações…',
      savedIndicator: 'Alterações salvas.',
      saveError: 'Não foi possível salvar as alterações. Tente novamente.',
      generateError: 'Não foi possível gerar o texto agora. Tente novamente.',
      generateErrorTimeout:
        'O Agente demorou a responder. O texto pode ter sido gerado mesmo assim — recarregue a página. Se não aparecer, tente novamente.',
      generateErrorNoKey:
        'Configure a chave de acesso ao Agente no perfil antes de gerar o texto do laudo.',
      varianteLabel: 'Conclusão técnica',
      varianteCompatibilidade: 'Compatibilidade grafoscópica',
      varianteDivergencia: 'Indícios de divergência',
      varianteIncompatibilidade: 'Incompatibilidade grafoscópica',
      varianteInconclusivo: 'Inconclusivo',
      varianteHelper:
        'A conclusão é determinada pela análise pericial e não pode ser editada manualmente.',
      fields: {
        estrutura_geral: '5.1 Estrutura geral e composição',
        morfologia: '5.2 Morfologia gráfica',
        conectividade: '5.3 Conectividade e continuidade',
        inclinacao: '5.4 Inclinação e eixo gráfico',
        sequencia: '5.5 Sequência aparente',
        avaliacao_tecnica: 'Avaliação técnica (5.6)',
        sintese: '6. Síntese valorativa',
        observacao_adicional: 'Observação adicional (opcional)',
      },
      convergenciasLabel: 'Pontos de convergência (5.6)',
      divergenciasLabel: 'Pontos de divergência (5.6)',
      addItem: 'Adicionar item',
      removeItem: 'Remover',
      readOnlyForMember:
        'Apenas o administrador do escritório pode gerar ou editar o texto do laudo.',

      // E36.F5/ADR-0050 — texto sendo regenerado após ajuste de valores na mesa.
      regenerating:
        'O texto está sendo atualizado para refletir os valores ajustados na mesa. Aguarde concluir para revisar e aprovar.',

      // E9.F2.T13 — Aprovação explícita da narrativa
      approval: {
        approveCta: 'Aprovar texto desta contestada',
        approving: 'Aprovando…',
        reopenCta: 'Reabrir para edição',
        reopening: 'Reabrindo…',
        approvedHelper:
          'Texto aprovado pelo administrador. Reabra para editar antes de gerar nova aprovação.',
        approveError: 'Não foi possível aprovar o texto agora. Tente novamente.',
        // E137.F2.C04: a aprovação é do texto que está na tela.
        approveErrorStale:
          'O texto mudou desde que você o abriu. A versão atual já está na tela: revise antes de aprovar.',
        approveErrorGenerating:
          'O texto está sendo gerado. Aguarde concluir para revisar e aprovar.',
        reopenError: 'Não foi possível reabrir o texto agora. Tente novamente.',
      },
    },

    // E23.F8 — Pré-visualização completa + edição conversacional confirmada (ADR-0025).
    preview: {
      sectionTitle: 'Pré-visualização do laudo',
      sectionHint:
        'Confira o documento como ele sairá. Peça alterações em linguagem natural — você confirma cada uma antes de gravar.',
      loading: 'Carregando a pré-visualização…',
      error: 'Não foi possível carregar a pré-visualização do laudo.',
      empty: 'Gere o texto desta contestada para visualizar o laudo completo.',
      // E23.F20 (ADR-0030): layout 2-colunas (documento à esquerda, edição à direita).
      editColumnLabel: 'Alterações do laudo',
      // E23.F20 (ADR-0030): pré-visualização agora é o documento renderizado.
      documentLabel: 'Documento do laudo',
      documentLoading: 'Preparando o documento…',
      documentError: 'Não foi possível exibir o documento agora. Tente novamente.',
      documentEmpty: 'Gere o texto das contestadas para visualizar o documento.',
      pageAlt: 'Página {{n}} do laudo',
      frameCaption: 'DOCUMENTO DO LAUDO · PRÉ-VISUALIZAÇÃO',
      editSectionKicker: 'ALTERAÇÕES',
      // E23.F23: visualizador paginado (1 página por vez).
      pagePrev: '‹ Anterior',
      pageNext: 'Próxima ›',
      pageIndicator: '{{n}} de {{total}}',
      contestadaHeading: 'Contestada {{letra}}',
      badgeDraft: 'Rascunho',
      badgeApproved: 'Aprovada',
      conclusaoLabel: 'Conclusão técnica',
      readOnlyForMember: 'Apenas o titular do escritório pode pedir e confirmar alterações.',
      approvedLocked:
        'Texto aprovado. Reabra esta contestada na Análise para pedir novas alterações.',
      instructionLabel: 'Peça uma alteração ao Agente',
      instructionPlaceholder: 'Ex.: na morfologia, descreva melhor o calibre e os remates.',
      proposeCta: 'Pedir proposta',
      proposing: 'Preparando proposta…',
      proposeError: 'Não foi possível preparar a proposta agora. Tente novamente.',
      proposeErrorTimeout: 'O Agente demorou a responder. Tente novamente em instantes.',
    },
    // E23.F20 (ADR-0030): edição manual inline por trecho (source='manual'),
    // complementar ao fluxo conversacional; grava na mesma trilha auditável.
    manualEdit: {
      sectionTitle: 'Editar um trecho diretamente',
      sectionHint:
        'Ajuste à mão os trechos da Análise Técnica (seções 5–6 do laudo). As seções 1–4 são padronizadas. A alteração entra no histórico.',
      editCta: 'Editar este trecho',
      emptyValue: '(sem texto)',
      saveCta: 'Salvar',
      saving: 'Salvando…',
      cancelCta: 'Cancelar',
      saveError: 'Não foi possível salvar a alteração. Tente novamente.',
      saveErrorApproved: 'Reabra esta contestada na Análise antes de editar o texto.',
      // E137.F2 (GUS-160): o texto mudou depois que a edição foi aberta.
      saveErrorStale: 'Este texto mudou desde que a edição foi aberta. Recarregue e edite de novo.',
      saveErrorGenerating: 'O texto está sendo gerado. Aguarde concluir para editar.',
    },
    editProposal: {
      title: 'Alteração proposta',
      fieldLabel: 'Trecho: {{field}}',
      currentLabel: 'Texto atual',
      proposedLabel: 'Texto proposto',
      rationaleLabel: 'Resumo da alteração',
      approveCta: 'Aplicar alteração',
      applying: 'Aplicando…',
      discardCta: 'Descartar',
      applyError: 'Não foi possível aplicar a alteração. Tente novamente.',
      applyErrorApproved: 'Reabra esta contestada na Análise antes de editar o texto.',
    },
    editHistory: {
      kicker: 'CADEIA DE CUSTÓDIA',
      title: 'Histórico de alterações',
      empty: 'Nenhuma alteração registrada ainda.',
      entryField: 'Trecho: {{field}}',
      sourceManual: 'edição manual',
      sourceAgentProposed: 'proposta confirmada',
      sourceHumanOverride: 'ajuste do responsável',
      fromLabel: 'Antes',
      toLabel: 'Depois',
      at: 'em {{date}}',
    },
  },
  /**
   * E74.F1 (ADR-0075) — pré-análise da modalidade assinatura eletrônica: o
   * escritório transcreve o protocolo da plataforma de assinatura por CCB e o
   * sistema confronta o código de verificação (SHA-256) da peça com o declarado,
   * confere identidade, IDs e linha do tempo. Vocabulário jurídico-pericial da
   * contratação eletrônica (ux-neutrality.md, exceções da E74).
   */
  mesaEletronica: {
    pageTitle: 'Mesa do perito',
    pageSubtitle:
      'Leia o que foi apurado em cada documento. A conclusão do sistema já está nas prévias; a sua, se registrada, prevalece.',
    loading: 'Carregando o exame das CCBs…',
    semCcbs: 'Este caso ainda não tem CCB anexada.',
    // E201.F1 (GUS-47): a verificação fica em Documentos, na própria mesa única.
    semExame:
      'O protocolo desta CCB ainda não foi verificado. Verifique-o em Documentos, nesta mesa.',
    irParaPreliminar: 'Ir aos documentos',
    ccbOrdinal: 'CCB {n} de {total}',
    apuradoTitulo: 'O que foi apurado',
    apuradoGrau: 'Grau apurado: {grau}',
    apuradoVersao: 'Parâmetros aplicados: versão {versao}',
    decisaoTitulo: 'Decisão do perito',
    grauLabel: 'Grau de convergência',
    grauAjuda: 'O grau apurado já vem selecionado. Mudá-lo exige justificativa.',
    justificativaLabel: 'Justificativa da mudança de grau',
    justificativaPlaceholder: 'Por que o grau apurado não se sustenta neste caso?',
    justificativaObrigatoria: 'Explique por que está mudando o grau apurado.',
    conclusaoLabel: 'Conclusão',
    conclusaoAjuda:
      'O texto abaixo é a redação padrão do grau escolhido, já preenchida com os dados desta CCB. Edite à vontade — o que ficar aqui é o que vai para o laudo.',
    conclusaoObrigatoria: 'A conclusão não pode ficar em branco.',
    conclusaoRestaurar: 'Restaurar a redação padrão',
    observacoesLabel: 'Observações do perito (opcional)',
    observacoesPlaceholder: 'Registros complementares que devem constar do laudo.',
    concluir: 'Registrar conclusão',
    concluindo: 'Registrando…',
    concluida: 'Conclusão registrada.',
    concluidaEm: 'Concluída em {quando}.',
    reabrir: 'Reabrir conclusão',
    reabrindo: 'Reabrindo…',
    reaberta: 'Conclusão reaberta. Registre a nova decisão.',
    reaberturaTitulo: 'Reabrir a conclusão desta CCB',
    reaberturaMotivoLabel: 'Motivo da reabertura',
    reaberturaMotivoPlaceholder: 'O que precisa ser corrigido nesta conclusão?',
    reaberturaMotivoObrigatorio: 'Descreva o motivo da reabertura.',
    reaberturaConfirmar: 'Reabrir',
    reaberturaCancelar: 'Cancelar',
    historicoTitulo: 'Conclusões anteriores',
    historicoItem: '{quando} — reaberta: {motivo} (grau anterior: {grau})',
    todasConcluidas: 'Todas as CCBs deste caso foram concluídas.',
    irParaLaudo: 'Ir para o laudo',

    // E78.F4 — o painel do caso no topo da mesa e a decisão em coluna lateral.
    painelTitulo: 'O que este caso confronta',
    painelPecas: '{n} documentos recebidos × protocolo {protocolo}',
    painelUmaPeca: '1 documento recebido × protocolo {protocolo}',
    painelSemProtocolo: 'O protocolo desta contratação ainda não foi transcrito.',
    painelSignatario: 'signatário {nome}',
    painelCpf: 'CPF {cpf}',
    painelAssinaturaEm: 'assinatura em {quando}',
    // E162.F2.T02 (ADR-0111 §2.1): a mesa conta só o que pede conclusão (a CCB). E180.F2
    // (GUS-254): a conclusão do assistente é facultativa — o contador não pede nada.
    contador: '{concluidas} de {total} CCBs com a sua conclusão registrada',
    contadorPeloSistema: 'as demais seguem a conclusão apurada pelo sistema',
    colunaPeca: 'Documento',
    // E91.F2 (GUS-51 RF04): a mesa mostra o confronto com o protocolo, não o
    // SHA-256 bruto — o hash completo continua no cabeçalho da peça aberta.
    colunaHash: 'Hash com o protocolo',
    colunaGrau: 'Grau',
    colunaTendencia: 'Tendência',
    colunaAlertas: 'Alertas',
    colunaSituacao: 'Situação',
    situacaoConcluida: 'Concluído',
    situacaoADecidir: 'A decidir',
    abrirPeca: 'Abrir o documento {peca}',
    decisaoDaPeca: 'Decisão — {peca}',
    proximaPeca: 'Próximo documento',
    semProximaPeca: 'Não há outro documento a decidir.',
    apuradoCabecalho: 'O que foi apurado neste documento',

    // E162.F2.T02 (QA-18, ADR-0111 §2.6): a mesa como apoio — a conclusão da CCB e a revisão no
    // alto; a tabela, o quadro de cada documento e a conferência das etapas por expansão.
    conclusaoTitulo: 'Conclusão da CCB',
    conclusaoPeloSistema:
      'Conclusão apurada pelo sistema, já considerada nas prévias. Registrar a sua é facultativo.',
    registrarConclusao: 'Registrar a minha conclusão',
    recolherConclusao: 'Recolher sem registrar',
    semCcbAConcluir:
      'Nenhum documento deste caso pede conclusão: a CCB ainda não foi recebida ou identificada.',
    escolherCcb: 'CCB a decidir',
    detalheTitulo: 'Ver detalhe por documento',
    decisaoNoAlto: 'A conclusão desta CCB fica no alto da mesa.',
    apoioConferido: 'Conferido com a verificação; sem conclusão própria.',
    apoioAguarda: 'Aguarda a verificação.',
    situacaoApoioConferido: 'Conferido',
    situacaoApoioAguarda: 'Aguarda verificação',
  },

  laudoEletronico: {
    pageTitle: 'Laudo de assinatura eletrônica',
    pageSubtitle:
      'Documento do caso, montado a partir do que foi apurado e concluído em cada documento.',
    loading: 'Carregando o laudo…',
    naoPronto: 'O laudo ainda não pode ser emitido.',
    // E180.F2 (GUS-254): a conclusão do perito é facultativa; o que falta é a verificação.
    naoProntoPendentes:
      'Falta verificar {ccbs}: a verificação roda sozinha na pré-análise; aguarde e emita de novo.',
    naoProntoReguaAnterior:
      'Verifique novamente {ccbs}: a verificação usou uma versão anterior das regras.',
    naoProntoDesalinhadas:
      'Verifique novamente {ccbs}: a verificação usou um protocolo ou uma versão das regras diferente da dos demais documentos.',
    naoProntoRevisao:
      'O caso ainda aguarda homologação: registre-a na mesa, na revisão da proposta, e emita de novo.',
    naoProntoSemCcb: 'Este caso não tem CCB anexada: envie-a na pré-análise.',
    // E140.F2 (GUS-143): a falha técnica da leitura trava o documento até a equipe resolvê-la.
    naoProntoLeitura:
      'A leitura dos documentos tem pendência técnica em conferência. Resolva-a na análise preliminar antes de emitir.',
    // Owner, 04/11 (GT-2026-0076): sem perfil normativo para o ato, o documento não é composto.
    naoProntoSemPerfil:
      'Sem perfil normativo para o ato: o material recebido não traz a data do ato ou não identifica a modalidade da operação. Informe o que falta na mesa, aba Exame; o documento é composto em seguida.',
    irParaMesa: 'Voltar para a mesa',
    previsualizar: 'Pré-visualizar',
    previsualizando: 'Gerando a pré-visualização…',
    baixarPdf: 'Baixar PDF',
    baixarDocx: 'Baixar DOCX',
    baixando: 'Preparando o arquivo…',
    // F-E162.F2-02 (QA-21): baixar segue a prontidão que a tela já mostra, e diz por que espera.
    prontidaoDoDownload: {
      carregando: 'Conferindo se o laudo já pode ser emitido…',
      bloqueado: 'O laudo ainda não pode ser emitido. Motivo: {motivo}.',
      bloqueadoComPecas: 'O laudo ainda não pode ser emitido. Motivo: {motivo} ({pecas}).',
      semDocumento: 'O laudo ainda não pode ser emitido: ainda não há documento para conferir.',
    },
    errorGeneric: 'Não foi possível gerar o laudo. Tente novamente.',
    errorRender: 'Não foi possível montar o documento. Tente novamente em instantes.',
    errorNetwork: 'Sem conexão. Verifique a rede e tente novamente.',
  },

  // E78.F1 — a rota /casos/:id resolve para onde o caso vai. A tela só aparece
  // no intervalo entre carregar e redirecionar (ou quando o carregamento falha).
  casoDestino: {
    titulo: 'Abrindo o caso',
    carregando: 'Localizando a etapa em que este caso está…',
    erro: 'Não foi possível abrir o caso. Tente novamente.',
    naoEncontrado: 'Caso não encontrado.',
  },

  exameEletronico: {
    // E91.F2 (GUS-51 RF03/RF05) — o cabeçalho do resultado: o estado do caso
    // numa linha e a ação de exame ao lado dela, na preliminar e na mesa.
    // E91.F2 (GUS-51 RF05/RN01) — "Baixar exame" é descoberta, não regra nova:
    // a mesma saída do portal, com a mesma condição. Indisponível diz por quê.
    // E177.F1 (GUS-253 A1, ADR-0131 §2.3): o banco do caso que nasceu sem ele, informado na mesa.
    informarOBanco: {
      titulo: 'Informar o banco do caso',
      explicacao:
        'A leitura da CCB não identificou o banco do caso pelo CNPJ do credor: a instituição sai como não informada e a conferência não libera o exame. O banco vale para todos os exames do processo e não se troca depois; a prévia é refeita com ele.',
      gravar: 'Gravar o banco',
      gravando: 'Gravando…',
      erro: 'Não foi possível gravar o banco. Tente novamente.',
      erroJaInformado: 'O banco deste caso já foi informado. A página foi atualizada.',
    },
    baixarExame: {
      acao: 'Baixar exame',
      baixando: 'Preparando o exame…',
      semDocumentos: 'Exame disponível depois que houver documentos verificados.',
      pendenteDeVerificacao: 'Exame disponível depois que todos os documentos forem verificados.',
      emProcessamento: 'Exame disponível quando o processamento terminar.',
      erroNaoDisponivel:
        'O exame ainda não está disponível: falta verificar algum documento do caso.',
      // E111.F1 (S-03): a peça verificada antes da régua vigente não sai no documento.
      erroReguaAnterior:
        'Estes documentos foram verificados com a régua anterior e precisam ser verificados de novo antes de baixar: {pecas}.',
      erroGeneric: 'Não foi possível baixar o exame. Tente novamente.',
      erroNetwork: 'Sem conexão. Verifique a rede e tente novamente.',
      // E140.F2 (GUS-143): a falha técnica da leitura trava o exame até a equipe resolvê-la.
      erroLeituraEmConferencia:
        'A leitura dos documentos tem pendência técnica em conferência. Resolva-a no painel da conferência antes de baixar o exame.',
      // Owner, 04/11 (GT-2026-0076): o exame não sai no desenho anterior ao 3.7 sem perfil normativo.
      erroSemPerfil:
        'Sem perfil normativo para o ato: o material recebido não traz a data do ato ou não identifica a modalidade da operação. Informe o que falta na mesa, aba Exame; o documento é composto em seguida.',
      // E119.F2 (GUS-132, Z-04): o caso sem banco, avisado junto à emissão, sem trava.
      bancoDoCasoAusente:
        'Banco do caso não informado: o requerente e a identificação do credor saem sem ele. Informe o banco do caso antes de emitir.',
      // E124.F1 (GUS-134): a análise fotográfica automática ainda em andamento, sem trava.
      analiseFotograficaEmAndamento:
        'A conferência facial ainda está em andamento: se baixar agora, o documento sai sem ela. Aguarde alguns instantes para incluí-la.',
    },
    // E91.F2 (GUS-51 RF03) — as áreas de preparação ficam recolhidas atrás de
    // uma linha de resumo; o resultado vem primeiro.
    secoes: {
      recolher: 'Recolher',
      cadastroAbrir: 'Revisar cadastro',
      // E207.F6.T02: o envio da aba Documentos usa `documentosDoCaso.envio`; o resumo saiu.
    },
    // E89.F2 (GUS-50) — o processamento automático na chegada à tela. O servidor
    // decide o que verificar; a tela conta o que houve e nunca deixa o resultado
    // anterior passar por atual (RF05).
    processamentoAutomatico: {
      emAtualizacao: 'Em atualização',
      emAtualizacaoDetalhe: 'O resultado exibido é o anterior e será substituído ao terminar.',
      // E91.F3 (GUS-51 RF09): "concluído" é uma coisa; o que cada fonte
      // externa fez é outra. A faixa separa as duas e lista o que ficou
      // indisponível com palavras de operação — nunca o `detalhe` do servidor,
      // que nomeia serviço e configuração.
      concluidoUm: 'Processamento concluído: 1 documento verificado.',
      concluidoVarios: 'Processamento concluído: {n} documentos verificados.',
      consultas: {
        cluster_cadastral: {
          indisponivel: 'Consulta cadastral indisponível',
          sem_dado: 'Consulta cadastral não realizada: falta o CPF do caso',
          executada: 'Consulta cadastral realizada',
        },
        geocodificacao: {
          indisponivel: 'Localização não comparada: serviço indisponível',
          sem_dado: 'Localização não comparada: faltam endereços',
          executada: 'Localização dos endereços comparada',
        },
        classificacao_ip: {
          indisponivel: 'Endereços de rede não classificados',
          sem_dado: 'Endereços de rede não classificados: o protocolo não os informa',
          executada: 'Endereços de rede classificados',
        },
      },
      consultasDetalhe: 'O que cada fonte fez',
      consultasOcultar: 'Ocultar',
      // E91.F3.C02 (F-E91.F3-02): o que ficou sem consulta sai da faixa de
      // sucesso e ganha bloco de atenção próprio, com rótulo.
      consultasPendentesTitulo: 'O que ficou sem consulta',
      consultaNaoApurada: 'Não apurada neste processamento',
      falhaTitulo: 'Não foi possível processar o caso automaticamente.',
      falhaUltimoGravado: 'A tela mostra o último resultado gravado.',
      tentarDeNovo: 'Tentar novamente',
    },
    loading: 'Carregando as CCBs do caso…',
    semCcbs:
      'Este caso ainda não tem CCB anexada. Anexe a CCB questionada para informar o protocolo.',
    ccbTitulo: 'CCB {numero}',
    ccbOrdinal: 'CCB {n} de {total}',
    ccbSemNumero: 'CCB sem número informado',
    // E78.F1 — peça sem número de CCB: letra da posição + arquivo enviado. As
    // cinco peças do caso real não têm número, e sem isto ficavam idênticas.
    pecaSemNumero: 'Documento {letra} — {arquivo}',
    // E106.F3.C11 — a fotografia não tem letra no documento emitido; a tela a
    // identifica pelo que ela é (o arquivo diz a página de onde saiu).
    pecaSemLetra: '{arquivo}',
    // E78.F2 — o que fica por peça agora que o protocolo é do caso.
    observacoesDaPeca: 'Observações deste documento',
    // E91.F3: a caixa grava código E observação — o rótulo diz o que faz.
    salvarCodigoDaPeca: 'Salvar alterações',
    codigoDaPecaSalvo: 'Código do documento salvo.',
    protocoloDoCasoTitulo: 'Protocolo de assinatura do caso',
    verificarAsPecas: 'Verificar os documentos',
    protocoloSalvo: 'Protocolo do caso salvo.',
    errorProtocoloPecaConcluida:
      'Há documento já concluído neste caso. Reabra a conclusão antes de alterar o protocolo.',
    // E136.F3 (GUS-152, ADR-0092): a verificação para só o documento que depende de arquivo
    // fora do exame pela custódia; os demais seguem.
    errorCustodiaInterrompida:
      'Nenhum documento pôde ser verificado: cada um depende de um arquivo que não confere com o registro do recebimento. As ocorrências estão na custódia do caso.',
    // E193.F1.C15 (GUS-259 item 3): o caso digital parado não é verificado até chegar o que falta.
    errorAguardandoArquivos:
      'O caso aguarda arquivos e não é verificado até chegar o que falta. A lista está na pré-análise.',
    paradasPelaCustodia: {
      titulo: 'Documentos fora do exame pela custódia',
      proprio: '{documento}: o próprio arquivo não confere com o registro do recebimento.',
      dependencia:
        '{documento}: depende de um arquivo (o pacote, o arquivo de origem ou o material do banco) que não confere com o registro do recebimento.',
      retirado_do_exame: 'Retirado do exame por decisão de quem atende o caso.',
      reenviado_pelo_banco: 'O banco reenviou o arquivo; a versão anterior fica fora do exame.',
      explica:
        'Os demais documentos seguem no exame. A ocorrência e a resolução ficam na custódia do caso.',
    },
    // E136.F2 (CA08): de onde veio o código declarado que o hash confronta.
    fonteDoCodigo: {
      rotulo: 'Fonte do código declarado',
      protocolo: 'protocolo de assinatura',
      tela_impressa: 'tela impressa do sistema do banco',
      perito: 'informado pelo perito',
    },
    codigoPecaLabel: 'Código de verificação (SHA-256) do documento recebido',
    codigoPecaAusente: 'O documento recebido ainda não teve o código de verificação calculado.',
    statusSemProtocolo: 'Protocolo não informado',
    statusRascunho: 'Protocolo salvo',
    statusVerificado: 'Verificado',
    statusConcluido: 'Concluído',
    concluidoAviso: 'O perito já concluiu esta CCB; o protocolo e o quadro estão congelados.',
    errorGeneric: 'Não foi possível concluir a operação. Tente novamente.',
    errorCaseNotFound: 'Caso não encontrado.',
    errorDocumentNotFound: 'CCB não encontrada neste caso.',
    errorNotFound: 'Protocolo não encontrado para esta CCB.',
    errorModalidadeInvalida: 'Este caso não é da modalidade assinatura eletrônica.',
    errorSemProtocolo: 'Salve o protocolo de assinatura antes de verificar.',
    errorConcluido: 'O perito já concluiu esta CCB. O protocolo não pode mais ser alterado.',
    errorNaoVerificado: 'Verifique o protocolo desta CCB antes de registrar a conclusão.',
    errorConsultaPendente:
      'A consulta do sistema desta CCB não respondeu. Registre a limitação logo abaixo do botão de concluir (ou tente a consulta de novo) e conclua em seguida.',
    errorNaoConcluido: 'Esta CCB não tem conclusão registrada para reabrir.',
    errorJustificativaRequerida:
      'O grau apurado foi outro. Explique a mudança no campo de justificativa antes de concluir.',
    errorCertificacaoRequerida:
      'A certificação desta CCB já foi solicitada — o resultado saiu para o cliente e a conclusão não pode mais ser reaberta.',
    errorValidation: 'Há campos fora do formato esperado. Revise o protocolo e tente de novo.',
    errorForbidden: 'O seu perfil não pode informar o protocolo deste caso.',
    errorNetwork: 'Sem conexão. Verifique a rede e tente novamente.',
    form: {
      titulo: 'Protocolo de assinatura',
      intro:
        'Transcreva o certificado de conclusão (ou manifesto) da plataforma de assinatura. Todos os campos são opcionais: o que faltar aparece como ausência no quadro, não bloqueia a verificação.',
      secaoIdentificacao: 'Identificação do protocolo',
      secaoSignatario: 'Signatário',
      secaoEventos: 'Trilha de aceite (eventos)',
      secaoIps: 'Endereços IP',
      secaoCoordenada: 'Geolocalização',
      secaoDispositivo: 'Dispositivo',
      secaoBiometria: 'Biometria',
      secaoObservacoes: 'Observações',
      plataforma: 'Plataforma de assinatura',
      codigoVerificacao: 'Código de verificação do protocolo',
      // E93.F1 (GUS-56 RN10) — só o endereço que o comprovante imprime.
      urlVerificacao: 'Endereço de verificação da plataforma',
      urlVerificacaoHint:
        'O link de validação impresso no comprovante, junto do código. Deixe em branco se o comprovante não traz um.',
      urlVerificacaoErro: 'Informe o endereço completo, começando por http:// ou https://.',
      proposta: 'Número da proposta',
      // E84.F4 — a linha de status do comprovante; o mesmo controle em UTC dos eventos.
      assinaturaRegistradaEm: 'Assinatura registrada em (UTC)',
      assinaturaRegistradaEmHint:
        'O instante em que a plataforma registrou a assinatura, lido da linha de status do comprovante.',
      assinaturaRegistradaEmPresumido:
        'O sinal do fuso estava ilegível no comprovante e foi presumido negativo (UTC-03:00). Confira e edite se necessário.',
      envelopeId: 'ID do envelope',
      assinaturaId: 'ID da assinatura',
      hashDeclarado: 'Código de verificação (SHA-256) declarado',
      hashDeclaradoHint:
        '64 caracteres hexadecimais, como impresso no protocolo. Espaços e maiúsculas são normalizados.',
      hashDeclaradoErro:
        'O código de verificação declarado precisa ter 64 caracteres hexadecimais.',
      tipoAssinatura: 'Tipo de assinatura',
      tipoAssinaturaOpcoes: {
        nao_informado: 'Não informado',
        qualificada_icp: 'Qualificada (certificado ICP-Brasil)',
        avancada: 'Avançada',
        simples: 'Simples',
      },
      tipoAssinaturaTexto: 'Tipo de assinatura, como impresso',
      tipoAssinaturaTextoHint: 'A frase do comprovante de onde a classificação acima foi lida.',
      formatoDaData: 'Formato da data no comprovante',
      formatoDaDataHint:
        'Como esta plataforma imprime a data. É esta declaração — e nunca a data de arquivo — que resolve a leitura do dia do ato.',
      formatoDaDataOpcoes: {
        '': 'Não declarado',
        dia_mes: 'Dia/mês (07/05 = 7 de maio)',
        mes_dia: 'Mês/dia (07/05 = 5 de julho)',
      },
      formatoDaDataDoCatalogo:
        'Proposto pelo catálogo a partir da plataforma informada. Confira e edite se o comprovante mostrar outra coisa.',
      signatarioNome: 'Nome',
      signatarioCpf: 'CPF',
      signatarioEmail: 'E-mail',
      signatarioTelefone: 'Telefone',
      eventoTipo: 'Evento',
      eventoTipoOpcoes: {
        envio_do_link: 'Envio do link',
        autenticacao_de_acesso: 'Autenticação de acesso',
        visualizacao: 'Visualização',
        aceite: 'Aceite',
        autenticacao: 'Autenticação',
        biometria: 'Biometria',
        assinatura: 'Assinatura',
        biometria_de_fechamento: 'Biometria ao fim da contratação',
        aprovacao: 'Aprovação pela instituição',
        liberacao: 'Liberação do crédito',
      },
      eventoEmUtc: 'Data/hora (UTC)',
      eventoEmLocal: 'Data/hora (local)',
      eventoDescricao: 'Descrição',
      eventoAdicionar: 'Adicionar evento',
      eventoRemover: 'Remover evento',
      eventoVazio: 'Nenhum evento informado.',
      eventoSemHorario: 'Cada evento precisa de data/hora UTC ou local.',
      eventoLocalHint: 'O horário local é gravado com o fuso deste navegador.',
      ipEndereco: 'Endereço IP',
      ipPapel: 'Papel',
      ipPapelOpcoes: { cliente: 'Cliente', servidor: 'Servidor', nao_declarado: 'Não declarado' },
      ipAdicionar: 'Adicionar IP',
      ipRemover: 'Remover IP',
      ipVazio: 'Nenhum IP informado.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      precisaoM: 'Precisão (m)',
      fonteCoordenada: 'Fonte da coordenada',
      fonteCoordenadaOpcoes: {
        nao_informada: 'Não informada',
        gps: 'GPS',
        wifi: 'Wi-Fi',
        rede_celular: 'Rede celular',
        navegador: 'Navegador',
        ip: 'Derivada do IP',
      },
      coordenadaIncompleta: 'Informe latitude e longitude juntas, ou deixe as duas vazias.',
      userAgent: 'Identificação do navegador (user agent)',
      fingerprint: 'Impressão do dispositivo',
      biometriaPresente: 'A plataforma registrou biometria',
      biometriaSessaoId: 'ID da sessão biométrica',
      biometriaScore: 'Pontuação',
      biometriaThreshold: 'Limiar de aceitação',
      biometriaProvaDeVida: 'Prova de vida',
      biometriaProvaDeVidaOpcoes: { nao_informado: 'Não informado', sim: 'Sim', nao: 'Não' },
      biometriaFornecedor: 'Fornecedor',
      observacoes: 'Observações',
      salvar: 'Salvar protocolo',
      salvando: 'Salvando…',
      salvo: 'Protocolo salvo.',
      verificar: 'Verificar',
      verificando: 'Verificando…',
      verificarHint: 'Salve o protocolo para liberar a verificação.',
      // E84.F7 (GUS-45 RF01): o outro motivo de o botão estar travado. A
      // verificação roda sobre o que está gravado, então ela não pode rodar
      // com um código digitado e não salvo em tela.
      verificarHintPecas:
        'Há documento com código alterado e não salvo. Salve ou descarte a alteração para liberar a verificação.',
      atualizarConsultas: 'Atualizar fontes externas',
      atualizandoConsultas: 'Consultando…',
      atualizarConsultasHint:
        'Refaz as consultas às fontes cadastrais, de localização e de rede. Sem isso, a verificação reaproveita o que já foi consultado neste caso — e o quadro não muda entre duas verificações do mesmo protocolo.',
    },
    quadro: {
      titulo: 'Quadro de verificação',
      semResultado: 'Salve o protocolo e clique em Verificar para montar o quadro.',
      integridade: 'Integridade',
      identidade: 'Identidade e vinculação',
      colunaItem: 'Item',
      colunaSituacao: 'Situação',
      colunaEsperado: 'Esperado',
      colunaObtido: 'Obtido',
      colunaDetalhe: 'Detalhe',
      itens: {
        hash_ccb: 'Código de verificação (SHA-256) da CCB',
        custodia_interna: 'Cadeia de custódia interna',
        cpf_signatario: 'CPF do signatário',
        nome_signatario: 'Nome do signatário',
        envelope_id: 'ID do envelope',
        assinatura_id: 'ID da assinatura',
        sessao_biometrica: 'Sessão biométrica',
        tipo_assinatura: 'Tipo de assinatura',
        vinculo_da_biometria: 'Transação biométrica × validação de identidade',
        vinculo_do_envelope: 'Identificador do envelope nas páginas',
        intervalo_da_biometria: 'Captura biométrica × assinatura',
        cluster_cadastral: 'Endereços vinculados ao titular',
        geocodificacao: 'Localização dos endereços',
        classificacao_ip: 'Classificação dos endereços IP',
        assinatura_digital_presente: 'Assinatura digital embutida no arquivo',
        assinatura_digital_integridade: 'Integridade criptográfica da assinatura',
        assinatura_digital_abrangencia: 'Abrangência da assinatura sobre o arquivo',
        assinatura_digital_cadeia: 'Cadeia até autoridade raiz da ICP-Brasil',
        assinatura_digital_revogacao: 'Situação de revogação do certificado',
        assinatura_digital_signatario: 'Titular do certificado que assinou',
        assinatura_digital_carimbo: 'Carimbo do tempo de autoridade',
        assinatura_digital_aparencia: 'Aparência de assinatura no texto do documento',
        metadado_datas: 'Datas de criação e de modificação declaradas',
        metadado_modificacao_no_ato: 'Modificação do arquivo em relação ao ato',
        metadado_origem: 'Origem do arquivo',
        metadado_salvamentos: 'Gravações do arquivo',
        peca_codigo_de_registro: 'Código de registro da transação embutido no documento',
        peca_cpf: 'CPF do titular no texto do documento',
        peca_nome: 'Nome do signatário no texto do documento',
        peca_proposta: 'Número da proposta no texto do documento',
        // E157.F2 (ADR-0107 §2.6): os códigos lidos das páginas e os dois estados explícitos.
        codigos_lidos: 'Códigos bidimensionais lidos das páginas',
        codigos_consulta_ao_portal: 'Consulta ao portal de verificação',
        codigos_de_barras: 'Códigos de barras unidimensionais',
        cronologia_formato_de_data: 'Formato das datas do comprovante',
        cronologia_registro_da_assinatura:
          'Registro da assinatura no comprovante em relação ao ato',
        cronologia_assinatura_embutida: 'Assinatura embutida em relação ao ato',
        cronologia_custodia: 'Entrada na cadeia de custódia em relação ao ato',
      },
      // E84.F4 — a linha do tempo consolidada: todos os instantes numa só ordem,
      // com a fonte ao lado.
      jornada: {
        titulo: 'Eventos e horários', // E156.F3 (ADR-0106 §2.8): era "Linha do tempo consolidada".
        subtitulo:
          'Revise as diferenças e os limites; a cronologia já chega organizada, com a fonte de cada instante.',
        limite:
          'Instantes declarados e verificados são distintos. Fuso ausente e ticks ambíguos não recebem precisão inventada.',
        semInstantes: 'Nenhuma fonte trouxe instante datado para este documento.',
        naoExaminada:
          'Este exame foi verificado antes de a linha do tempo consolidada integrar a metodologia; só os eventos do protocolo foram examinados.',
        declaratoria:
          'Os instantes são apresentados na ordem cronológica, cada um com a fonte de onde foi lido; não há ordem esperada entre fontes distintas — a coerência entre elas é o que os itens de cronologia confrontam.',
        lidoEmMesDia: 'Lido em mês/dia',
        fusoPresumido: 'Fuso presumido',
        // E156.F3 — os registros da jornada no painel: vínculo, origem, sem fuso, leitura, ticks, dúvidas.
        origem: { linha: 'linha' },
        vinculo: {
          identificador: 'Vínculo por identificador',
          indicio: 'Indício',
          sem_identificador: 'Sem identificador',
          equivalente: 'Confirma o protocolo',
        },
        semFuso: {
          titulo: 'Sem fuso declarado',
          selo: 'Sem fuso',
          nota: 'Horário como consta na fonte, sem posição na linha do tempo; uma hipótese de fuso serve só para conferência, não para ordem nem contemporaneidade.',
        },
        leitura: {
          titulo: 'Leitura registrada',
          nenhuma:
            'Nenhum par registrado de disponibilização ou abertura e aceite na mesma sessão ou documento; o envio da notificação não conta como abertura.',
          ateOAceite: 'até o aceite',
          segundos: 'segundos',
          semPrecisao:
            'Limites do intervalo: o registro não traz os segundos ou a hora de uma das pontas.',
          apressada: 'Abaixo do intervalo mínimo de leitura',
        },
        ticks: {
          titulo: 'Ticks no nome do arquivo',
          semFuso: 'Sem fuso',
          semCaptura: 'Sem captura registrada coincidente',
          limite:
            'Nome de arquivo não é carimbo autenticado: o instante lido do nome corrobora ou levanta dúvida, nunca prova data.',
        },
        registros: {
          titulo: 'Registros recebidos',
          nenhum: 'Nenhuma planilha ou registro de eventos recebido para este caso.',
          eventosLidos: 'eventos lidos',
          desteDocumento: 'deste documento',
          semIdentificador: 'sem identificador',
          linhasSemLeitura: 'linhas sem leitura',
          fusoInvalido: 'com fuso fora da faixa (de UTC-12:00 a UTC+14:00)',
          motivos: {
            formato_sem_leitor: 'Formato sem leitor',
            sem_coluna_de_instante: 'Sem coluna de data e hora',
            sem_linhas: 'Sem linha com data e hora',
            ilegivel: 'Conteúdo ilegível',
          },
        },
        duvidas: {
          titulo: 'Dúvidas para a operação',
          nota: 'Linhas com data e hora, mas sem identificador do contrato, da proposta, do documento ou da sessão: não entram na linha do tempo.',
        },
        fontes: {
          protocolo: 'Protocolo',
          instrumento: 'Carimbo do instrumento',
          comprovante: 'Comprovante',
          // E156.F1 — a planilha ou o log de eventos que o banco entregou.
          registro: 'Registro da jornada',
          arquivo: 'Arquivo',
          assinatura_embutida: 'Assinatura embutida',
          carimbo_do_tempo: 'Carimbo do tempo',
          custodia: 'Custódia',
        },
        rotulos: {
          carimbo_do_instrumento: 'Carimbo do instrumento',
          registro_da_assinatura: 'Registro da assinatura pela plataforma',
          criacao_do_arquivo: 'Criação do arquivo declarada',
          modificacao_do_arquivo: 'Última modificação do arquivo declarada',
          hora_da_assinatura: 'Hora declarada na assinatura embutida',
          carimbo_do_tempo: 'Carimbo do tempo de autoridade',
          entrada_na_custodia: 'Entrada do documento na cadeia de custódia',
          // E156.F1 — os papéis do evento registrado que não são tipo do protocolo.
          disponibilizacao: 'Disponibilização do documento',
          captura_da_foto: 'Captura da foto',
          aprovacao_do_banco: 'Aprovação pelo banco',
          geracao_do_arquivo: 'Geração do arquivo',
          evento_registrado: 'Evento registrado',
          // E156.F2 — o instante decodificado do nome do arquivo, sem fuso.
          ticks_do_nome_do_arquivo: 'Ticks no nome do arquivo',
        },
      },
      // E84.F3 — o vínculo da peça com a transação, lido do texto da própria peça.
      vinculo: {
        titulo: 'Vínculo do documento com a transação',
        codigoDaTransacao: 'Código de registro da transação',
        codigosLidos: 'Códigos de registro lidos no documento',
        codigosDasPaginas: 'Códigos lidos das páginas',
        nenhum: 'nenhum',
        naoInformado: 'não informado',
        semTexto:
          'O documento não traz camada de texto legível; o código de registro, o CPF, o nome e a proposta não puderam ser procurados no arquivo.',
        naoExaminado:
          'Este exame foi verificado antes de a leitura do texto do documento integrar a metodologia.',
        declaratorio:
          'O código de registro, o CPF, o nome e a proposta foram procurados na camada de texto do próprio documento, que é declaração da plataforma emissora; a leitura sustenta o vínculo com a contratação e não substitui a prova de integridade.',
      },
      // E84.F2 — a ficha do que o próprio arquivo declara sobre si.
      arquivo: {
        ficha: 'O que o arquivo declara sobre si',
        criadoEm: 'Data de criação declarada',
        modificadoEm: 'Data da última modificação declarada',
        fonteDasDatas: 'Fonte das datas',
        fonteDasDatasOpcoes: {
          info: 'dicionário de informações do arquivo',
          xmp: 'metadados XMP do arquivo',
        },
        produtor: 'Produtor',
        criador: 'Aplicativo criador',
        autor: 'Autor declarado',
        titulo: 'Título declarado',
        salvamentos: 'Gravações do arquivo',
        naoInformado: 'não informado',
        semFuso: 'fuso não declarado',
        semDicionario:
          'O arquivo não traz dicionário de informações legível; nenhuma data de criação ou de modificação pôde ser lida.',
        naoExaminado:
          'Este exame foi verificado antes de a leitura dos metadados do arquivo integrar a metodologia.',
        declaratorios:
          'As datas, o produtor e as gravações são declarações do próprio arquivo, editáveis por qualquer ferramenta; sustentam a leitura da jornada, mas não substituem a prova de integridade.',
        // E97.F4.T04: o documento saiu de um arquivo com vários documentos.
        origemTitulo: 'Arquivo de onde o documento saiu',
        origemCorpo:
          'Este documento está contido em {nome} ({paginas}). A assinatura digital e as declarações acima são as desse arquivo; o texto e o SHA-256 conferidos são os do documento.',
        origemHash: 'SHA-256 do arquivo recebido: {hash}',
      },
      // E97.F3/F4.T04: a assinatura que o arquivo carrega e não sustenta.
      vestigio: {
        titulo: 'Vestígio de assinatura digital',
        corpo:
          'O arquivo carrega uma assinatura digital que não é verificável nele: ela está fora do formulário de assinatura e a faixa assinada descreve outro arquivo. É o sinal de uma conversão posterior do original assinado; a conferência exige o PDF original.',
        titular: 'Certificado de',
        emissor: 'Emitido por',
        validade: 'Validade do certificado',
        declaradaEm: 'Data declarada da assinatura',
        vencido: 'O certificado já estava vencido na data declarada da assinatura.',
        faixa:
          'A faixa assinada descreve um arquivo de {assinados} bytes; o recebido tem {tamanho}.',
        semCarimbo: 'A assinatura não traz carimbo do tempo.',
        naoInformado: 'não informado',
      },
      situacao: {
        confere: 'Confere',
        nao_confere: 'Não confere',
        ausente: 'Ausente',
        inconclusivo: 'Inconclusivo',
        nao_executado: 'Não executado',
      },
      linhaDoTempo: 'Linha do tempo',
      linhaDoTempoVazia: 'Nenhum evento informado no protocolo.',
      sequenciaIlogica: 'A sequência dos eventos é ilógica (evento posterior registrado antes).',
      foraDeOrdem: 'Fora de ordem',
      utcLocalIncoerentes: 'UTC e local incoerentes',
      semHorario: '—',
      enriquecimento: 'Fontes externas',
      assinaturaDigital: 'Assinatura digital embutida',
      assinaturaDigitalNaoExaminada:
        'Este exame foi verificado antes de a conferência da assinatura digital embutida integrar a metodologia.',
      assinaturaDigitalCampo: 'Campo de assinatura',
      assinaturaDigitalCertificado: 'Certificado',
      assinaturaDigitalSemCertificado:
        'Não apresentado — a assinatura não trouxe certificado de onde extrair o titular',
      assinaturaDigitalEmissor: 'Emitido por',
      assinaturaDigitalSerie: 'Série',
      assinaturaDigitalCnpj: 'CNPJ do titular do certificado',
      assinaturaDigitalPapelTitular: 'Assinatura do titular do caso',
      assinaturaDigitalPapelTerceiro: 'Assinatura de terceiro',
      assinaturaDigitalIntegridadeAssinatura: 'Integridade desta assinatura',
      assinaturaDigitalSituacaoRevogacao: 'Situação de revogação desta assinatura',
      assinaturaDigitalRevogacaoOpcoes: {
        nao_revogado_no_material: 'Não revogado no material embutido',
        revogado: 'Revogado no material embutido',
        autoridade_revogada: 'Autoridade da cadeia revogada no material embutido',
        nao_conferivel: 'Não foi possível conferir',
      },
      assinaturaDigitalImpressao: 'Código de verificação (SHA-256) do certificado',
      assinaturaDigitalAssinadoEm: 'Data declarada da assinatura',
      assinaturaDigitalCarimboEm: 'Carimbo do tempo',
      assinaturaDigitalCarimboAutoridade: 'Autoridade carimbadora',
      assinaturaDigitalCarimboConfirmada: 'Cadeia confirmada até uma raiz de confiança',
      assinaturaDigitalCarimboNaoConfirmada: 'Cadeia não confirmada até uma raiz de confiança',
      assinaturaDigitalCarimboNaoIntegro:
        'Carimbo não íntegro/válido — a cadeia da autoridade nem foi avaliável',
      assinaturaDigitalAlgoritmoHash: 'Algoritmo de resumo criptográfico',
      assinaturaDigitalMecanismoAssinatura: 'Mecanismo de assinatura',
      // E157.F1 (ADR-0107 §2.1 e §2.2): a data pertinente com a origem e a consulta em linha.
      assinaturaDigitalInstantePertinente: 'Data pertinente da conferência',
      assinaturaDigitalInstanteOrigem: {
        carimbo_confiavel: 'fixada pelo carimbo do tempo confiável',
        instante_do_exame: 'data de execução do exame, sem carimbo do tempo confiável',
      },
      assinaturaDigitalDeclaradoPeloSignatario: 'Data declarada pelo signatário',
      assinaturaDigitalConsultaEmLinha: 'Consulta em linha de revogação',
      assinaturaDigitalConsultaNaoExecutada: 'não executada',
      assinaturaDigitalLimite:
        'A situação de revogação foi conferida nas listas que o próprio arquivo embute, sem consulta em linha, tendo por referência o instante de execução do exame.',
      assinaturaDigitalRevogacaoNaoExaminada:
        'Este exame foi verificado antes de a conferência da situação de revogação integrar a metodologia; a situação de revogação não foi conferida.',
      assinaturaDigitalVereditoRotulo: 'Veredito da assinatura digital',
      assinaturaDigitalVereditoOpcoes: {
        confirmada: 'Confirmada',
        nao_confirmada: 'Não confirmada',
        nao_foi_possivel_confirmar: 'Não foi possível confirmar',
        nao_se_aplica: 'Não se aplica',
      },
      assinaturaDigitalRevogacaoNaoExecutada:
        'A conferência da situação de revogação não foi executada neste exame: as referências necessárias para conferir a cadeia não estavam disponíveis. Nenhuma situação individual de revogação é declarada.',
      cluster: 'Endereços vinculados',
      clusterVazio: 'Nenhum endereço vinculado foi apurado.',
      colunaPessoa: 'Pessoa',
      colunaVinculo: 'Vínculo',
      colunaEndereco: 'Endereço',
      colunaFonte: 'Fonte',
      colunaDataFonte: 'Data da fonte',
      colunaDistancia: 'Distância',
      colunaProximidade: 'Proximidade',
      vinculoOpcoes: {
        titular: 'Titular',
        conjuge: 'Cônjuge',
        ascendente: 'Ascendente',
        descendente: 'Descendente',
        colateral: 'Colateral',
        trabalho: 'Trabalho',
        outro: 'Outro',
      },
      faixaOpcoes: {
        ate_100m: 'Até 100 m',
        ate_500m: 'De 100 m a 500 m',
        ate_2km: 'De 500 m a 2 km',
        ate_10km: 'De 2 km a 10 km',
        acima_10km: 'Acima de 10 km',
        indeterminada: 'Não medida',
      },
      clusterCautela:
        'Proximidade é elemento de corroboração, nunca prova isolada de quem contratou.',
      ips: 'Endereços IP',
      ipAsn: 'Sistema autônomo',
      // E168.F3.C01 (QA de 24/10): o papel e a natureza que o exame apura, não o tipo bruto.
      ipRedeDeEntrega: 'Rede de entrega (caminho da conexão, não o signatário)',
      ipRedeDaInstituicao:
        'Rede da instituição ({instituicao}): não indica residência nem o titular',
      coordenadaSemRaio: 'Precisão não informada',
      ipTipo: {
        residencial: 'Residencial',
        movel: 'Móvel',
        datacenter: 'Datacenter',
        vpn_proxy: 'VPN/proxy',
        desconhecido: 'Não classificado',
      },
      coordenada: 'Geolocalização',
      coordenadaFonte: 'Fonte',
      coordenadaPrecisao: 'Raio de precisão',
      coordenadaSemPrecisao: 'Não informado',
      coordenadaQualidade: 'Confiabilidade',
      qualidadeOpcoes: {
        confiavel: 'Confiável',
        limitada: 'Limitada',
        ausente: 'Ausente',
      },
      qualidadeLimitadaHint:
        'Sem raio de precisão ou com origem imprecisa: a leitura de proximidade é conservadora.',
      // E182.F1 (ADR-0135 §2.1): o resultado principal da geolocalização.
      geolocalizacaoPrincipal: 'Distância do ato ao endereço declarado',
      geolocalizacaoPrincipalComoLer:
        'Resultado principal da geolocalização: a coordenada do ato confrontada, em linha reta, com o endereço que o signatário declarou no contrato.',
      geolocalizacaoSemDistancia: 'A distância ao endereço declarado não foi medida.',
      precisaoDoEnderecoOpcoes: {
        building: 'localizado no número do imóvel',
        amenity: 'localizado no número do imóvel',
        street: 'localizado na via, sem o número',
        postcode: 'localizado pelo CEP',
        suburb: 'localizado pelo bairro',
        district: 'localizado pelo bairro',
        city: 'localizado só pelo município',
        county: 'localizado só pela região',
        state: 'localizado só pelo estado',
      },
      // E90.F2/F3 (GUS-14): onde o ato aconteceu e os mapas. Só descritivo.
      confronto: 'Confronto de localização',
      confrontoNaoApurado:
        'O confronto de localização não foi apurado nesta verificação. Verifique o exame novamente para apurá-lo.',
      colunaReferencia: 'Referência',
      colunaMunicipio: 'Município',
      colunaDistanciaAoAto: 'Distância ao ato',
      colunaLeitura: 'Leitura',
      localDoAto: 'Local do ato',
      localDoAtoConfere: 'Ponto registrado no protocolo',
      enderecoDeclarado: 'Endereço declarado do signatário',
      semEnderecoDeclarado: 'O cadastro do caso não traz endereço do signatário.',
      enderecoDeRede: 'Endereço de rede {endereco} ({papel})',
      papelRede: {
        cliente: 'signatário',
        servidor: 'plataforma',
        nao_declarado: 'papel não declarado',
      },
      papelRedeDeEntrega: 'rede de entrega',
      papelRedeDaInstituicao: 'rede da instituição',
      confiancaDaGeocodificacao: 'Confiança da geocodificação {confianca}',
      coordenadaDoEndereco: 'coordenada {lat}, {lon}',
      municipioNaoIdentificado: 'Não identificado',
      coberturaOpcoes: {
        cobre: 'Cobre o local do ato (raio de {raio} km)',
        nao_cobre: 'Não cobre o local do ato (raio de {raio} km)',
        nao_conclusivo: 'Não permite concluir',
        indeterminada: 'Distância não medida',
        nao_se_aplica: 'Não se aplica',
      },
      precisaoRedeOpcoes: {
        muito_alta: 'Precisão declarada muito alta',
        alta: 'Precisão declarada alta',
        media: 'Precisão declarada média',
        baixa: 'Precisão declarada baixa',
        muito_baixa: 'Precisão declarada muito baixa',
        nao_informada: 'Precisão não declarada',
      },
      confrontoCautela:
        'A localização estimada de um endereço de rede tem precisão de cidade: é indicador, não prova de onde o signatário estava. O confronto não altera o grau do exame.',
      mapas: 'Mapas',
      mapaTitulo: { local_do_ato: 'Local do ato', confronto: 'Confronto de localização' },
      mapaAlt: {
        local_do_ato: 'Mapa do local do ato',
        confronto: 'Mapa do confronto de localização',
      },
      mapaRaio: {
        local_do_ato: 'Círculo: raio de precisão da coordenada ({raio})',
        confronto: 'Círculo: raio de cobertura do endereço de rede ({raio})',
      },
      mapaNaoGerado: 'Mapa não gerado: {motivo}',
      mapaCarregando: 'Carregando o mapa…',
      mapaFalhou: 'Não foi possível carregar o mapa.',
      mapasNaoConstam: 'Os mapas não constam desta verificação.',
      // Exceção declarada da regra de nomes (naming-conventions.md, ADR-0081 §2.5): aviso de licença.
      mapaAtribuicao:
        'Dados cartográficos: © colaboradores do OpenStreetMap (licença ODbL), © OpenMapTiles; imagem de base: Geoapify', // branding:allow atribuicao-de-licenca
      redFlags: 'Indicadores de alerta',
      redFlagsVazio: 'Nenhum indicador de alerta.',
      severidade: { alta: 'Alta', media: 'Média' },
      ausencias: 'Ausências declaradas',
      ausenciasVazio: 'Nenhuma ausência: todos os insumos foram informados.',
      grau: 'Grau de convergência',
      grauOpcoes: {
        forte: 'Forte',
        medio: 'Médio',
        fraco: 'Fraco',
        inconclusivo: 'Inconclusivo',
        inconsistente: 'Inconsistente',
      },
      tendencia: 'Tendência',
      versao: 'Parâmetros',
      executadoEm: 'Verificado em',
    },

    // E78.F3 — o mesmo quadro lido por eixo. As frases dizem o que cada eixo
    // confronta; sem elas o perito via uma pilha de itens sem saber contra o
    // quê cada um foi conferido.
    eixos: {
      titulo: 'Quadro de verificação',
      pecaTitulo: '{peca} · quadro de verificação',
      nomes: {
        integridade: 'Integridade',
        arquivo: 'Arquivo',
        identidade: 'Identidade',
        trilha: 'Trilha no tempo',
        rede: 'Rede',
        localizacao: 'Localização',
        contrato: 'Contrato e apoio',
        alertas: 'Alertas',
      },
      confronta: {
        integridade:
          'Confronta o código de verificação declarado no protocolo com o recalculado sobre o documento recebido, e o que o próprio arquivo carrega.',
        arquivo:
          'Confronta as datas de criação e de modificação, o produtor e as gravações que o próprio arquivo declara com o instante do ato registrado no protocolo.',
        identidade:
          'Confronta o signatário e os identificadores declarados no protocolo com o que o caso já registra do titular, e o que o próprio documento imprime: código de registro da transação, CPF, nome e proposta.',
        trilha:
          'Confronta a ordem e a coerência dos horários dos eventos da trilha de aceite, e reúne numa só linha do tempo, com a fonte ao lado, o registro da assinatura no comprovante, as datas do arquivo, a assinatura embutida e a entrada na custódia — confrontados com o instante do ato.',
        rede: 'Confronta os endereços de rede registrados no ato com a classificação apurada de cada um.',
        localizacao:
          'Confronta a coordenada registrada no ato com os endereços que a fonte cadastral vincula ao titular na data da consulta.',
        contrato:
          'Confronta o bem financiado entre os documentos do contrato, os campos essenciais que outro signatário preencheu depois do cliente, as datas da emissão e da informação prévia, os documentos declarados no envelope e as leituras dos documentos de apoio confirmadas pelo perito.',
        alertas: 'Reúne os indicadores de alerta apurados e as ausências que o exame declarou.',
      },
      contadorDivergencia: '{n} divergência apurada',
      contadorDivergencias: '{n} divergências apuradas',
      contadorConfere: '{n} item sem divergência',
      contadorConferem: '{n} itens sem divergência',
      contadorVazio: 'sem itens examinados',
      colunaItem: 'Item',
      colunaSituacao: 'Situação',
      // E91.F3 (GUS-51 RF07): o cabeçalho genérico não atribui fonte a
      // ninguém; cada linha diz de onde veio cada lado (UXD-07).
      colunaConfronto: 'Referência × Valor comparado',
      colunaDetalhe: 'Detalhe',
      fontes: {
        protocolo: 'Protocolo',
        // E91.F3.C01: lados que são regra do exame, não dado de documento —
        // criação ≤ modificação no arquivo; uma leitura sustentada por todas
        // as âncoras no formato das datas. E o que a resolução das datas fez.
        regra_de_consistencia: 'Regra de consistência',
        resolucao_das_datas: 'Resolução das datas',
        arquivo_recebido: 'Arquivo recebido',
        arquivo: 'Arquivo',
        arquivo_armazenado: 'Arquivo armazenado',
        registro_de_recebimento: 'Registro de recebimento',
        cadastro_do_caso: 'Cadastro do caso',
        texto_do_documento: 'Texto do documento',
        comprovante: 'Comprovante',
        consulta_cadastral: 'Consulta cadastral',
        consulta_de_localizacao: 'Consulta de localização',
        consulta_de_rede: 'Consulta de rede',
      },
      fonteDesconhecidaReferencia: 'Referência',
      fonteDesconhecidaComparado: 'Valor comparado',
      // E91.F3 (RF06): a explicação de cada eixo vira ajuda sob demanda.
      comoLer: 'Como ler',
      ocultarComoLer: 'Ocultar',
      assinaturaNaoSeAplica:
        'O arquivo não traz assinatura criptográfica. A conferência de integridade, cadeia, revogação e carimbo do tempo não foi acionada neste documento.',
      // E98.F7.T06 — o arquivo exportado pela plataforma de envelope: sem assinatura do signatário, com o selo conferido.
      assinaturaNaoSeAplicaComSelo:
        'O arquivo não traz assinatura digital do signatário. O selo que a plataforma aplicou ao exportar foi conferido e está descrito abaixo.',
      metodologia: 'Metodologia',
      metodologiaLinha: 'Parâmetros {versao} · verificado em {quando}',
    },

    // E98.F7.T01 — o eixo "Contrato e apoio" do quadro da CCB (kit de veículos e documentos de
    // apoio). Os rótulos dos itens moram aqui, com paridade com as chaves do motor.
    contrato: {
      bemTitulo: 'Bem financiado em cada documento',
      colunaDocumento: 'Documento',
      colunaVeiculo: 'Veículo (marca e versão)',
      colunaAno: 'Ano (fab./mod.)',
      colunaCor: 'Cor',
      colunaChassi: 'Chassi',
      colunaValor: 'Valor',
      preenchidosTitulo: 'Campos preenchidos depois da assinatura do cliente',
      preenchidosVazio: 'Nenhum campo preenchido depois da assinatura do cliente foi apurado.',
      colunaCampo: 'Campo',
      colunaValorPreenchido: 'Valor',
      colunaQuem: 'Quem preencheu',
      colunaQuando: 'Quando',
      colunaPagina: 'Página',
      colunaNatureza: 'Natureza',
      natureza: { fato: 'Fato apurado', indicio: 'Indício' },
      naturezaNota:
        'Fato: registrado nas abas do envelope, com quem preencheu e quando. Indício: sem as abas, a data de emissão coincide com a assinatura de outro signatário, e não com a do cliente.',
      conferenciasTitulo: 'Conferências do contrato e dos documentos de apoio',
      diligenciasTitulo: 'Diligências',
      semValor: '—',
      itens: {
        bem_marca_e_versao: 'Veículo (marca e versão) entre os documentos',
        bem_ano: 'Ano do bem entre os documentos',
        bem_cor: 'Cor do bem entre os documentos',
        bem_chassi: 'Chassi do bem entre os documentos',
        bem_valor: 'Valor do bem entre os documentos',
        campo_preenchido_depois: 'Campos essenciais preenchidos depois da assinatura',
        emissao_e_bloco_de_assinatura: 'Data de emissão × bloco de assinatura',
        informacao_previa_e_aceite: 'Informação prévia (orçamento) × aceite',
        documentos_do_envelope_recebidos: 'Documentos declarados no envelope e recebidos',
        // E101.F4: o dossiê em imagem, sobre as leituras confirmadas.
        bem_marca: 'Marca do bem entre os documentos',
        bem_combustivel: 'Combustível do bem entre os documentos',
        placa_da_fotografia: 'Placa da fotografia × CRLV',
        data_da_fotografia: 'Data da fotografia × assinatura',
        local_declarado: 'Local declarado entre os documentos',
        apoio_identidade_do_documento: 'Documento de identidade × cadastro',
        apoio_endereco_do_comprovante: 'Comprovante de endereço × cadastro',
        apoio_destinatario_da_nota: 'Destinatário da nota fiscal × signatário',
        apoio_chave_de_acesso_da_nota: 'Autenticidade da nota fiscal pela chave de acesso',
        apoio_qr_da_cnh: 'Validação do QR code da CNH',
        apoio_nascimento: 'Data de nascimento × CCB',
        apoio_filiacao: 'Filiação entre RG e CNH',
        apoio_numero_do_rg: 'Número do RG × documento de identidade da CNH',
        apoio_registro_da_cnh: 'Número do documento × Doc. Identidade da CCB',
        apoio_validade_da_cnh: 'Validade do documento × data do ato',
        apoio_estado_civil: 'Estado civil da CCB × documento de origem',
        // E107.F2 (ADR-0087): o manifesto de evidências do banco e o carimbo do tempo sobre ele.
        manifesto_carimbo: 'Carimbo do tempo sobre o manifesto de evidências do banco',
        manifesto_hash_da_peca: 'Hash do documento no manifesto de evidências',
        manifesto_dados: 'Proposta, CPF e nome do manifesto × protocolo',
      },
    },

    // E78.F3 — o protocolo do caso resumido em quatro colunas, para que o
    // formulário de oito seções só apareça quando o escritório for editá-lo.
    resumoProtocolo: {
      plataformaAusente: 'Plataforma não informada',
      editar: 'Editar protocolo',
      fecharEdicao: 'Fechar sem salvar',
      semProtocolo:
        'O protocolo desta contratação ainda não foi transcrito. Preencha e salve para liberar a verificação dos documentos.',
      colunaSignatario: 'Signatário',
      colunaAssinatura: 'Assinatura',
      colunaEnvelope: 'Envelope',
      colunaTrilha: 'Trilha de aceite',
      colunaRede: 'Rede e localização',
      cpf: 'CPF {valor}',
      biometriaComSessao: 'Biometria registrada · sessão {valor}',
      biometriaSemSessao: 'Biometria registrada, sem identificador de sessão',
      semBiometria: 'Sem biometria registrada',
      envelope: 'Envelope {valor}',
      assinaturaId: 'Identificador da assinatura {valor}',
      eventos: '{n} eventos registrados',
      eventoUnico: '1 evento registrado',
      primeiroEvento: 'Primeiro: {valor}',
      ultimoEvento: 'Último: {valor}',
      registroDaAssinatura: 'Assinatura registrada em {valor}',
      registroFusoPresumido: '(sinal do fuso presumido)',
      enderecos: '{n} endereços · {cliente} do cliente, {servidor} do servidor',
      enderecoUnico: '1 endereço · {cliente} do cliente, {servidor} do servidor',
      enderecosSemPapel: '{n} sem papel declarado',
      coordenada: 'Coordenada {lat}, {lon}',
      precisao: 'Fonte {fonte} · raio de precisão de {valor} m',
      ausenciasTitulo: 'Não informado no protocolo',
      ausenciasVazio: 'Nada: todos os campos do protocolo foram informados.',
      ausencias: {
        plataforma: 'plataforma de assinatura',
        codigoVerificacao: 'código de conferência do protocolo',
        proposta: 'número da proposta',
        nome: 'nome do signatário',
        cpf: 'CPF do signatário',
        contato: 'e-mail e telefone do signatário',
        tipoAssinatura: 'tipo de assinatura',
        envelope: 'identificador do envelope',
        assinaturaId: 'identificador da assinatura',
        eventos: 'eventos da trilha de aceite',
        assinaturaRegistradaEm: 'registro da assinatura pela plataforma',
        ips: 'endereços de rede',
        coordenada: 'coordenada do ato',
        precisao: 'fonte e raio de precisão da coordenada',
        dispositivo: 'identificação do dispositivo',
      },
    },

    // E98.F7.T02 — o envelope por papel e a biometria do provedor no resumo do protocolo.
    resumoEnvelope: {
      papel: {
        cliente: 'Cliente: {nome}',
        outro_signatario: 'Outro signatário: {nome}',
      },
      semNome: 'nome não informado',
      assinouEm: 'assinou em {quando}',
      ip: 'endereço de rede {valor}',
      documentos: '{n} documentos declarados no envelope',
      paginas: '{n} páginas declaradas',
      fusoPresumido: 'Horários sem fuso lidos como {valor} (presumido)',
      fusoDeclarado: 'Fuso declarado: {valor}',
      provedor: 'Provedor da biometria: {valor}',
      provaDeVidaDeclarada: 'Prova de vida declarada pelo provedor',
      provaDeVidaNegada: 'Prova de vida declarada como não realizada',
      moduloDeColeta: 'Módulo de coleta: {valor}',
      coletaPorReaproveitamento: 'Coleta por reaproveitamento (amostra não capturada no ato)',
      documentoValidadoDeclarado: 'Documento declarado como validado pelo provedor',
    },
    // E98.F7.T02 — o selo da plataforma de envelope no painel de integridade.
    selo: {
      titulo: 'Selo da plataforma de envelope',
      integro: 'Íntegro',
      naoIntegro: 'Não íntegro',
      exportadoEm: 'Aplicado na exportação em {quando}',
      naoEAssinatura:
        'O selo comprova que o arquivo não mudou desde a exportação pela plataforma. Não é assinatura do signatário, e a data dele é a da exportação, não a do ato.',
      leituraTolerante:
        'A estrutura do arquivo foge do padrão e a assinatura foi lida em modo tolerante; a leitura está declarada no item de presença.',
    },

    // E77.F1 — importar o protocolo em vez de digitá-lo.
    importarProtocolo: {
      titulo: 'Importar do protocolo da plataforma',
      // E84.F1 (ADR-0078 §2.2 emendada): a leitura preenche o que está vazio;
      // o que o perito já informou não é alterado.
      intro:
        'Envie o comprovante em PDF: o protocolo e o código de cada documento reconhecido pelo hash ficam preenchidos na hora. O que você já tiver informado à mão não é alterado.',
      escolherArquivo: 'Enviar protocolo em PDF',
      enviando: 'Lendo o protocolo…',
      arquivoAnexado: '{nome} · anexado ao caso',
      codigoDeConferencia: 'Código de conferência do arquivo: {valor}',
      sugestaoTitulo: '{n} campos preenchidos a partir do protocolo',
      sugestaoTituloUm: '1 campo preenchido a partir do protocolo',
      sugestaoAviso:
        'O que estava vazio foi preenchido a partir do documento; o que você já tinha informado ficou como estava. Confira e edite o que for preciso.',
      marcaSugerido: 'Sugerido',
      marcaLido: 'Lido do documento',
      marcaAssistida: 'Leitura assistida — confira com atenção',
      codigoDaPecaSugerido:
        'O protocolo traz o código de verificação {valor}. Aplique-o ao documento correspondente na tabela.',
      // E83.F1 (ADR-0078 §2.7): os códigos do protocolo casados com as peças
      // recebidas pelo código apurado — e o que ficou sem par, dos dois lados.
      codigosCasados: '{n} códigos do protocolo conferem com documentos recebidos.',
      codigoCasadoUm: '1 código do protocolo confere com um documento recebido.',
      // E84.F1: o que a leitura gravou nas peças — e o que preservou.
      codigosGravados: '{n} documentos receberam o código e o tipo agora.',
      codigoGravadoUm: '1 documento recebeu o código e o tipo agora.',
      codigosJaPreenchidos: '{n} documentos já tinham código informado e foram mantidos.',
      codigoJaPreenchidoUm: '1 documento já tinha código informado e foi mantido.',
      codigosSemPeca: 'Sem documento correspondente entre os recebidos: {rotulos}.',
      pecasSemCodigo: '{n} documentos recebidos não têm código no protocolo.',
      pecaSemCodigoUma: '1 documento recebido não tem código no protocolo.',
      restaTitulo: 'Continua por transcrever: {campos}',
      restaVazio: 'Todos os campos que sabemos ler foram preenchidos.',
      // A ação paga: o aviso é o que o perito lê ANTES de clicar, não uma dica.
      tentarLeituraAssistida: 'Tentar leitura assistida do que faltou',
      tentandoLeituraAssistida: 'Lendo o que faltou…',
      leituraAssistidaAviso:
        'A leitura assistida envia este protocolo a um serviço externo e consome consulta paga. Os campos já preenchidos não são alterados.',
      erros: {
        arquivo_nao_suportado: 'Envie o protocolo em PDF.',
        arquivo_vazio: 'O arquivo enviado está vazio.',
        arquivo_muito_grande: 'O arquivo é grande demais para ser lido aqui.',
        documento_sem_texto:
          'Este PDF é uma imagem digitalizada, sem texto que se possa ler. Transcreva o protocolo no formulário abaixo.',
        documento_ilegivel:
          'Não foi possível abrir este arquivo. Confira se é o protocolo da plataforma e tente de novo.',
        protocolo_nao_importado: 'Envie o protocolo antes de pedir a leitura do que faltou.',
        assistida_indisponivel:
          'A leitura assistida não está disponível agora. Os campos abaixo vieram do próprio documento; complete o resto à mão.',
        provider_auth:
          'A chave de acesso cadastrada foi recusada. Revise-a em Configurações e tente de novo.',
        provider_credit:
          'A conta da chave cadastrada está sem saldo. Complete os campos à mão ou regularize o saldo.',
      },
    },

    // E80.F1 (ADR-0079) — as fotos do rosto do signatário, em dois grupos.
    fotosDoSignatario: {
      titulo: 'Fotos do signatário',
      // E91.F1 (GUS-51 RF06): a foto é identificada pelo uso, não pelo tipo
      // do contrato; a explicação de retenção saiu do preâmbulo.
      intro: 'Escolha, em cada grupo, a foto que entra na comparação. As demais ficam guardadas.',
      grupos: {
        documento_identidade: {
          titulo: 'Fotografia do documento',
          descricao: 'A fotografia impressa no RG, na CNH ou no passaporte.',
          vazio: 'Nenhuma foto anexada. Envie a fotografia do documento de identidade.',
        },
        ccb: {
          titulo: 'Selfie/FotoDocContrato da formalização',
          descricao:
            'O rosto capturado na formalização: a selfie da sessão ou a fotografia da ficha.',
          vazio: 'Nenhuma foto anexada. Envie o rosto capturado na formalização.',
        },
      },
      anexar: 'Anexar foto',
      anexando: 'Enviando…',
      formatosAceitos: 'PNG, JPG ou JFIF, até 10 MB.',
      escolhida: 'Escolhida para a comparação',
      // E122.F2 (ADR-0079 E.23): a foto que entrou sem clique diz isso na galeria.
      confirmadaAutomaticamente: 'Confirmada automaticamente pelo sistema',
      escolher: 'Usar esta foto',
      escolhendo: 'Trocando…',
      semEscolhida: 'Escolha qual foto entra na comparação.',
      recortar: 'Recortar',
      recortada: 'Recortada nesta tela',
      remover: 'Remover',
      removendo: 'Removendo…',
      codigoDeConferencia: 'Código de conferência: {valor}',
      sigilo:
        'Imagem de rosto é dado pessoal sensível: fica guardada em sigilo, vinculada a este caso, e sai junto com ele.',
      erroCarregar: 'Não foi possível carregar as fotos deste caso. Recarregue a página.',
      erros: {
        arquivo_nao_suportado: 'Envie a foto em PNG, JPG ou JFIF.',
        arquivo_vazio: 'O arquivo enviado está vazio.',
        arquivo_muito_grande: 'A foto é grande demais. Envie um arquivo de até 10 MB.',
        arquivo_nao_e_imagem:
          'Este arquivo não é uma fotografia — não foi possível abri-lo como imagem. Envie o PNG, JPG ou JFIF da foto.',
        foto_nao_encontrada: 'Esta foto não está mais no caso. Recarregue a página.',
        generico: 'Não foi possível concluir. Tente de novo.',
      },
      recorte: {
        titulo: 'Recortar {nome}',
        intro:
          'Arraste sobre a imagem para marcar o rosto. O arquivo original continua guardado — o recorte é só o enquadramento.',
        palcoLabel: 'Área de recorte: arraste sobre a imagem para marcar o rosto',
        girar: 'Girar 90°',
        orientacao: 'Girada em {deg}°',
        semCaixa: 'Arraste sobre a imagem para marcar a área do rosto.',
        aplicar: 'Aplicar recorte',
        aplicando: 'Aplicando…',
        desfazer: 'Usar a foto inteira',
        cancelar: 'Cancelar',
        carregando: 'Carregando a imagem…',
        indisponivel: 'Não foi possível abrir esta imagem para recortar.',
      },
    },
    // E80.F2 (ADR-0079 §2.5) — o parecer da conferência facial, subordinado:
    // vocabulário próprio, sem percentual, e a régua ética impressa na tela.
    // E123.F3 (GUS-128, ADR-0079 E.24): a etapa fotográfica saiu da esteira. O sistema escolhe as
    // fotos e faz a conferência facial; a pré-análise mostra o resultado e oferece a troca.
    fotografias: {
      titulo: 'Fotografias e conferência facial',
      carregando: 'Carregando as fotografias…',
      erroCarregar: 'Não foi possível carregar as fotografias deste caso. Recarregue a página.',
      organizando: 'Organizando as imagens do material…',
      conferindo: 'Conferência facial em andamento…',
      grupos: {
        documento_identidade: 'Fotografia do documento de identidade',
        ccb: 'Fotografia do titular (formalização)',
      },
      semFotoNoGrupo: 'Nenhuma fotografia escolhida.',
      origem: 'Origem',
      origemComPagina: (documento: string, pagina: number): string =>
        `${documento}, página ${pagina}`,
      escolhidaPeloSistema: 'Escolhida automaticamente pelo sistema',
      escolhidaPeloPerito: 'Escolhida pelo perito',
      conferenciaAutomatica: 'Conferência feita automaticamente pelo sistema.',
      trocar: 'Trocar fotos',
      fecharTroca: 'Fechar a troca de fotos',
      trocaTitulo: 'Trocar fotos',
      trocaIntro:
        'Escolha, entre as imagens do material, a fotografia do documento de identidade e a fotografia do titular. Imagens repetidas não aparecem. A conferência facial é refeita ao confirmar.',
      trocada:
        'Fotografia trocada. A conferência facial está sendo refeita; se a imagem for de documento, os dados lidos aparecem em instantes para você confirmar.',
      // E191.F1 (GT-2026-0030): a troca em curso é dita no alto da seção, não só no botão.
      trocando: (grupo: string): string => `Trocando a ${grupo.toLowerCase()}…`,
      // GUS-57 (alteração 1, RN01): há imagens candidatas, mas o par não foi formado.
      selecione: {
        titulo: 'Análise não realizada: selecione as fotos',
        texto:
          'O sistema não escolheu as duas fotografias com segurança. Use "Trocar fotos" para escolher a fotografia do documento e a fotografia do titular.',
      },
      // GUS-57 (alteração 4): sem fotografias no material — aviso não bloqueante.
      semFotos: {
        titulo: 'Comparação de imagens não realizada: não recebemos fotografias suficientes',
        texto:
          'Para a conferência facial, envie a fotografia do documento de identidade (RG, CNH ou passaporte) e a fotografia do titular capturada na formalização, em Documentos do caso. A análise segue com os documentos disponíveis, e o perito registra o alcance e as limitações no laudo.',
      },
      indisponivel:
        'A conferência facial não pôde ser feita agora. Ela será tentada de novo automaticamente, ou você pode tentar agora.',
      tentarAgora: 'Tentar agora',
      tentando: 'Conferindo…',
      // E141.F2 (GUS-147, ADR-0079 E.26): o perito ajusta o recorte e a orientação da foto escolhida
      // sobre o original; a leitura automática que não achou a fotografia fica apontada no cartão.
      ajustarRecorte: 'Ajustar recorte',
      ajusteTitulo: (grupo: string): string => `Ajustar recorte e orientação: ${grupo}`,
      ajusteIntro:
        'Marque a fotografia sobre a imagem original e gire até o rosto ficar em pé. O arquivo original continua guardado; a conferência facial é refeita ao salvar.',
      fecharAjuste: 'Fechar o ajuste',
      ajustado: 'Recorte salvo. A conferência facial está sendo refeita.',
      erroAjuste: 'Não foi possível salvar o recorte. Tente novamente.',
      ajusteBloqueado: 'O exame já foi concluído: o recorte não muda mais.',
      recortePendente: {
        titulo: 'Fotografia não localizada no documento',
        tituloFalha: 'Leitura automática do recorte não concluída',
        texto:
          'A leitura automática {motivo}; a imagem entrou inteira na conferência facial. Confira e ajuste o recorte.',
      },
      // E162.F1.T08 (ADR-0111 §2.4, QA-25): a fotografia escolhida saiu de documento sem vínculo
      // demonstrado com o caso — a conferência fica registrada e não corrobora a autoria.
      semVinculo: {
        titulo: 'Fotografia de documento sem vínculo demonstrado com este caso',
        texto:
          'A imagem saiu de um documento que {motivo}. A conferência facial foi feita e fica registrada no laudo, marcada, mas não corrobora a autoria do ato. Confira a origem e, se for o caso, troque a foto.',
        motivo: {
          outro_contrato: 'traz a chave de outro contrato',
          outra_pessoa: 'identifica outra pessoa',
          nenhum: 'não identifica a pessoa nem o contrato do caso',
        },
      },
      motivoDaPendencia: {
        sem_fotografia: 'não encontrou a fotografia no documento',
        sem_caixa: 'não delimitou a fotografia',
        caixa_fora_da_imagem: 'delimitou uma região fora da imagem',
        caixa_pequena: 'delimitou uma região pequena demais para a comparação',
        caixa_quase_inteira: 'delimitou quase a imagem inteira',
        proporcao_implausivel: 'delimitou uma região de proporção incompatível com uma fotografia',
        falha_da_leitura: 'não foi concluída',
      },
    },
    conferenciaFacial: {
      titulo: 'Conferência facial',
      // E90.F4: a saída é o painel de referência, com a conclusão em degrau.
      intro:
        'Compara a foto escolhida do documento de identidade com a escolhida na formalização e devolve o painel de comparação, com a conclusão em degrau.',
      reguaEtica:
        'Conferência de corroboração sobre imagens de qualidade não controlada. Não é identificação biométrica e não substitui exame de reconhecimento facial.',
      conferir: 'Conferir as duas fotos',
      conferindo: 'Conferindo…',
      // E184.F4 (GUS-145 item 5): refazer sobre o par eleito, mesmo com documento concluído; o
      // exame e o relatório de riscos se refazem sem clique e a conferência final pede de novo.
      refazer: 'Refazer análise morfológica',
      refeita:
        'Análise morfológica refeita. O exame e o relatório de riscos estão sendo refeitos com o resultado novo; as edições salvas seguem, e a conferência final, se havia, precisa ser feita de novo. O resultado anterior fica no histórico do caso.',
      // E184.F4.C01: a falha ao refazer, na seção de fotografias da pré-análise.
      erroRefazer:
        'Não foi possível refazer a análise morfológica agora. Tente de novo em instantes.',
      // E200.F2 (GUS-220, ADR-0143 §3): o servidor já tinha a análise em curso; o clique não
      // disparou outra, e a seção espera por ela.
      emAndamento:
        'A análise morfológica deste caso já está em andamento. Esta área se atualiza sozinha quando ela terminar.',
      // E206.F2 (GUS-296 item 2): o caso aguardando arquivos não roda a comparação, nem pelo botão.
      aguardandoArquivos:
        'A comparação facial espera os arquivos que faltam ao caso: {faltam}. Ela roda quando eles chegarem.',
      aguardandoRecusa:
        'A comparação facial não rodou: o caso ainda espera arquivos. Ela roda quando eles chegarem.',
      pronta: 'As duas fotos já foram escolhidas. A conferência pode ser feita.',
      // E91.F1 (GUS-51 CA01): sem par não é "não se aplica" — é análise não
      // realizada, e a tela diz o que falta para realizá-la.
      semParTexto: 'Adicione uma foto de cada origem para que a conferência tenha o que comparar.',
      leituras: {
        elementos_convergentes: 'Elementos convergentes',
        elementos_divergentes: 'Elementos divergentes',
        nao_foi_possivel_conferir: 'Não foi possível conferir',
        nao_se_aplica: 'Análise não realizada — faltam fotos',
        // E216.F4.C05 (GUS-317, 0334): a foto comparada saiu do caso e não há outro par apto.
        nao_demonstrada: 'Não demonstrada — a foto comparada saiu do caso e não há outro par',
      },
      // E90.F4: convergências e divergências deixaram a tela — o painel é a
      // forma delas. Ficam as ressalvas, abaixo da tabela.
      secoes: {
        ressalvas: 'Ressalvas de qualidade do material',
      },
      vazio: {
        ressalvas: 'Nenhuma ressalva foi registrada.',
      },
      semAfirmacao:
        'As três leituras independentes não coincidiram na avaliação global, e por isso nada foi afirmado sobre este par; no painel, o elemento em que elas não coincidiram sai como não validado. As ressalvas abaixo descrevem o que limitou a comparação.',
      // E90.F4: o painel de referência do owner — uma tabela só, com as fotos
      // no cabeçalho e a CONCLUSÃO no rodapé. A conclusão é o degrau gravado
      // pelo servidor; o percentual é rótulo FIXO do degrau (emenda E.9).
      painel: {
        titulo: 'Painel de comparação facial',
        colunaElemento: 'Fotos e elementos examinados',
        colunaSelfie: 'Selfie/FotoDocContrato da formalização',
        colunaIdentidade: 'Fotografia do documento',
        colunaGrau: 'Grau de compatibilidade',
        conclusao: 'Conclusão',
        // Round 2 (F-E90.F4-01): o degrau descreve o conjunto; o número é a
        // posição fixa do degrau na escala — sem "chance", sem probabilidade.
        // Round 3 (F-E90.F4-02): a frase nomeia SÓ a avaliação global — nunca
        // atribui convergência ou divergência aos elementos do painel.
        // E106.F3 (emenda E.11, GT-0054 I-17): escala simétrica, sem percentual. Os quatro
        // degraus da escala anterior só chegam em parecer gravado antes dela.
        // E115.F1 (revisor do escritório, 27/09): a escala de suporte de sete níveis, nomeada
        // (operacional do sistema, sobre o guia OSAC — E.18), com o nível e o significado — o
        // mesmo texto de `relatorio_eletronico_texto`.
        conclusaoDoDegrau: {
          mesma_origem_forte:
            'suporte forte à hipótese de mesma fonte, nível +3 da escala de sete níveis (+3 a -3): a avaliação global do par sustenta com força que as duas imagens têm a mesma fonte',
          mesma_origem_moderado:
            'suporte moderado à hipótese de mesma fonte, nível +2 da escala de sete níveis (+3 a -3): a avaliação global do par sustenta, com força moderada, que as duas imagens têm a mesma fonte',
          mesma_origem_limitado:
            'suporte limitado à hipótese de mesma fonte, nível +1 da escala de sete níveis (+3 a -3): a avaliação global do par tende à mesma fonte, com suporte fraco pela limitação do material',
          inconclusivo:
            'inconclusivo, nível 0 da escala de sete níveis (+3 a -3): a avaliação global do par não sustenta nem a mesma fonte nem fontes diferentes',
          origem_distinta_limitado:
            'suporte limitado à hipótese de fontes diferentes, nível -1 da escala de sete níveis (+3 a -3): a avaliação global do par tende a fontes diferentes, com suporte fraco',
          origem_distinta_moderado:
            'suporte moderado à hipótese de fontes diferentes, nível -2 da escala de sete níveis (+3 a -3): a avaliação global do par sustenta, com força moderada, que as duas imagens têm fontes diferentes',
          origem_distinta_forte:
            'suporte forte à hipótese de fontes diferentes, nível -3 da escala de sete níveis (+3 a -3): a avaliação global do par sustenta com força que as duas imagens têm fontes diferentes',
          nao_avaliavel:
            'Não avaliável, fora da escala de sete níveis: o material não sustenta uma avaliação global do par',
          alta: 'Compatibilidade facial alta (escala anterior, de quatro degraus) — avaliação global do par no degrau mais alto daquela escala',
          media_alta:
            'Compatibilidade facial média-alta (escala anterior, de quatro degraus) — avaliação global do par no segundo degrau daquela escala',
          media:
            'Compatibilidade facial média (escala anterior, de quatro degraus) — avaliação global do par no degrau intermediário daquela escala',
          baixa:
            'Compatibilidade facial baixa (escala anterior, de quatro degraus) — avaliação global do par no degrau mais baixo daquela escala',
        },
        // E117.F1 (pedido do owner, E.19): o resultado antes do nível, com os rótulos do veredito
        // (`veredito.ts`) em maiúsculas, como no documento emitido.
        // E116.F2 (decisão do owner, 27/09): uma linha de método, a mesma do documento emitido.
        metodo: 'Método: {partes}.',
        // E117.F1 (X-03, E.19): o que a comparação por elemento é, no início da linha de método.
        // E209.F2.T08 (GUS-296 item 13c): sem os "nove elementos" fixos; a contagem vem do painel,
        // como no exame (`CONFERENCIA_TRACOS_COMPARADOS`). Na tela a expressão é linha da tabela, por
        // isso sem o "fora da tabela" do documento.
        morfologiaInspirada:
          'análise morfológica inspirada na lista de componentes faciais do FISWG',
        tracosComparados: 'sobre {n} traços morfológicos comparados',
        expressaoRegistrada: ', além do registro da expressão facial, por ser estado transitório',
        // E115.F1.C01 (F-E115.F1-01): a escala é operacional do sistema, sobre o guia OSAC.
        escalaCurta:
          'escala operacional de sete níveis, de +3 a -3, construída sobre as cinco categorias de opinião do guia OSAC 2022-S-0001, cujas subdivisões (+2 e +1, -1 e -2) não têm estudo empírico de validação',
        escalaAnterior: 'escala anterior, de quatro degraus de compatibilidade',
        porMaioria:
          '{k} leituras independentes do par, consolidadas pela maioria (nível sustentado por {n} de {k})',
        porUnanimidade: '{k} leituras independentes do par, que coincidiram no nível',
        semMaioriaNoNivel:
          '{k} leituras independentes do par, sem maioria no nível: adotado o de menor força',
        semMaioriaGlobal:
          '{k} leituras independentes do par, sem maioria na avaliação global: nenhuma direção é afirmada',
        corForaDaLeitura:
          'cor de íris, de cabelo e de pele não é avaliada, porque a imagem de referência é reprodução impressa do documento de identidade e a cor nela é artefato de impressão e de captura; os olhos são lidos só pela morfologia',
        // F-E116.F2-01: o parecer gravado com cor não recebe a exclusão como fato.
        corRegistrada:
          'as leituras deste parecer registraram cor de íris, de cabelo ou de pele, que a análise não avalia porque a imagem de referência é reprodução impressa do documento de identidade e a cor nela é artefato de impressão e de captura; o grau dos elementos em que a cor aparece pode tê-la considerado, e o parecer pede nova conferência',
        // E117.F1 (X-02, E.19): o parecer gravado com colunas idênticas pede nova conferência.
        colunasIdenticas:
          'as leituras deste parecer registraram a mesma descrição nas duas imagens em {quantos}, e o parecer pede nova conferência',
        umElemento: '1 elemento',
        nElementos: '{n} elementos',
        // E117.F1 (X-05): a legenda dos graus em uma linha, sob a tabela — a do documento emitido.
        // E172.F14 (GUS-230 ajuste 14): com dois-pontos, sem o travessão.
        legendaDosGraus:
          'Graus: Alta: compatível nas duas imagens, com detalhe suficiente; Média-alta: compatível, com limitação do material; Média: o material não permite dizer se é compatível ou diferente; Baixa: difere entre as imagens; Não avaliável: o material não permite avaliar o elemento; Não validado: as leituras não coincidiram no elemento; (sem maioria): as leituras não formaram maioria, e ficou o grau de menor força.',
        conclusaoRessalva:
          'Ressalvada a limitação de imagens de qualidade não controlada e a ausência de exame biométrico automatizado.',
        degrauNaoRegistrado:
          'Este parecer foi emitido antes de a conclusão em degrau integrar o painel; o degrau de compatibilidade não foi registrado.',
        nota: 'O grau de cada linha descreve a compatibilidade observada naquele elemento. A conclusão é a leitura do conjunto e não é a soma, a média nem a contagem das linhas.',
        elementos: {
          formato_do_rosto: 'Formato do rosto',
          testa: 'Testa',
          sobrancelhas: 'Sobrancelhas',
          olhos_regiao_periocular: 'Olhos e região periocular',
          nariz: 'Nariz',
          labios_boca: 'Lábios e boca',
          queixo_mandibula: 'Queixo e mandíbula',
          proporcao_olhos_nariz_boca: 'Proporção entre olhos, nariz e boca',
          expressao_facial: 'Expressão facial',
          pele: 'Pele (textura)',
          cabelo: 'Cabelo (implantação e contorno)',
          bochechas: 'Bochechas e maçãs do rosto',
          orelhas: 'Orelhas',
          pescoco: 'Pescoço',
          pelos_faciais: 'Pelos faciais',
          linhas_faciais: 'Linhas faciais',
          cicatrizes: 'Cicatrizes',
          marcas_faciais: 'Marcas faciais',
          alteracoes: 'Alterações',
        },
        graus: {
          alta: 'Alta',
          media_alta: 'Média-alta',
          media: 'Média',
          baixa: 'Baixa',
          nao_avaliavel: 'Não avaliável',
          nao_validado: 'Não validado entre as leituras',
        },
        // E116.F2: sem a contagem por elemento — só a marca do elemento sem maioria.
        semMaioria: '(sem maioria)',
        semPainel:
          'Este parecer não traz o painel por elemento. As leituras não coincidiram entre si, ou ele foi emitido antes de o painel existir.',
        fotoIdentidade: 'Fotografia do documento de identidade',
        fotoFormalizacao: 'Foto colhida na formalização',
      },
      provenienciaTitulo: 'Fotos comparadas',
      // E205.F5.T01 (ADR-0147 §2.6): campos rotulados numa grade.
      proveniencia: {
        codigo: 'Código de conferência',
        conferidoEm: 'Conferido em',
      },
      parMudou:
        'A escolha de fotos mudou depois deste parecer. Ele continua sendo sobre as fotos listadas aqui; confira de novo para falar do par atual.',
      // E141.F2 (ADR-0079 E.26): o mesmo par, com outra caixa ou outro giro desde o parecer.
      recorteMudou:
        'O recorte ou a orientação de uma das fotos mudou depois deste parecer. Ele continua sendo sobre a região conferida na época; a conferência facial está sendo refeita sobre o recorte atual.',
      erros: {
        conferencia_sem_par: 'Escolha uma foto em cada grupo antes de pedir a conferência.',
        // E200.F2 (GUS-220, ADR-0143 §3): a conferência já roda; não há o que repetir.
        conferencia_em_andamento:
          'A conferência facial deste caso já está em andamento. Esta área se atualiza sozinha quando ela terminar.',
        foto_integridade:
          'Uma das fotos escolhidas não confere com o arquivo registrado no caso. Anexe-a de novo antes de conferir.',
        // E80.F3.T07 (F-E80.F2-08): a foto está íntegra; quem falhou foi a
        // leitura. Mandar reanexar aqui não resolveria a causa e sugeriria um
        // problema de integridade que não foi demonstrado.
        foto_indisponivel:
          'Não foi possível ler uma das fotos escolhidas agora. O arquivo continua registrado no caso; tente conferir de novo em alguns instantes.',
        conferencia_indisponivel:
          'A conferência não está disponível agora. Tente de novo em alguns instantes.',
        // E82.F5: a resposta pode ter chegado depois que o navegador desistiu;
        // a tela relê o estado antes de mostrar isto.
        network:
          'A resposta demorou mais que o esperado. O que está abaixo é o último estado gravado; confira antes de pedir de novo, para não repetir a conferência.',
        provider_auth:
          'A chave de acesso cadastrada foi recusada. Revise-a em Configurações e tente de novo.',
        provider_credit:
          'A conta da chave cadastrada está sem saldo. Regularize o saldo e tente de novo.',
        sem_chave: 'Cadastre a chave de acesso em Configurações para usar a conferência.',
        carregar: 'Não foi possível carregar a conferência deste caso. Recarregue a página.',
        generico: 'Não foi possível concluir. Tente de novo.',
      },
    },

    // E78.F3 — a tabela que substitui os cards empilhados por peça.
    // E101.F5: a leitura por imagem do documento sem camada de texto, na tabela e no aviso.
    leituraPorImagem: {
      estado: {
        pendente: 'Aguardando a leitura da imagem',
        lendo: 'Lendo a imagem',
        concluida: 'Lido da imagem',
        falhou: 'Imagem não lida',
      },
      aria: 'Leitura da imagem do documento: {estado}',
      dicaConcluida:
        'Os valores lidos da imagem só entram no exame depois que você os confere e confirma.',
      motivo: {
        acima_do_teto: 'o arquivo passa do limite de páginas',
        arquivo_ilegivel: 'o arquivo não abre',
        nada_lido: 'nenhum texto saiu das páginas',
        cadeia_interrompida: 'a imagem foi lida, mas a organização dos documentos não terminou',
      },
      sugestaoAplicada:
        'Campos sugeridos pela leitura da imagem dos comprovantes. Nada foi gravado: confira cada campo com o documento e salve para confirmar.',
      sugestaoLendo:
        'A imagem dos comprovantes ainda está sendo lida. A sugestão do protocolo aparece aqui quando a leitura terminar.',
      emAndamentoTitulo: 'Lendo a imagem dos documentos enviados',
      emAndamento:
        'A pré-análise continua sozinha quando a leitura terminar. Documentos só em imagem levam alguns minutos.',
    },
    tabelaDePecas: {
      titulo: 'Documentos recebidos',
      // E91.F3 (RF06): a explicação de organização interna saiu; fica a ação.
      colunaPeca: 'Documento',
      colunaDeclarado: 'Código declarado no protocolo',
      // E91.F2 (GUS-51 RF04): a pergunta do banco é uma só — "o hash confere?"
      // — e a coluna responde com um estado por documento. O hash completo
      // mora no detalhe; o grau mora no quadro; "Situação" passa a dizer o que
      // é: o processamento, e não o resultado.
      colunaHash: 'Hash com o protocolo',
      colunaAlertas: 'Alertas',
      colunaSituacao: 'Processamento',
      hash: {
        confere: 'Confere',
        divergente: 'Divergente',
        sem_referencia: 'Sem referência',
        // E97.F4.T08: a integridade declarada na assinatura do arquivo original,
        // que este arquivo não permite conferir (ADR-0082 §2.4).
        nao_conferivel: 'Não conferível',
        nao_verificado: 'Ainda não verificado',
        em_processamento: 'Em processamento',
      },
      hashAria: '{peca}: hash com o protocolo — {estado}',
      // O resumo do confronto, por estado. Só as partes com contagem aparecem.
      resumo: {
        documentos: '{n} documentos',
        documentosUm: '1 documento',
        confere: '{n} hashes conferem',
        confereUm: '1 hash confere',
        divergente: '{n} divergentes',
        divergenteUm: '1 divergente',
        sem_referencia: '{n} sem referência',
        sem_referenciaUm: '1 sem referência',
        nao_conferivel: '{n} não conferíveis',
        nao_conferivelUm: '1 não conferível',
        nao_verificado: '{n} ainda não verificados',
        nao_verificadoUm: '1 ainda não verificado',
        em_processamento: '{n} em processamento',
        em_processamentoUm: '1 em processamento',
      },
      salvarCodigo: 'Salvar',
      // E84.F7 (GUS-45 RF03): volta ao valor gravado, e com ele ao estado de
      // verificação que corresponde a esse valor.
      descartarCodigo: 'Descartar',
      // RF02: a linha continua mostrando o confronto e o grau apurados sobre o
      // código ANTERIOR. Dizer isso é o que impede a leitura errada.
      resultadoDesatualizado: 'Resultado anterior, alteração não verificada',
      resultadoDesatualizadoAria:
        '{peca}: o resultado exibido é anterior à alteração e ainda não foi verificado',
      // E84.F9 (GUS-44 RF05/CA05): o exame foi calculado com um conjunto de
      // regras anterior ao vigente. Nada é recalculado em silêncio — a linha
      // avisa, e o perito decide se reverifica.
      reguaAnterior: 'Verificado com a régua anterior',
      reguaAnteriorAria:
        '{peca}: verificado com a régua anterior ({versao}); a vigente é {corrente}. Verifique de novo para reavaliar com a régua atual.',
      // E84.F1: o tipo da peça, deduzido do rótulo do hash no comprovante.
      // `outro` não tem rótulo de propósito: o código foi gravado, o tipo
      // ficou por dizer, e a linha mostra só o nome do arquivo.
      tipoDaPeca: {
        ccb: 'CCB',
        cet: 'CET',
        termo_inss: 'Termo INSS',
        cadastro: 'Cadastro',
        termo_ciencia: 'Termo de ciência',
        // E98.F3/F5: a proposta contida no envelope do kit de veículos.
        proposta_de_seguro: 'Proposta de adesão do seguro',
        // E90.F6: RG e CNH reconhecidos pelo cabeçalho.
        documento_identidade: 'Documento de identidade',
        // E98.F5: os documentos de apoio, escolhidos pelo perito.
        cnh: 'CNH',
        // E116.F1: o passaporte e a identidade de estrangeiro (CRNM/RNE).
        passaporte: 'Passaporte',
        identidade_de_estrangeiro: 'Identidade de estrangeiro',
        cnh_verso: 'Verso da CNH',
        nota_fiscal: 'Nota fiscal',
        extrato_bancario: 'Extrato bancário',
        fatura_de_cartao: 'Fatura de cartão',
        // E101.F2: o dossiê do segundo banco de veículos.
        termo_de_servico: 'Termo de contratação do serviço',
        crlv: 'CRLV',
        foto_do_veiculo: 'Fotografia do veículo',
        // E106.F3 (GT-0054 I-08): o laudo de formalização do arquivo único, peça com letra própria.
        laudo_de_formalizacao: 'Laudo de formalização',
        // E128.F1: os formulários do arquivo único do cartão consignado.
        termo_de_adesao: 'Termo de adesão ao cartão',
        termo_de_consentimento: 'Termo de consentimento',
        termo_de_desbloqueio: 'Termo de desbloqueio do benefício',
      },
      // E90.F6 (GUS-14): o perito nomeia o documento que o catálogo não
      // identificou; o arquivo recebido fica em legenda, e o nome vai ao exame.
      arquivoRecebido: 'Arquivo: {arquivo}',
      renomear: 'Renomear',
      renomearAria: 'Renomear o documento {peca}',
      nomeDoDocumento: 'Nome do documento',
      salvarNome: 'Salvar nome',
      cancelarNome: 'Cancelar',
      nomeInvalido: 'Informe um nome com até 120 caracteres.',
      tipoDaPecaAria: 'Tipo do documento: {tipo}',
      // E86.F1 (GUS-43 RF03): o kit consignado da instituição exige
      // documentos que nenhuma peça enviada declarou ser. Avisa, não bloqueia.
      kitIncompletoTitulo: 'Faltam documentos obrigatórios no conjunto enviado',
      // E91.F2 (GUS-51 RF08): a pendência aponta para a ação que EXISTE. A
      // tabela não tem controle de tipo, então o texto não manda confirmar nada
      // nela — a saída é adicionar o que falta.
      kitIncompletoCorpo:
        'O conjunto de documentos desta instituição exige {faltantes}. Nenhum documento enviado foi identificado como esse tipo.',
      kitIncompletoAcao: 'Adicionar documentos',
      abrirQuadro: 'Abrir o quadro do documento {peca}',
      verificarPecas: 'Verificar os {n} documentos',
      verificarUmaPeca: 'Verificar o documento',
    },

    // E84.F1 — documentos que chegam depois do cadastro entram por aqui, pelo
    // mesmo caminho do envio inicial.
    adicionarDocumentos: {
      titulo: 'Adicionar documentos',
      // E91.F3 (RF06): sem o parágrafo sobre envio inicial e comprovante que
      // "casou" — o formato e o limite ficam na área de envio.
      dropzoneTitulo: 'Arraste arquivos aqui',
      dropzoneHint:
        'ou clique para selecionar · PDF, DOCX, JPG, PNG, ZIP, JSON, TST e registros (XLSX, CSV, TXT, LOG) · até 50 MB cada',
      inputLabel: 'Adicionar documentos ao caso',
      enviando: 'Enviando {nome}…',
      enviado: '{nome} adicionado ao caso.',
      comprovanteReconhecido: '{nome} reconhecido como comprovante de formalização.',
      concluido:
        'Há documento concluído neste caso. Reabra a conclusão antes de adicionar documentos.',
      erroGenerico: 'Não foi possível adicionar {nome}. Tente de novo.',
      // E97.F4.T03: o arquivo que traz todos os documentos num PDF só.
      arquivoSeparado: '{nome} separado em {n} documentos.',
      arquivoNaoSeparado: 'Não foi possível separar os documentos de {nome}: {motivos}.',
      // E107.F1 (ADR-0087): o pacote ZIP do banco e a evidência que vem nele.
      pacoteRecebido: '{nome}: {n} arquivos adicionados ao caso.',
      pacoteRecebidoUm: '{nome}: 1 arquivo adicionado ao caso.',
      // E133.F2 (ADR-0089): o que o exame não lê fica guardado e marcado, em vez de ficar de fora.
      pacoteNaoExaminados: 'Guardados sem exame: {lista}.',
      naoExaminado: '{nome} recebido e guardado, sem exame: {motivo}.',
      // E111.F1 (GUS-122): os mesmos bytes de um documento do caso não entram de novo. E216.F7
      // (GUS-317 item 9): a linha diz "já recebido", e a tentativa fica no recibo.
      pacoteCopias: 'Já recebidos, não duplicados: {lista}.',
      copiaIdentica:
        'Já recebido: {nome} é idêntico a um arquivo do caso e não foi duplicado. A tentativa fica no recibo.',
      evidenciaRecebida: '{nome} guardado como evidência do banco.',
      motivoNaoExaminado: {
        formato_fora_do_exame: 'conteúdo que não é PDF, imagem, DOCX nem evidência do banco',
        profundidade_excedida: 'pacote dentro de pacote além do segundo nível',
        arquivo_vazio: 'arquivo vazio',
        acima_do_limite: 'acima do limite do arquivo de evidência',
        pacote_ilegivel: 'pacote que não pôde ser aberto',
        pacote_cifrado: 'pacote protegido por senha',
        pacote_acima_do_limite: 'pacote acima de 100 arquivos ou 50 MB descompactados',
        pacote_vazio: 'pacote sem arquivos',
      },
    },

    // E97.F4.T02 — o arquivo único recebido e o que a separação apurou dele.
    arquivoUnico: {
      conferidoTitulo: 'Arquivo recebido com vários documentos',
      conferidoCorpo:
        '{nome}, com {paginas} páginas, foi separado em {n} documentos, cada um com as páginas de onde saiu:',
      reprovadoTitulo: 'Os documentos deste arquivo não foram separados',
      reprovadoCorpo:
        '{nome} traz vários documentos num arquivo só, e a separação não fechou. Nenhum documento foi criado a partir dele e o exame não é gerado enquanto isso não for resolvido. Envie o arquivo completo ou os documentos em arquivos separados.',
      motivosTitulo: 'O que impediu a separação:',
      pagina: 'página {paginas}',
      paginas: 'páginas {paginas}',
      tipo: {
        ccb: 'CCB',
        termo_inss: 'Termo INSS',
        comprovante: 'Comprovante de formalização',
        laudo: 'Laudo de formalização',
        fotografia: 'Fotografia',
        cadastro: 'Ficha cadastral',
        cet: 'Orçamento CET',
        proposta_de_seguro: 'Proposta de adesão do seguro',
        termo_de_servico: 'Termo de contratação do serviço',
        cnh: 'CNH',
        crlv: 'CRLV',
        termo_de_adesao: 'Termo de adesão ao cartão',
        termo_de_consentimento: 'Termo de consentimento',
        termo_de_desbloqueio: 'Termo de desbloqueio do benefício',
      },
      acao: 'Adicionar documentos',
    },
  },
} as const;

export type I18nKey = typeof ptBR;
